import{jsx as e,jsxs as t,Fragment as i}from"react/jsx-runtime";import n,{useState as a,useDebugValue as r,useEffect as o,useRef as l,createElement as d,forwardRef as s,useMemo as c}from"react";import{Helmet as u}from"react-helmet";import{toast as p,ToastContainer as h}from"react-toastify";import m,{createGlobalStyle as g,ThemeProvider as f,css as v,keyframes as b}from"styled-components";import{createContext as y,useContextSelector as _}from"use-context-selector";import{v4 as x}from"uuid";import S from"axios";import{format as w,differenceInYears as E,isSameDay as k,isEqual as T}from"date-fns";import{useFormik as I}from"formik";import*as C from"yup";import P,{registerLocale as N}from"react-datepicker";const M=y({});function D({children:t}){const[i,n]=a();return e(M.Provider,{value:{selectedService:i,setSeletedService:n,clearService:()=>{n(void 0)}},children:t})}const O={SERVICE_LIST:{id:1,title:"Escolha o produto",nextPage:""},PATIENT_FORM:{id:2,title:"Identificação do paciente",nextPage:"Método de compra"},CONFIGURATOR:{id:3,title:"Agendamento",nextPage:""},PAYMENT_VIEW:{id:4,title:"Método de compra",nextPage:"Atendimento"},SERVICE_TYPE_PAGE:{id:5,title:"Atendimento",nextPage:"Data e horário"},SERVICE_UNIT:{id:6,title:"Data e horário",nextPage:"Confirmação"},APPOINTMENT_CONFIRMATION:{id:7,title:"Confirmação",nextPage:"Conclusão"},CONCLUSION:{id:8,title:"Conclusão",nextPage:""},CONSULTAPPOINTMENT:{id:9,title:"Consultar agendamento",nextPage:""},DETAILS_APPOINTMENT:{id:10,title:"Detalhes Agendamento",nextPage:""},RESOURCE_DETAILS:{id:11,title:"",nextPage:""},MEDICAL_APPOINTMENT_TYPE:{id:13,title:"Tipo de Consulta",nextPage:"identificação"},SPECIALIST_DETAILS:{id:14,title:"Detalhes do médico",nextPage:""},UNIT_AUXILIARY_INFO:{id:15,title:"",nextPage:""},SPECIALIST_LIST:{id:16,title:"Escolha seu médico",nextPage:""}},R=e=>{const t=Object.entries(O).find((t=>{if(t[1].id===e)return t}));return t?t[1]:null},A=y({});function L({children:t}){const[i,n]=a(-1),[r,o]=a(0),[l,d]=a([]),[s,c]=a(1),[u,p]=a({}),h=()=>{s<6&&c(s+1)},m=()=>{s>0&&c(s-1)};return e(A.Provider,{value:{route:i,goTo:(e,t)=>{p(t||{}),n(e),(e=>{l[l.length-1]!==e&&d([...l,e])})(e),i===O.SERVICE_UNIT.id&&O.APPOINTMENT_CONFIRMATION.id,h()},goBack:()=>{const e=l[l.length-2];if(e||0===e){const t=l.filter(((e,t)=>t<l.length-1));d([...t]),n(e),(i!==O.PAYMENT_VIEW.id&&i!==O.SERVICE_TYPE_PAGE.id&&i!==O.SERVICE_UNIT.id&&e!==O.SERVICE_UNIT.id||e===O.PATIENT_FORM.id)&&m(),i===O.APPOINTMENT_CONFIRMATION.id&&e===O.SERVICE_UNIT.id&&m()}},currentStep:s,totalSteps:6,resetRoutes:()=>{n(-1),d([]),c(1)},incrementStep:h,resetSteps:()=>{c(1)},decreaseStep:m,primaryRoute:r,primaryRouteNavigate:e=>{o(e)},state:u,setState:p},children:t})}const U="after_patient_identification",$="after_choosing_service_type",F="after_product_selection",V="FIND_ANOTHER_DOCTOR",z="CHANGE_PRODUCT",H="TO_SERVICE_TYPE",B="CLOSE_MODAL",G="CLOSE",j="OPEN_MODAL_CONDITION",q="OPEN_WHATSAPP",W="FIND_SLOTS_BY_UNIT_SPECIALIST",Y="FIND_SLOTS_WITHOUT_RESOURCEID",X="MAKE_A_CALL",K="professional_without_schedule_available",Q="is_first_appointment",Z="always",J="diu_professional_without_schedule_available",ee="unavailable_slots",te="PARTICULAR",ie="B2B",ne="HELTH_INSURANCE";var ae;!function(e){e.APPOINTMENT="APPOINTMENT",e.CONSULTATION="CONSULTATION",e.EXAM="EXAM",e.IMMUNIZATION="IMMUNIZATION"}(ae||(ae={}));const re=e=>{throw new Error(`${e}`)};var oe;!function(e){e[e.PARTICULAR=1]="PARTICULAR",e[e.B2B=2]="B2B",e[e.HEALTH_INSURANCE=3]="HEALTH_INSURANCE"}(oe||(oe={}));const le="PRESENTIAL",de="EINSTEIN_TO_YOU",se="TELEMEDICINE",ce="DRIVE_THRU",ue="PROCEDURE";const pe=e=>{const t=e||{};return{setPatient:function(e){return t.idPatient=e,t},setProduct:function(e){let i;return t.productId=e.id,t.productIdLocal=e.idLocal||"",t.name=e.name,t.price=e.price,t.discount=e.discount,t.id=x(),t.productName=e.name,e.coverages&&(i=e.coverages[0].category===ae.APPOINTMENT?ae.CONSULTATION:e.coverages[0].category),t.scheduleType=i,t},validateSchedule:()=>(t.idPatient||re("Missing schedule.idPatient property"),t.productId||re("Missing (setProductInfo) schedule.productId property"),t.productName||re("Missing schedule.productName property"),t.itemId||re("Missing (setProductInfo) schedule.itemId property"),t.catalogItemId||re("Missing (setProductInfo) schedule.catalogItemId property"),t.careType||re("Missing (setScheduleType) schedule.careType property"),t.scheduleType||re("Missing schedule.scheduleType property"),t.payment||re("Missing (setPayment) schedule.payment property"),t.unit||re("Missing (setUnit) schedule.unit property"),t.selectedSlotOptions||re("Missing (setSlotsOptions) schedule.selectedSlotOptions property"),t.payment||re("Missing (setSlotsOptions) schedule.payment property"),t.selectedSlotOptions||re("Missing (setSlotsOptions) schedule.selectedSlotOptions property"),t.catalogItemId||re("Missing (schedule) schedule.catalogItemId property"),t),setScheduleType:function(e){return t.careType=e.careType,t},setPayment:function(e){return t.payment=e,t},setUnit:function(e,i){return t.unit=(e=>{const t={};return t.unitId=e.id_sgh,t.catalogUnitId=e.id,t.name=e.name,t.address=e.address,t.neighborhood=e.neighborhood,t.number=e.address_number,t.city=e.city,t.state=e.state,t.additionalInfo=e.address_complement,t})(e),t.unitId=e.id_sgh,t.itemId=e.itemId,t.catalogItemId=e.catalogItemId,t.isKit=e.isKit,t.localId=i,t},setSlotsOptions:function(e){return t.selectedSlotOptions=e,t},setResource:function(e,i){return t.resource=i||void 0,t.useResouce=e,t},build:function(){return t},setChannel:function(e){return t.channel=e,t}}},he=y({});function me({children:t}){const[i,r]=a([]),[o,l]=a(),[d,s]=a({}),[c,u]=a([]),[p,h]=a(),[m,g]=a(""),[f,v]=n.useState([]),b=e=>{const t=i;let n=!1;return t.forEach(((i,a)=>{i.idPatient===e.idPatient&&(n=!0,t[a]=e)})),n||t.push(e),l(e),r(t),e};return e(he.Provider,{value:{scheduleItems:i,addScheduleItem:e=>{const t=e.quantity||1;for(let n=1;n<=t;n++){let t;e.coverages&&(t=e.coverages[0].category);const n={productId:e.id,productIdLocal:e.idLocal||"",name:e.name,price:e.price,discount:e.discount,id:x(),productName:e.name,scheduleType:t,...e.idPatient?{idPatient:e.idPatient}:{}};return l(n),r([...i,n]),n}},selectedItem:o,setSelectedItem:l,changeSchedule:b,addUnits:e=>{u(e)},clearUnits:()=>{u([])},units:c,removeSchedule:e=>{const t=i.filter((t=>t.productIdLocal!==e));r(t)},clearSchedules:()=>{r([]),l({}),u([]),v([]),g(""),s({})},removeOneSchedule:e=>{const t=i;let n=0;i.find(((t,i)=>{t.productId===e&&0===n&&(n=i)})),t.splice(n,1),r(t)},addScheduleOneItem:e=>{const t={productId:e.id,productIdLocal:e.idLocal||"",name:e.name,price:e.price,discount:e.discount,id:x()};r([...i,t])},unitDatesAvailable:f,addUnitDatesAvailable:e=>{v(e)},findUnitDatesAvailable:e=>{if(f.length){const t=f.find((t=>Object.keys(t).find((t=>t===e))));if(t)return t[e]}return[]},changeScheduleDateSlot:({scheduleId:e,displayTimes:t})=>{const n=[...i];n.map(((i,a)=>{if(i.id===e){const e={...i,time:t,selectedSlotOptions:t.slots};n[a]=e}})),r(n)},tokenSuccess:m,setTokenSuccess:g,eavSlotsData:p,setEavSlotsData:h,changeProductSchedule:({schedule:e,product:t})=>{e.productIdLocal=t.idLocal,e.productId=t.id,e.price=t.price,e.discount=t.discount,e.productName=t.name,e.name=t.name,b(e)},getNotScheduledProducts:({patientList:e,productList:t})=>{const n=[];return e.forEach((e=>{i.forEach((i=>{var a,r;if(i.idPatient===e.idPatient){const o=!!i.time&&!!(null===(a=null==i?void 0:i.payment)||void 0===a?void 0:a.type)&&!!i.careType;if(!o){const a={};a.patient=e,a.payment=String(null===(r=null==i?void 0:i.payment)||void 0===r?void 0:r.type)||"",a.schedule=i,a.complete=o;const l=t.find((e=>e.id===i.productId));l&&(a.product=l),n.push(a)}}}))})),n},scheduleSpecialistSelected:d,setScheduleSpecialistSelected:s,changeScheduleSpecialist:e=>{s({...d,...e})}},children:t})}const ge=y({});function fe({children:t}){const[i,n]=a([]),[r,o]=a([]),{removeSchedule:l}=_(he,(e=>e)),{selectedService:d}=_(M,(e=>e));return e(ge.Provider,{value:{productList:i,productListOriginal:r,addProductList:(e,t)=>{e.idLocal=x(),n([...i,e]);const a=function(e){const t={};return t.discount=e.discount,t.discount_percent=e.discount_percent,t.price=e.price,t.id=e.id,t.name=e.name,t.recurrence_type=e.recurrence_type,t.description=e.description,t.contract_type=e.contract_type,t.active=e.active,t.created_at=e.created_at,t.updated_at=e.updated_at,t.amount=e.amount,t.price_discount=e.price_discount,t.suggested_amount=e.suggested_amount,t.coverages=e.coverages,t.is_b2b=e.is_b2b,t.rules=e.rules,t.icon=e.icon,t}(e);if(o([...r,a]),t)return t.productIdLocal=e.idLocal,t.productId=e.id,t.price=e.price,t.discount=e.discount,t.productName=e.name,t.name=e.name,t},removeProductList:e=>{const t=i.filter((t=>{if(t.idLocal===e&&l(e),t.idLocal!==e)return t}));n(t)},clearCart:()=>{n([]),o([])},changeProduct:e=>{const t=e.idLocal||(a=e.id,null===(l=i.find((e=>e.id===a)))||void 0===l?void 0:l.idLocal);var a,l;let s=!1;const c=i.map((i=>e.idLocal===t?(s=!0,function({productFind:e,productToAdd:t}){const i=r.find((t=>t.id===e.id)),n=null==d?void 0:d.products.find((e=>e.id===t.id));if(i&&n){const e=r.map((e=>e.id===(null==i?void 0:i.id)?n:e));o(e)}}({productFind:i,productToAdd:e}),e):i));s||c.push(e),n(c)},findProduct:e=>i.find((t=>t.id===e)),findProductOriginal:e=>r.find((t=>t.id===e))},children:t})}const ve=y({});function be({children:t}){const[i,a]=n.useState([]);return e(ve.Provider,{value:{eligibilityPlans:i,setEligibilityPlans:a,clearEligibilityPlans:()=>{a([])}},children:t})}const ye=g`
  :root {
   --blue-einstein: #004F92;
   --background-color: #ffffff;
   --color-gray-100: #E8E8E8;
   --color-gray-400: #898B8E;
   --color-gray-500: #555658;

   --height-full: calc(var(--vh, 1vh) * 100);
   --height-body-without-header: calc(var(--height-full) - 72px);


   --toastify-color-light: #fff;
  --toastify-color-dark: #121212;
  --toastify-color-info: #3498db;
  --toastify-color-success: #07bc0c;
  --toastify-color-warning: #f1c40f;
  --toastify-color-error: #e74c3c;
  --toastify-color-transparent: rgba(255, 255, 255, 0.7);
  --toastify-icon-color-info: var(--toastify-color-info);
  --toastify-icon-color-success: var(--toastify-color-success);
  --toastify-icon-color-warning: var(--toastify-color-warning);
  --toastify-icon-color-error: var(--toastify-color-error);
  --toastify-toast-width: 320px;
  --toastify-toast-background: #fff;
  --toastify-toast-min-height: 64px;
  --toastify-toast-max-height: 800px;
  --toastify-font-family: sans-serif;
  --toastify-z-index: 9999;
  --toastify-text-color-light: #757575;
  --toastify-text-color-dark: #fff;
  --toastify-text-color-info: #fff;
  --toastify-text-color-success: #fff;
  --toastify-text-color-warning: #fff;
  --toastify-text-color-error: #fff;
  --toastify-spinner-color: #616161;
  --toastify-spinner-color-empty-area: #e0e0e0;
  --toastify-color-progress-light: linear-gradient(
    to right,
    #4cd964,
    #5ac8fa,
    #007aff,
    #34aadc,
    #5856d6,
    #ff2d55
  );
  --toastify-color-progress-dark: #bb86fc;
  --toastify-color-progress-info: var(--toastify-color-info);
  --toastify-color-progress-success: var(--toastify-color-success);
  --toastify-color-progress-warning: var(--toastify-color-warning);
  --toastify-color-progress-error: var(--toastify-color-error);
  }

  * { 
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html{
    height: 100%;

    scroll-behavior: smooth;
  }

  body {
    font-family: 'Montserrat', sans-serif;
    margin: 0px;
    padding: 0px;
    height: 100%;
    background-color: var(--background-color);

    overflow-x: hidden;
  }





.Toastify__toast-container {
  z-index: var(--toastify-z-index);
  -webkit-transform: translate3d(0, 0, var(--toastify-z-index) px);
  position: fixed;
  padding: 4px;
  width: var(--toastify-toast-width);
  box-sizing: border-box;
  color: #fff;
}
.Toastify__toast-container--top-left {
  top: 1em;
  left: 1em;
}
.Toastify__toast-container--top-center {
  top: 1em;
  left: 50%;
  transform: translateX(-50%);
}
.Toastify__toast-container--top-right {
  top: 1em;
  right: 1em;
}
.Toastify__toast-container--bottom-left {
  bottom: 1em;
  left: 1em;
}
.Toastify__toast-container--bottom-center {
  bottom: 1em;
  left: 50%;
  transform: translateX(-50%);
}
.Toastify__toast-container--bottom-right {
  bottom: 1em;
  right: 1em;
}

@media only screen and (max-width : 480px) {
  .Toastify__toast-container {
    width: 100vw;
    padding: 0;
    left: 0;
    margin: 0;
  }
  .Toastify__toast-container--top-left, .Toastify__toast-container--top-center, .Toastify__toast-container--top-right {
    top: 0;
    transform: translateX(0);
  }
  .Toastify__toast-container--bottom-left, .Toastify__toast-container--bottom-center,
   .Toastify__toast-container--bottom-right {
    bottom: 0;
    transform: translateX(0);
  }
  .Toastify__toast-container--rtl {
    right: 0;
    left: initial;
  }
}
.Toastify__toast {
  position: relative;
  min-height: var(--toastify-toast-min-height);
  box-sizing: border-box;
  margin-bottom: 1rem;
  padding: 8px;
  border-radius: 4px;
  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1), 0 2px 15px 0 rgba(0, 0, 0, 0.05);
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: justify;
      justify-content: space-between;
  max-height: var(--toastify-toast-max-height);
  overflow: hidden;
  font-family: var(--toastify-font-family);
  cursor: pointer;
  direction: ltr;
}
.Toastify__toast--rtl {
  direction: rtl;
}
.Toastify__toast-body {
  margin: auto 0;
  -ms-flex: 1 1 auto;
      flex: 1 1 auto;
  padding: 6px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
      align-items: center;
}
.Toastify__toast-body > div:last-child {
  -ms-flex: 1;
      flex: 1;
}
.Toastify__toast-icon {
  -webkit-margin-end: 10px;
          margin-inline-end: 10px;
  width: 20px;
  -ms-flex-negative: 0;
      flex-shrink: 0;
  display: -ms-flexbox;
  display: flex;
}

.Toastify--animate {
  animation-fill-mode: both;
  animation-duration: 0.7s;
}

.Toastify--animate-icon {
  animation-fill-mode: both;
  animation-duration: 0.3s;
}

@media only screen and (max-width : 480px) {
  .Toastify__toast {
    margin-bottom: 0;
    border-radius: 0;
  }
}
.Toastify__toast-theme--dark {
  background: var(--toastify-color-dark);
  color: var(--toastify-text-color-dark);
}
.Toastify__toast-theme--light {
  background: var(--toastify-color-light);
  color: var(--toastify-text-color-light);
}
.Toastify__toast-theme--colored.Toastify__toast--default {
  background: var(--toastify-color-light);
  color: var(--toastify-text-color-light);
}
.Toastify__toast-theme--colored.Toastify__toast--info {
  color: var(--toastify-text-color-info);
  background: var(--toastify-color-info);
}
.Toastify__toast-theme--colored.Toastify__toast--success {
  color: var(--toastify-text-color-success);
  background: var(--toastify-color-success);
}
.Toastify__toast-theme--colored.Toastify__toast--warning {
  color: var(--toastify-text-color-warning);
  background: var(--toastify-color-warning);
}
.Toastify__toast-theme--colored.Toastify__toast--error {
  color: var(--toastify-text-color-error);
  background: var(--toastify-color-error);
}

.Toastify__progress-bar-theme--light {
  background: var(--toastify-color-progress-light);
}
.Toastify__progress-bar-theme--dark {
  background: var(--toastify-color-progress-dark);
}
.Toastify__progress-bar--info {
  background: var(--toastify-color-progress-info);
}
.Toastify__progress-bar--success {
  background: var(--toastify-color-progress-success);
}
.Toastify__progress-bar--warning {
  background: var(--toastify-color-progress-warning);
}
.Toastify__progress-bar--error {
  background: var(--toastify-color-progress-error);
}
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info, 
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success, 
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error {
  background: var(--toastify-color-transparent);
}

.Toastify__close-button {
  color: #fff;
  background: transparent;
  outline: none;
  border: none;
  padding: 0;
  cursor: pointer;
  opacity: 0.7;
  transition: 0.3s ease;
  -ms-flex-item-align: start;
      align-self: flex-start;
}
.Toastify__close-button--light {
  color: #000;
  opacity: 0.3;
}
.Toastify__close-button > svg {
  fill: currentColor;
  height: 16px;
  width: 14px;
}
.Toastify__close-button:hover, .Toastify__close-button:focus {
  opacity: 1;
}

@keyframes Toastify__trackProgress {
  0% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(0);
  }
}
.Toastify__progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5px;
  z-index: var(--toastify-z-index);
  opacity: 0.7;
  transform-origin: left;
}
.Toastify__progress-bar--animated {
  animation: Toastify__trackProgress linear 1 forwards;
}
.Toastify__progress-bar--controlled {
  transition: transform 0.2s;
}
.Toastify__progress-bar--rtl {
  right: 0;
  left: initial;
  transform-origin: right;
}

.Toastify__spinner {
  width: 20px;
  height: 20px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: var(--toastify-spinner-color-empty-area);
  border-right-color: var(--toastify-spinner-color);
  animation: Toastify__spin 0.65s linear infinite;
}

@keyframes Toastify__bounceInRight {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
  }
  75% {
    transform: translate3d(10px, 0, 0);
  }
  90% {
    transform: translate3d(-5px, 0, 0);
  }
  to {
    transform: none;
  }
}
@keyframes Toastify__bounceOutRight {
  20% {
    opacity: 1;
    transform: translate3d(-20px, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(2000px, 0, 0);
  }
}
@keyframes Toastify__bounceInLeft {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }
  75% {
    transform: translate3d(-10px, 0, 0);
  }
  90% {
    transform: translate3d(5px, 0, 0);
  }
  to {
    transform: none;
  }
}
@keyframes Toastify__bounceOutLeft {
  20% {
    opacity: 1;
    transform: translate3d(20px, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0);
  }
}
@keyframes Toastify__bounceInUp {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(0, 3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  75% {
    transform: translate3d(0, 10px, 0);
  }
  90% {
    transform: translate3d(0, -5px, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__bounceOutUp {
  20% {
    transform: translate3d(0, -10px, 0);
  }
  40%, 45% {
    opacity: 1;
    transform: translate3d(0, 20px, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
}
@keyframes Toastify__bounceInDown {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(0, -3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, 25px, 0);
  }
  75% {
    transform: translate3d(0, -10px, 0);
  }
  90% {
    transform: translate3d(0, 5px, 0);
  }
  to {
    transform: none;
  }
}
@keyframes Toastify__bounceOutDown {
  20% {
    transform: translate3d(0, 10px, 0);
  }
  40%, 45% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
}
.Toastify__bounce-enter--top-left, .Toastify__bounce-enter--bottom-left {
  animation-name: Toastify__bounceInLeft;
}
.Toastify__bounce-enter--top-right, .Toastify__bounce-enter--bottom-right {
  animation-name: Toastify__bounceInRight;
}
.Toastify__bounce-enter--top-center {
  animation-name: Toastify__bounceInDown;
}
.Toastify__bounce-enter--bottom-center {
  animation-name: Toastify__bounceInUp;
}

.Toastify__bounce-exit--top-left, .Toastify__bounce-exit--bottom-left {
  animation-name: Toastify__bounceOutLeft;
}
.Toastify__bounce-exit--top-right, .Toastify__bounce-exit--bottom-right {
  animation-name: Toastify__bounceOutRight;
}
.Toastify__bounce-exit--top-center {
  animation-name: Toastify__bounceOutUp;
}
.Toastify__bounce-exit--bottom-center {
  animation-name: Toastify__bounceOutDown;
}

@keyframes Toastify__zoomIn {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}
@keyframes Toastify__zoomOut {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  to {
    opacity: 0;
  }
}
.Toastify__zoom-enter {
  animation-name: Toastify__zoomIn;
}

.Toastify__zoom-exit {
  animation-name: Toastify__zoomOut;
}

@keyframes Toastify__flipIn {
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }
  40% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    animation-timing-function: ease-in;
  }
  60% {
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }
  80% {
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  }
  to {
    transform: perspective(400px);
  }
}
@keyframes Toastify__flipOut {
  from {
    transform: perspective(400px);
  }
  30% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    opacity: 1;
  }
  to {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    opacity: 0;
  }
}
.Toastify__flip-enter {
  animation-name: Toastify__flipIn;
}

.Toastify__flip-exit {
  animation-name: Toastify__flipOut;
}

@keyframes Toastify__slideInRight {
  from {
    transform: translate3d(110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideInLeft {
  from {
    transform: translate3d(-110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideInUp {
  from {
    transform: translate3d(0, 110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideInDown {
  from {
    transform: translate3d(0, -110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideOutRight {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(110%, 0, 0);
  }
}
@keyframes Toastify__slideOutLeft {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(-110%, 0, 0);
  }
}
@keyframes Toastify__slideOutDown {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, 500px, 0);
  }
}
@keyframes Toastify__slideOutUp {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, -500px, 0);
  }
}
.Toastify__slide-enter--top-left, .Toastify__slide-enter--bottom-left {
  animation-name: Toastify__slideInLeft;
}
.Toastify__slide-enter--top-right, .Toastify__slide-enter--bottom-right {
  animation-name: Toastify__slideInRight;
}
.Toastify__slide-enter--top-center {
  animation-name: Toastify__slideInDown;
}
.Toastify__slide-enter--bottom-center {
  animation-name: Toastify__slideInUp;
}

.Toastify__slide-exit--top-left, .Toastify__slide-exit--bottom-left {
  animation-name: Toastify__slideOutLeft;
}
.Toastify__slide-exit--top-right, .Toastify__slide-exit--bottom-right {
  animation-name: Toastify__slideOutRight;
}
.Toastify__slide-exit--top-center {
  animation-name: Toastify__slideOutUp;
}
.Toastify__slide-exit--bottom-center {
  animation-name: Toastify__slideOutDown;
}

@keyframes Toastify__spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`,_e=y({});function xe({children:t}){const[i,n]=a([]),[r,o]=a(),[l,d]=a(!1),[s,c]=a(!1),[u,p]=a(!1),[h,m]=a(!1),{changeSchedule:g,scheduleItems:f}=_(he,(e=>e)),v=e=>{f.map((t=>{t.idPatient=e,g(t)}))};return e(_e.Provider,{value:{patientList:i,addPatientList:e=>{let t="";if(i.find((t=>e.idPatient===t.idPatient))){t=e.idPatient||"";const a=i.filter((t=>t.idPatient!==e.idPatient));a.push(e),n(a)}else t=x(),e.idPatient=t,n([...i,e]);return e.idPatient?v(e.idPatient):v(t),e},clearPatientList:()=>{n([]),o(void 0)},findPatiendById:e=>i.find((t=>t.idPatient===e)),isModalExistingSchedule:s,isModalNoEligibility:u,isModalProductNotCoveredVisible:h,isModalSystemUnavailableVisible:l,setIsModalExistingSchedule:c,setIsModalNoEligibility:p,setIsModalProductNotCoveredVisible:m,setIsModalSystemUnavailableVisible:d,patientSelected:r,setPatientSelected:o},children:t})}var Se={colors:{blueEinstein:"#004F92",backgroundColor:"#ffffff",colorGray100:"#E8E8E8",colorGray300:"#d5d5d6",colorGray400:"#898B8E",colorGray500:"#555658",colorSuccess:"#00b193",colorDanger:"#ef4f4c"},fontWeight:{medium:500,semibold:600,bold:700},layers:{base:10,menu:20,overlay:30,modal:40,alwaysOnTop:50}};const we=e=>"Público Geral"===e.type||"Colaboradores Einstein"===e.type||"Corporativo"===e.type,Ee=e=>{var t;return{id:e.id,active:e.active,name:e.name,cnpj:e.companyCode,id_sgh:e.id_sgh,img_url:e.img_url,address:e.address.name,address_complement:e.address.complement,address_number:e.address.number,block_building:e.address.block_building,cep:e.address.cep,city:e.address.city,state:e.address.state,neighborhood:e.address.neighborhood,phone:null===(t=e.contacts.find((e=>"Público Geral"===e.type)))||void 0===t?void 0:t.value,phoneList:e.contacts.filter(we),business_unit_work_hour_id:e.workHours.id,business_unit_work_hour:{id:e.workHours.id,sunday:e.workHours.weekends.sunday,saturday:e.workHours.weekends.saturday,is_24h_weekends:e.workHours.weekends.is_24h,monday:e.workHours.weekdays.monday,tuesday:e.workHours.weekdays.tuesday,wednesday:e.workHours.weekdays.wednesday,thursday:e.workHours.weekdays.thursday,friday:e.workHours.weekdays.friday,is_24h_weekdays:e.workHours.weekdays.is_24h,work_hour_start:e.workHours.start,work_hour_end:e.workHours.end,holiday_work_hour_start:e.workHours.holiday.hours.start,holiday_work_hour_end:e.workHours.holiday.hours.end,different_work_hour_start:e.workHours.different.start,different_work_hour_end:e.workHours.different.end,holiday:e.workHours.holiday.is_holiday,is_24h_holiday:e.workHours.holiday.is_24h}}},ke=S.create({baseURL:process.env.REACT_APP_CATALOGO_API}),Te=S.create({baseURL:process.env.REACT_APP_SLOTS_API}),Ie=S.create({baseURL:process.env.REACT_APP_VIACEP_API}),Ce=S.create({baseURL:process.env.REACT_APP_BUSINESS_RULE}),Pe=S.create({baseURL:process.env.REACT_APP_SCHEDULE_SPECIALIST_API});S.create({baseURL:"http://localhost:4444"});const Ne=S.create({baseURL:process.env.REACT_APP_SPECIALISTS_PUBLIC_API,headers:{"X-Tenant-Id":"einstein"}});S.create({baseURL:process.env.REACT_APP_UNIFIED_APPOINTMENTS});const Me=S.create({baseURL:process.env.REACT_APP_TELEORIENTATION_BASE_URL}),De=S.create({baseURL:process.env.REACT_APP_GET_LAMBDA_VALIDATE_API_URL}),Oe=async e=>{const t={error:!1,errorStatus:null,message:"",data:{}};try{const i=await ke.get(`products/${e}`);return t.data=i.data,t}catch(e){return t.error=!0,console.error(e),p.error("Erro ao obter produto"),t}},Re=async e=>{const t={error:!1,errorStatus:null,message:"",data:{}};try{const i=await De.get("validate-products/",{params:{serviceId:e}});return t.data=i.data,t}catch(e){return t.error=!0,console.error(e),p.error("Erro ao obter serviço"),t}},Ae=async(e="")=>{const t={error:!1,errorStatus:null,message:"",data:{}};let i={};e&&(i={name:e});try{const e=await De.get("validate",{params:i});return t.data=e.data,t}catch(e){return t.error=!0,console.error(e),t}},Le=y({});function Ue({children:t}){const[i,r]=a(),[o,l]=a(),[d,s]=a(),[c,u]=a([]),[h,m]=n.useState(!1),[g,f]=a(!1),v=g,[b,y]=a(null);return e(Le.Provider,{value:{loading:v,units:c,selectedProduct:i,selectedService:o,activeServices:d,selectedItemToSchedule:b,selectItemToSchedule:y,getActiveServices:async e=>{f(!0);const t=await Ae(e),{error:i,data:n}=t;i||s(n),i&&(p.error("Erro ao obter produtos."),s(void 0)),f(!1)},getAttendanceUnits:async()=>{const{data:e}=await(async e=>{const t=await ke.get("branch",{params:{limit:e}}),{data:i}=t;return i})(30),t=e.map((e=>Ee(e)));u(t)},handleSelectProduct:e=>{r(e),l(void 0)},handleSelectService:e=>{r(void 0),l(e)},logged:h,setLogged:m},children:t})}const $e=e=>{let t;const i=new Set,n=(e,n)=>{const a="function"==typeof e?e(t):e;if(!Object.is(a,t)){const e=t;t=(null!=n?n:"object"!=typeof a)?a:Object.assign({},t,a),i.forEach((i=>i(t,e)))}},a=()=>t,r={setState:n,getState:a,subscribe:e=>(i.add(e),()=>i.delete(e)),destroy:()=>{"production"!==(import.meta.env&&import.meta.env.MODE)&&console.warn("[DEPRECATED] The destroy method will be unsupported in the future version. You should use unsubscribe function returned by subscribe. Everything will be garbage collected if store is garbage collected."),i.clear()}};return t=e(n,a,r),r};var Fe={exports:{}},Ve={},ze={exports:{}},He={},Be=n;var Ge="function"==typeof Object.is?Object.is:function(e,t){return e===t&&(0!==e||1/e==1/t)||e!=e&&t!=t},je=Be.useState,qe=Be.useEffect,We=Be.useLayoutEffect,Ye=Be.useDebugValue;function Xe(e){var t=e.getSnapshot;e=e.value;try{var i=t();return!Ge(e,i)}catch(e){return!0}}var Ke="undefined"==typeof window||void 0===window.document||void 0===window.document.createElement?function(e,t){return t()}:function(e,t){var i=t(),n=je({inst:{value:i,getSnapshot:t}}),a=n[0].inst,r=n[1];return We((function(){a.value=i,a.getSnapshot=t,Xe(a)&&r({inst:a})}),[e,i,t]),qe((function(){return Xe(a)&&r({inst:a}),e((function(){Xe(a)&&r({inst:a})}))}),[e]),Ye(i),i};He.useSyncExternalStore=void 0!==Be.useSyncExternalStore?Be.useSyncExternalStore:Ke;var Qe={};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */"production"!==process.env.NODE_ENV&&function(){"undefined"!=typeof __REACT_DEVTOOLS_GLOBAL_HOOK__&&"function"==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart&&__REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error);var e=n,t=e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;function i(e){for(var t=arguments.length,i=new Array(t>1?t-1:0),n=1;n<t;n++)i[n-1]=arguments[n];a("error",e,i)}function a(e,i,n){var a=t.ReactDebugCurrentFrame.getStackAddendum();""!==a&&(i+="%s",n=n.concat([a]));var r=n.map((function(e){return String(e)}));r.unshift("Warning: "+i),Function.prototype.apply.call(console[e],console,r)}var r="function"==typeof Object.is?Object.is:function(e,t){return e===t&&(0!==e||1/e==1/t)||e!=e&&t!=t},o=e.useState,l=e.useEffect,d=e.useLayoutEffect,s=e.useDebugValue,c=!1,u=!1;function p(e){var t=e.getSnapshot,i=e.value;try{var n=t();return!r(i,n)}catch(e){return!0}}var h=!!("undefined"==typeof window||void 0===window.document||void 0===window.document.createElement)?function(e,t,i){return t()}:function(t,n,a){c||void 0!==e.startTransition&&(c=!0,i("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));var h=n();if(!u){var m=n();r(h,m)||(i("The result of getSnapshot should be cached to avoid an infinite loop"),u=!0)}var g=o({inst:{value:h,getSnapshot:n}}),f=g[0].inst,v=g[1];return d((function(){f.value=h,f.getSnapshot=n,p(f)&&v({inst:f})}),[t,h,n]),l((function(){p(f)&&v({inst:f});return t((function(){p(f)&&v({inst:f})}))}),[t]),s(h),h},m=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:h;Qe.useSyncExternalStore=m,"undefined"!=typeof __REACT_DEVTOOLS_GLOBAL_HOOK__&&"function"==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop&&__REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error)}(),"production"===process.env.NODE_ENV?ze.exports=He:ze.exports=Qe
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */;var Ze=n,Je=ze.exports;var et="function"==typeof Object.is?Object.is:function(e,t){return e===t&&(0!==e||1/e==1/t)||e!=e&&t!=t},tt=Je.useSyncExternalStore,it=Ze.useRef,nt=Ze.useEffect,at=Ze.useMemo,rt=Ze.useDebugValue;Ve.useSyncExternalStoreWithSelector=function(e,t,i,n,a){var r=it(null);if(null===r.current){var o={hasValue:!1,value:null};r.current=o}else o=r.current;r=at((function(){function e(e){if(!d){if(d=!0,r=e,e=n(e),void 0!==a&&o.hasValue){var t=o.value;if(a(t,e))return l=t}return l=e}if(t=l,et(r,e))return t;var i=n(e);return void 0!==a&&a(t,i)?t:(r=e,l=i)}var r,l,d=!1,s=void 0===i?null:i;return[function(){return e(t())},null===s?void 0:function(){return e(s())}]}),[t,i,n,a]);var l=tt(e,r[0],r[1]);return nt((function(){o.hasValue=!0,o.value=l}),[l]),rt(l),l};var ot={};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */"production"!==process.env.NODE_ENV&&function(){"undefined"!=typeof __REACT_DEVTOOLS_GLOBAL_HOOK__&&"function"==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart&&__REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error);var e=n,t=ze.exports;var i="function"==typeof Object.is?Object.is:function(e,t){return e===t&&(0!==e||1/e==1/t)||e!=e&&t!=t},a=t.useSyncExternalStore,r=e.useRef,o=e.useEffect,l=e.useMemo,d=e.useDebugValue;ot.useSyncExternalStoreWithSelector=function(e,t,n,s,c){var u,p=r(null);null===p.current?(u={hasValue:!1,value:null},p.current=u):u=p.current;var h=l((function(){var e,a,r=!1,o=function(t){if(!r){r=!0,e=t;var n=s(t);if(void 0!==c&&u.hasValue){var o=u.value;if(c(o,n))return a=o,o}return a=n,n}var l=a;if(i(e,t))return l;var d=s(t);return void 0!==c&&c(l,d)?l:(e=t,a=d,d)},l=void 0===n?null:n;return[function(){return o(t())},null===l?void 0:function(){return o(l())}]}),[t,n,s,c]),m=h[0],g=h[1],f=a(e,m,g);return o((function(){u.hasValue=!0,u.value=f}),[f]),d(f),f},"undefined"!=typeof __REACT_DEVTOOLS_GLOBAL_HOOK__&&"function"==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop&&__REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error)}(),"production"===process.env.NODE_ENV?Fe.exports=Ve:Fe.exports=ot;var lt=Fe.exports;const{useSyncExternalStoreWithSelector:dt}=lt;const st=e=>{"production"!==(import.meta.env&&import.meta.env.MODE)&&"function"!=typeof e&&console.warn('[DEPRECATED] Passing a vanilla store will be unsupported in the future version. Please use `import { useStore } from "zustand"` to use the vanilla store in React.');const t="function"==typeof e?(e=>e?$e(e):$e)(e):e,i=(e,i)=>function(e,t=e.getState,i){const n=dt(e.subscribe,e.getState,e.getServerState||e.getState,t,i);return r(n),n}(t,e,i);return Object.assign(i,t),i},ct=(ut=e=>({genericModals:null,setGenericModals:t=>e({genericModals:t}),clearGenericModals:()=>e({genericModals:null})}))?st(ut):st;var ut;const pt=e=>{if("string"!=typeof e)return!1;if(!(e=e.replace(/[\s.-]*/gim,""))||11!=e.length||"00000000000"==e||"11111111111"==e||"22222222222"==e||"33333333333"==e||"44444444444"==e||"55555555555"==e||"66666666666"==e||"77777777777"==e||"88888888888"==e||"99999999999"==e)return!1;let t,i=0;for(let t=1;t<=9;t++)i+=parseInt(e.substring(t-1,t))*(11-t);if(t=10*i%11,10!=t&&11!=t||(t=0),t!=parseInt(e.substring(9,10)))return!1;i=0;for(let t=1;t<=10;t++)i+=parseInt(e.substring(t-1,t))*(12-t);return t=10*i%11,10!=t&&11!=t||(t=0),t==parseInt(e.substring(10,11))},ht=e=>e.length>=8,mt=e=>e.replace(/[&/\\#,+()$~%.'":*?<>={}[\]@!-]/g,""),gt=e=>e.replace(/[\d]/g,"").replace(/[&/\\#,+()$~%.'":*?<>{}[\]@!]/g,"");function ft(e){return/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(e.trim()).toLowerCase())}function vt(e){const t=e.split("/"),i=`${t[2]}-${t[1]}-${t[0]}`,n=new Date(i+"T00:00:00");return n.getTime()&&n>=new Date(1900,0,1)&&n<=new Date(Date.now())?i:null}function bt(e){const t=e.trim().split(" ");if(t.length>=2){const e=t[0],i=t[t.length-1];if(e.length>=2&&i.length>=2)return!0}return!1}function yt(e,t){const i=e.split("-")[0];return(new Date).getFullYear()-+i>=t}const _t=e=>{const t=e.replace(/[^\d]/g,""),i=t.length;return i<=6?e=t.replace(/(\d{3})(\d{1,3})/g,"$1.$2"):i<=9?e=t.replace(/(\d{3})(\d{3})(\d{1,3})/g,"$1.$2.$3"):i<=11?e=t.replace(/(\d{3})(\d{3})(\d{3})(\d{1,2})/g,"$1.$2.$3-$4"):i>=12&&(e=e.substr(0,14)),e},xt=e=>e.replace(/(\.|\/|-)/g,"").replace("(","").replace(")",""),St=e=>{const t=e.replace(/[^\d]/g,""),i=t.length;return i<=6?e=t.replace(/(\d{2})(\d{1,6})/g,"($1) $2"):i<=10?e=t.replace(/(\d{2})(\d{4})(\d{1,4})/g,"($1) $2-$3"):i<=11?e=t.replace(/(\d{2})(\d{5})(\d{4})/g,"($1) $2-$3"):i<=15&&(e=e.substr(0,14)),e},wt=e=>{if(Date.parse(e)){const t=e.split("-");return t[2]+"/"+t[1]+"/"+t[0]}},Et=e=>{const t=mt(e);return t.length>=10?t.substr(0,10):t};function kt(e){let t=e.toLowerCase();return t=t.replace(new RegExp(/\s/g),""),t=t.replace(new RegExp(/[àáâãäå]/g),"a"),t=t.replace(new RegExp(/æ/g),"ae"),t=t.replace(new RegExp(/ç/g),"c"),t=t.replace(new RegExp(/[èéêë]/g),"e"),t=t.replace(new RegExp(/[ìíîï]/g),"i"),t=t.replace(new RegExp(/ñ/g),"n"),t=t.replace(new RegExp(/[òóôõö]/g),"o"),t=t.replace(new RegExp(/œ/g),"oe"),t=t.replace(new RegExp(/[ùúûü]/g),"u"),t=t.replace(new RegExp(/[ýÿ]/g),"y"),t=t.replace(new RegExp(/\W/g),""),t}const Tt=y({});function It({children:t}){const[i,r]=n.useState(null),[o,l]=a(),[d,s]=a([]),[c,u]=a(),[p,h]=a([]),[m,g]=a({expertise:[],medicalField:[],units:[]}),[f,v]=n.useState("");return e(Tt.Provider,{value:{specialists:i,setSpecialists:r,selectedSpecialist:o,setSelectedSpecialist:l,selectedSpecialty:c,setSelectedSpecialty:u,listUnitsFilter:p,setListUnitsFilter:h,specialties:d,setSpecialties:s,findSpecialties:function(e){return null==d?void 0:d.filter((t=>kt(t.name).toUpperCase().includes(kt(e).toUpperCase())))},clearSpecialistConntext:()=>{v(""),s([]),h([]),r(null),l(void 0)},selectedFilters:m,handleCleanSelectedFilters:function(){g({expertise:[],medicalField:[],units:[]})},setSelectedFilters:g,valueFilter:f,setValueFilter:v},children:t})}const Ct=y({});function Pt({children:t}){const[i,n]=a(""),[r,o]=a(!1),[l,d]=a(!1),[s,c]=a(),{clearCart:u}=_(ge,(e=>e)),{resetRoutes:p}=_(A,(e=>e)),{clearSchedules:h}=_(he,(e=>e)),{clearPatientList:m}=_(_e,(e=>e)),{clearSpecialistConntext:g}=_(Tt,(e=>e)),{clearService:f}=_(M,(e=>e)),{clearEligibilityPlans:v}=_(ve,(e=>e)),b=ct((e=>e.clearGenericModals)),y=()=>{u(),m(),h(),f(),p(),v(),b(),g()};return e(Ct.Provider,{value:{id:i,setId:n,clearData:y,isSchedulerOpen:r,setIsSchedulerOpen:o,selectedUnit:s,setSelectedUnit:c,isModalCloseOpen:l,setModalCloseOpen:d,onCloseScheduler:()=>{o(!1),y()}},children:t})}const Nt=({children:i})=>{function n(){const e=.01*window.innerHeight;document.documentElement.style.setProperty("--vh",`${e}px`)}return o((()=>{n(),window.addEventListener("resize",(()=>{n()}))}),[]),e(f,{theme:Se,children:t(L,{children:[e(ye,{}),e(D,{children:e(me,{children:e(fe,{children:e(be,{children:e(xe,{children:e(It,{children:e(Ue,{children:t(Pt,{children:[t(u,{children:[e("link",{rel:"preconnect",href:"https://fonts.googleapis.com"}),e("link",{rel:"preconnect",href:"https://fonts.gstatic.com"}),e("link",{href:"https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;400;500;600;700;800;900&display=swap",rel:"stylesheet"})]}),i,e(h,{})]})})})})})})})})]})})},Mt=m.div`
  ${({visible:e})=>v`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #0000003d;
    z-index: 25;
    opacity: ${e?1:0};
    pointer-events: ${e?"all":"none"};
    transition: opacity 250ms ease-in-out;
  `}
`,Dt=b`
  from {
    top: 0;
  }
  to {
    top: 5rem;
  }
`,Ot=m.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #fff;
  z-index: 50;
  width: 100%;
  /* max-width: 500px; */
`,Rt=m.div`
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 24px;
  height: 72px;
  align-items: center;
`,At=m.p`
  color: #555658;
  text-align: left;
  font-size: 16px;
  font-weight: 500;
`,Lt=m.p`
  color: #898b8e;
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  margin-top: 4px;
`,Ut=m.div`
  width: 100%;

  margin: 0px;
`;m.div`
  position: relative;
  cursor: pointer;
  margin: 0px;
  margin-right: 0.5rem;
`;const $t=m.div`
  margin-right: 12px;
  cursor: pointer;
  width: 24px;
  height: 24px;
`;m.label`
  position: absolute;
  top: -6px;
  right: -6px;
  padding: 4px;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 600;
  background-color: #ef4f4c;
  color: #fff;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`,m.button`
  background-color: transparent;
  border: 1px solid transparent;
`;const Ft=m.div`
  ${({visible:e})=>v`
    display: ${e?"flex":"none"};
    flex-direction: column;
    position: relative;
    background: #fff;
    animation: ${Dt};
    animation-duration: 250ms;

    position: absolute;
    top: 5rem;
    left: 0;
    right: 0;

    & .services-list {
      max-height: var(--height-body-without-header);
      overflow-y: auto;
    }
  `}
`,Vt=m.div`
  height: 1px;
  background: #d5d5d6;
  margin: 0 32px;
  margin-bottom: 16px;
`,zt=m.div`
  margin: 10px 0;
  padding: 0 32px;
  display: flex;
  align-items: center;
`,Ht=m.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0;
`,Bt=m.p`
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  color: #898b8e;
`,Gt=m.div`
  background: #f7f7f7;
  padding: 5px 20px;
  font-size: 32px;
  color: #898b8e;
  font-weight: 600;
  border-radius: 100%;
`,jt=m.li`
  ${({borderOrShadow:e})=>v`
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 8px;
    padding: 16px;
    box-shadow: ${e?"none":"0px 8px 16px 0px #00000014"};
    border: ${e?"1pt solid #d5d5d6":"0px"};
    width: 100%;
    cursor: pointer;

    .btn-remove {
      border: 0;
      margin: 0;
      outline: 0;
      background: transparent;
      cursor: pointer;
    }
  `}
`,qt=m.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
`,Wt=m.h5`
  color: #555658;
  font-size: 16px;
  font-weight: 500;
`;m.div`
  display: flex;
  align-items: center;
  gap: 10px;

  a {
    color: var(--blue-einstein);
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    text-decoration: none;
  }

  svg {
    width: 12px;
    fill: var(--blue-einstein);
  }
`;const Yt=m.p`
  color: #898b8e;
  font-size: 14px;
  font-weight: 500;
  margin-top: 4px;
`;m.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
`,m.div``,m.p`
  color: #898b8e;
  font-size: 14px;
  font-weight: 500;
`,m.div`
  display: flex;
  justify-content: flex-end;
`;const Xt=m.div`
  display: flex;
  flex-direction: column;
`,Kt="https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/services/vacina.svg",Qt="https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/services/estetoscopio.svg",Zt="https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/services/exam.svg",Jt={APPOINTMENT:{alt:"Consulta",icon:Qt},EXAM:{alt:"Exame",icon:Zt},IMMUNIZATION:{alt:"Imunização",icon:Kt}},ei={"Atenção Primária à Saúde Clinicas":"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/services/aps.svg","Imunização":Kt,"Médicos Einstein":Qt,"PCR Covid-19":Zt,"Saúde Ocupacional":"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/services/saude_ocupacional.svg",DEFAULT:Qt},ti=({product:i,border:n=!1,disabled:a=!1,handleClick:r,whitoutRemoveBtn:o=!1})=>{var l;const{clearData:d}=_(Ct,(e=>e)),{productList:s,removeProductList:c}=_(ge,(e=>e)),{resetSteps:u,goTo:p}=_(A,(e=>e));let h=null;return(null===(l=i.coverages)||void 0===l?void 0:l.length)&&(h=Jt[i.coverages[0].category]),e(jt,{borderOrShadow:n,onClick:()=>{r&&r()},children:t(qt,{children:[h&&e("img",{src:h.icon,alt:h.alt}),t(Xt,{style:{width:"100%"},children:[e(Wt,{children:i.name}),h&&e(Yt,{children:h.alt})]}),e(Xt,{children:!a&&!o&&e("button",{className:"btn-remove",onClick:()=>{return e=(null==i?void 0:i.idLocal)||"",c(e),p(O.SERVICE_LIST.id),u(),void(1===s.length&&d());var e},children:e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/Apagar.svg",alt:"remove"})})})]})})},ii=m.div`
  background: #d5d5d6;
  height: 3px;
  width: 100%;
`,ni=m.div`
  ${({width:e})=>v`
    background: var(--blue-einstein);
    height: 3px;
    width: ${e}%;
  `}
`,ai=({currentStep:t=0,totalSteps:i=1})=>e(ii,{children:e(ni,{width:((e,t)=>100/t*e)(t,i)})}),ri=({onClose:n})=>{const{productList:r}=_(ge,(e=>e)),o=_(A,(e=>e)),[l,d]=a(!1),s=R(o.route);return t(i,{children:[e(Mt,{visible:l,onClick:()=>d(!l)}),e("div",{className:"top-wrapper",style:{position:"fixed",zIndex:"25",top:0,left:0,right:0},children:t("div",{className:"",style:{position:"relative"},children:[t(Ot,{children:[t(Rt,{children:[e($t,{onClick:()=>n(),children:e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/xIcon.svg",alt:"reset"})}),t(Ut,{children:[e(At,{children:null==s?void 0:s.title}),(null==s?void 0:s.nextPage)&&t(Lt,{children:["Etapa seguinte: ",s.nextPage]})]})]}),!l&&e(ai,{currentStep:o.currentStep,totalSteps:o.totalSteps})]}),t(Ft,{visible:l,children:[e("ul",{className:"services-list",children:(null==r?void 0:r.length)>=1?t(i,{children:[e(Vt,{}),r.map(((t,i)=>e(zt,{children:e(ti,{disabled:o.route!==O.SERVICE_LIST.id&&o.route!==O.PATIENT_FORM.id,product:t,border:!0})},i+t.id)))]}):t(Ht,{children:[e(Gt,{children:"!"}),e(Bt,{children:"O carrinho está vazio"})]})}),e(ai,{currentStep:o.currentStep,totalSteps:o.totalSteps})]})]})})]})},oi=e=>v`
    background: ${e.colors.colorGray300};
    color: ${e.colors.colorGray400};
  `,li=e=>v`
    background: #fff;
    color: ${e.colors.blueEinstein};
    border: 1px solid ${e.colors.blueEinstein};
  `,di=e=>v`
    background: #fff;
    color: ${e.colors.blueEinstein};
  `,si=e=>v`
    width: initial;
    height: initial;
    background: transparent;
    color: ${e.colors.blueEinstein};
    font-size: 16px;
  `,ci=m.button`
  ${({theme:e,secondary:t,tertiary:i,disabled:n,link:a,height:r,fontSize:o})=>v`
    width: 100%;
    height: ${r?`${r}px`:"56px"};
    background: ${e.colors.blueEinstein};
    color: #fff;
    border: 0;
    border-radius: 3rem;
    font-size: ${o?`${o}px`:"18px"};
    font-weight: 600;
    cursor: pointer;
    font-family: 'Montserrat', sans-serif;

    ${t&&li(e)}
    ${i&&di(e)}
    ${n&&oi(e)}
    ${a&&si(e)}

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 16px;

    & + & {
      margin-top: 16px;
    }
  `}
`,ui=m.div`
  img {
    width: 24px;
    height: 24px;
  }
`,pi=({title:i,iconLeft:n,...a})=>t(ci,{...a,children:[!!n&&e(ui,{children:n}),i]}),hi=m.div`
  background: #fff;
  padding: 24px 32px;
  -webkit-box-shadow: 0px -8px 20px 0px #0000000f;
  box-shadow: 0px -8px 20px 0px #0000000f;

  /* position: absolute;
  left: 0;
  right: 0;
  bottom: 0; */
`,mi=({children:t,...i})=>e(hi,{...i,children:t}),gi=m.div`
  position: absolute;
  top: 75px;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100% - 75px;
  background: #fff;
  z-index: ${({visible:e})=>e?55:0};
  opacity: ${({visible:e})=>e?1:0};
  pointer-events: ${({visible:e})=>e?"all":"none"};
  transition: opacity 350ms ease-in-out;
  display: flex;
  flex-direction: column;

  @media (min-width: 900px) {
    margin: 0 auto;
  }
`,fi=m.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 32px;
  padding-top: 32px;

  div {
    display: flex;
    gap: 8px;
  }
`,vi=m.img`
  cursor: pointer;
`,bi=m.h1`
  font-size: 24px;
  font-weight: 500;
  color: #555658;
`,yi=m.h1`
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  color: #004f92;
  cursor: pointer;
`;const _i=m((function({visible:i,headTitle:n,children:a,onClose:r,rightText:o,onPressRightText:l}){return t(gi,{visible:i,children:[r&&t(fi,{children:[t("div",{children:[e(vi,{onClick:r,src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/Voltar.svg",alt:"Close Icon"}),e(bi,{children:n||"Voltar"})]}),o&&o.length>0&&e(yi,{onClick:null!=l?l:()=>{},children:o})]}),a]})}))``,xi=m.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  overflow-y: auto;
`,Si=m.div`
  overflow-y: auto;
  padding: 32px;
  overflow-y: auto;

  @media (min-width: 900px) {
    padding-top: 56px;
  }
`,wi=m(mi)`
  padding: 32px;
`,Ei=({children:i,visible:n,onClose:a,childrenFooter:r,headTitle:o,rightText:l,onPressRightText:d,...s})=>e(_i,{visible:n,headTitle:o,rightText:l,onPressRightText:d,onClose:a,...s,children:t(xi,{children:[e(Si,{children:i}),r&&e(wi,{children:r})]})}),ki=m.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  @media (min-width: 900px) {
    justify-content: space-between;
  }
`,Ti=m.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;

  & .title {
    font-weight: 500;
    font-size: 24px;
    color: var(--color-gray-500);
    line-height: 32px;
    text-align: center;
  }

  @media (min-width: 900px) {
    padding: 0 40px;
  }
`,Ii=m.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  @media (min-width: 900px) {
    padding-bottom: 32px;
  }
`,Ci=({visible:n,onCancelClose:a,onConfirmClose:r})=>e(Ei,{visible:n,onClose:a,withoutCloseButton:!0,childrenFooter:t(i,{children:[e(pi,{disabled:!n,type:"button",title:"Sim",onClick:r}),e(pi,{disabled:!n,type:"button",title:"Não",tertiary:!0,onClick:a})]}),children:e(ki,{children:e(Ti,{children:t(Ii,{children:[e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warning.svg",alt:"warning"}),e("h3",{className:"title",children:"Deseja abandonar o agendamento?"})]})})})}),Pi=m.div`
  overflow: hidden;
  font-family: 'Montserrat', sans-serif;
`,Ni=()=>v`
    top: 72px;
  `,Mi=m.div`
  ${({visible:e,isFull:t,conclusion:i,isMainNavigation:n,theme:a})=>v`
    position: fixed;
    top: ${t?"0":"72px"};
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: ${t?"100vh":"calc(100vh - 72px)"};
    background: #00000066;
    z-index: 50;
    opacity: ${e?1:0};
    pointer-events: ${e?"all":"none"};
    transition: opacity 250ms ease-in-out;
    overflow: hidden;
    ${i&&Ni()}

    @media(max-width: 900px) {
      ${n&&v`
        z-index: ${a.layers.base};
      `}
    }
  `}
`,Di=e=>v`
    left: initial;
    right: 0;
    transform: ${e?"translateX(0)":"translateX(100vw)"};
    box-shadow: ${e?"-8px 0px 24px #00000029":"none"};
  `,Oi=m.div`
  ${({visible:e,isFull:t,scrollable:i,conclusion:n,isMainNavigation:a,theme:r,withoutPaddingHeaderDesktop:o})=>v`
    position: fixed;
    top: ${t?"0":"72px"};
    bottom: 0;
    left: 0;
    background: #fff;
    transition: transform 250ms ease-in-out;
    z-index: 100;
    height: ${t?"100vh":"calc(100vh - 72px)"};
    min-width: 288px;
    max-width: ${t?"422px":"calc(var(--vh, 1vh) * 100)"};
    width: 100%;
    overflow: hidden;
    ${i&&"overflow-y: auto;"}
    transform: ${e?"translateX(0)":"translateX(-100%)"};
    * {
      font-family: 'Montserrat', sans-serif;
    }

    ${t&&Di(e)}
    /* ${n&&Ni()} */

    @media (max-width: 900px) {
      max-width: ${t?"100vw":"calc(var(--vh, 1vh) * 100)"};
      width: ${t?"100vw":"auto"};

      ${a&&v`
        padding-top: ${o?"0":"72px"};
        z-index: ${r.layers.base};
      `}
    }
  `}
`,Ri=({visible:i,onClose:n,isFull:a,scrollable:r,children:o,conclusion:l,isMainNavigation:d,withoutPaddingHeaderDesktop:s})=>t(Pi,{children:[e(Mi,{"data-testid":"test-overlay","aria-label":"overlay",visible:i,isFull:a,onClick:()=>n(),conclusion:l,isMainNavigation:d}),e(Oi,{"data-testid":"test-sidebar",visible:i,isFull:a,scrollable:r,conclusion:l,isMainNavigation:d,withoutPaddingHeaderDesktop:s,children:o})]}),Ai=m.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    margin-bottom: 24px;
  }

  & .title {
    font-weight: 500;
    font-size: 24px;
    color: var(--color-gray-500);
    line-height: 32px;
    text-align: center;

    margin-bottom: 16px;
  }

  & .subtitle {
    font-weight: 500;
    font-size: 16px;
    color: var(--color-gray-400);
    line-height: 24px;
    text-align: center;
  }
`,Li=({visible:i,onClose:n})=>e(Ei,{visible:i,onClose:n,children:t(Ai,{children:[e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/negative.svg",alt:"negative"}),e("h3",{className:"title",children:"Produto não coberto"}),e("p",{className:"subtitle",children:"O método de pagamento selecionado não cobre o produto."})]})}),Ui=m.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  & .title {
    font-weight: 500;
    font-size: 24px;
    color: var(--color-gray-500);
    line-height: 32px;
    text-align: center;
    width: 308px;
  }

  & .subtitle {
    font-weight: 500;
    font-size: 16px;
    color: var(--color-gray-400);
    line-height: 24px;
  }
`,$i=({visible:n,onClickClose:a})=>e(Ei,{visible:n,onClose:a,withoutCloseButton:!0,childrenFooter:e(i,{children:e(pi,{disabled:!n,type:"button",title:"Fechar",onClick:a})}),children:t(Ui,{children:[e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warning.svg",alt:"warning"}),e("h3",{className:"title",children:"Aviso importante!"}),e("p",{className:"subtitle",children:"Por motivos de segurança, a vacina da gripe via Drive-thru não é permitida para menores de 9 anos. Por favor, escolha outro tipo de atendimento."})]})}),Fi=m.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  & .title {
    font-weight: 500;
    font-size: 24px;
    color: var(--color-gray-500);
    line-height: 32px;
    text-align: center;
    width: 308px;
  }

  & .subtitle {
    font-weight: 500;
    font-size: 16px;
    color: var(--color-gray-400);
    line-height: 24px;
    text-align: center;
  }

  & .tel {
    font-weight: 600;
    font-size: 16px;
    color: var(--blue-einstein);
    line-height: 24px;
  }
`,Vi=m(pi)``,zi=({visible:n,onClickClose:a,onClickWhatsapp:r})=>e(Ei,{visible:n,onClose:a,withoutCloseButton:!0,childrenFooter:t(i,{children:[e(pi,{disabled:!n,type:"button",title:"Agendar pelo whatsapp",onClick:r,iconLeft:e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/whatsapp-white.svg",alt:"whatsapp-icon"})}),e(Vi,{disabled:!n,type:"button",title:"Fechar",tertiary:!0,onClick:a})]}),children:t(Fi,{children:[e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warning.svg",alt:"warning"}),e("h3",{className:"title",children:"Ainda não é possível agendar por aqui"}),t("p",{className:"subtitle",children:["Por enquanto, o agendamento do Einstein até você é apenas por WhatsApp ou pela central de atendimento:"," ",e("a",{className:"tel",href:"tel:+551121511233",children:"(11) 2151-1233"})]})]})});var Hi;!function(e){e.PRODUCT_NOT_COVERED="PRODUCT_NOT_COVERED",e.SERVICE_UNAVAILABLE="SERVICE_UNAVAILABLE",e.NINE_YEARS_DRIVE_THRU="NINE_YEARS_DRIVE_THRU"}(Hi||(Hi={}));const Bi=y({});function Gi({children:i}){const[a,r]=n.useState(!1),[o,l]=n.useState(!1),[d,s]=n.useState(!1);return t(Bi.Provider,{value:{openModal:function(e){({PRODUCT_NOT_COVERED:()=>r(!0),SERVICE_UNAVAILABLE:()=>l(!0),NINE_YEARS_DRIVE_THRU:()=>s(!0),DEFAULT:()=>{}})[e]()}},children:[i,e(Li,{visible:a,onClose:()=>r(!1)}),e(zi,{visible:o,onClickWhatsapp:()=>{window.open("https://wa.me/551136202550")},onClickClose:()=>l(!1)}),e($i,{visible:d,onClickClose:()=>s(!1)})]})}const ji=(e,t,i)=>{e.defaults.headers.common[t]=i};function qi(e){const{atendimento:t}=e;window.dataLayer&&window.dataLayer.push({event:e.event,categoria:e.categoria,acao:e.acao,rotulo:e.rotulo,atendimento:t})}const Wi=m.div`
  background: #ebf7fd;
  border-left: 6px solid #009ddc;
  display: flex;
  flex-direction: row;
  padding: 16px;
  align-items: center;

  & .info {
    font-size: 14px;
    color: #0376a3;
    font-weight: 500;
    margin-right: 16px;
  }

  & .close-button {
    margin-left: auto;
    width: 24px;
    height: 24px;
  }
`,Yi=m.div`
  padding-right: 13px;
`,Xi=({icon:i,info:n,closeButton:a,onClickClose:r})=>t(Wi,{children:[e(Yi,{children:i}),e("p",{className:"info",children:n}),a&&e("img",{onClick:r,className:"close-button",src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/FecharBlue.svg",alt:"taginfo-fechar"})]});m.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  /* align-items: center; */
`;const Ki=m.div`
  margin-right: 16px;
  cursor: pointer;
  margin-top: 3px;

  img {
    max-width: 24px;
  }
`,Qi=({goBack:t})=>{const i=_(A,(e=>e));return e(Ki,{"data-testid":"test-return",onClick:()=>t?t():i.goBack(),children:e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/Voltar.svg",alt:""})})},Zi=m.div`
  margin-bottom: 32px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`,Ji=m.h3`
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  color: #555658;
  margin: 0;
  text-align: left;
`,en=({title:i,disableBack:n,goBack:a,...r})=>t(Zi,{...r,children:[!n&&e(Qi,{goBack:a}),e(Ji,{children:i})]}),tn=m.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: var(--height-full);
  background: #00000075;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  svg {
    width: 100px;
  }
`,nn=({loading:t})=>t?e(tn,{children:e("svg",{version:"1.1",id:"L9",xmlns:"http://www.w3.org/2000/svg",xmlnsXlink:"http://www.w3.org/1999/xlink",x:"0px",y:"0px",viewBox:"0 0 100 100",enableBackground:"new 0 0 0 0",xmlSpace:"preserve",children:e("path",{fill:"#e9e9e9",d:"M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50",children:e("animateTransform",{attributeName:"transform",attributeType:"XML",type:"rotate",dur:"1s",from:"0 50 50",to:"360 50 50",repeatCount:"indefinite"})})})}):null,an=m.div`
  display: flex;
  flex-direction: column;
  color: #555658;

  img {
    width: 120px;
    height: 120px;
    align-self: center;
  }

  h3 {
    text-align: center;
    font-size: 24px;
    font-weight: 400;
    margin-top: 24px;
  }

  div {
    margin-top: 24px;

    p {
      text-align: left;
      color: #898b8e;
      font-size: 16px;
      font-weight: 400;
      margin-bottom: 8px;
    }

    ul {
      margin-left: 24px;

      li {
        text-align: left;
        color: #898b8e;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }

  .info {
    margin-top: 32px;
    font-size: 16px;
    font-weight: 500;
  }

  @media (min-width: 900px) {
    justify-content: space-between;
  }
`,rn=({visible:n,onClose:a})=>{const{goTo:r,primaryRouteNavigate:o}=_(A,(e=>e)),{clearData:l,setIsSchedulerOpen:d}=_(Ct,(e=>e));return e(Ei,{visible:n,onClose:a,withoutCloseButton:!0,childrenFooter:t(i,{children:[e(pi,{disabled:!n,type:"button",title:"Consultar agendamento",onClick:()=>{l(),r(O.CONSULTAPPOINTMENT.id)}}),e(pi,{disabled:!n,type:"button",title:"Fechar",onClick:a,secondary:!0})]}),children:t(an,{children:[e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warning.svg",alt:"warning"}),e("h3",{children:"Não é possível realizar seu agendamento no momento"}),t("div",{children:[e("p",{children:"Possíveis causas:"}),t("ul",{children:[e("li",{children:"Você já possui uma consulta agendada"}),e("li",{children:"Sistema indisponível"})]})]}),e("p",{className:"info",children:"Para consultar ou cancelar seu agendamento, acesse:"})]})})},on=m.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #555658;
  text-align: center;

  h3 {
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
    text-align: center;
    margin-top: 24px;
  }

  .info1 {
    color: #898b8e;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    margin-top: 24px;
  }

  .info2 {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    margin-top: 32px;
  }

  .phone-link {
    color: #004f92;
    font-weight: 600;
  }

  @media (min-width: 900px) {
    justify-content: space-between;
  }
`,ln=({visible:i,onClose:n})=>e(Ei,{visible:i,onClose:n,children:t(on,{children:[e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warning.svg",alt:"warning"}),e("h3",{children:"Não foi possível consultar sua elegibilidade"}),t("p",{className:"info1",children:["Não conseguimos consultar sua elegibilidade através desse canal, entre em contato com a central de atendimento:",e("br",{}),e("a",{className:"phone-link",href:"tel:01121510021",children:"(11) 2151-0021"})]}),e("p",{className:"info2",children:"De Segunda a Sexta, das 7:00 às 19:00. Exceto feriados."})]})}),dn=m.div`
  ${({visible:e})=>v`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: flex-end;
    height: var(--height-full);
    background: transparent;
    z-index: 25;
    opacity: ${e?1:0};
    pointer-events: ${e?"all":"none"};
    transition: opacity 250ms ease-in-out;
  `}
`,sn=m.div`
  ${({visible:e,isFull:t})=>v`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: flex-end;
    width: 100%;
    height: 100%;
    background: #00000066;
    z-index: 50;

    @media (min-width: 900px) {
      border-top-left-radius: 0;
      border-top-right-radius: 0;

      background: ${t?"transparent":"#00000066"};
    }
  `}
`,cn=()=>v`
    box-shadow: -8px 0px 24px #00000029;

    @media (min-width: 900px) {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  `,un=m.div`
  ${({visible:e,isFull:t})=>v`
    background: #fff;
    border-top-left-radius: 40px;
    border-top-right-radius: 40px;
    padding: 32px;
    transition: transform 250ms ease-in-out;
    z-index: 100;
    max-height: var(--height-full);
    overflow: auto;
    width: 100%;
    transform: ${e?"translateY(0)":"translateY(100%)"};
    text-align: center;
    ${t&&cn()}
  `}
`,pn=m.div`
  margin-top: 16px;
`,hn=({visible:i,onClose:n,children:a,withoutCloseButton:r=!1,buttonClosePrimary:o,isFull:l,...d})=>t(dn,{visible:i,children:[e(sn,{"aria-hidden":!i,"aria-label":"overlay",visible:i,onClick:n,isFull:l}),t(un,{visible:i,isFull:l,...d,onClick:()=>{},children:[a,!r&&e(pn,{children:e(pi,{title:"Fechar",type:"button",tertiary:!o,onClick:n})})]})]}),mn=m.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  & .title {
    font-weight: 500;
    font-size: 24px;
    color: var(--color-gray-500);
  }

  & .subtitle {
    font-weight: 500;
    font-size: 16px;
    color: var(--color-gray-400);
    text-align: center;
  }
`,gn=m.div`
  width: 100%;
  margin-top: 56px;
`,fn=({visible:i,documentType:n,onConfirmIdentity:a})=>e(hn,{visible:i,onClose:a,withoutCloseButton:!0,children:t(mn,{children:[e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warning.svg",alt:"warning"}),e("h3",{className:"title",children:`${n} já cadastrado`}),e("p",{className:"subtitle",children:`Para acessar a conta vinculada a esse ${n}, confirme sua identidade.`}),t(gn,{children:[e(pi,{disabled:!i,type:"button",title:"Confirmar identidade"}),e(pi,{disabled:!i,type:"button",title:"Continuar agendamento",tertiary:!0,onClick:a})]})]})}),vn=m.div`
  width: 100%;
  position: relative;

  .error-wrapper {
    margin-left: 16px;
  }

  .error-message {
    color: red;
    text-align: left;
  }
`,bn=m.label`
  ${({error:e,theme:t})=>v`
    position: absolute;
    top: -8px;
    left: 16px;
    font-weight: 500;
    font-size: 12px;
    background-color: var(--background-color);
    padding: 0 1px;
    color: ${e?t.colors.colorDanger:t.colors.blueEinstein};
  `}
`,yn=e=>v`
    border-color: ${e.colors.colorDanger};
  `,_n=e=>v`
    border-color: ${e.colors.blueEinstein};
  `,xn=m.div`
  ${({focus:e,theme:t,error:i})=>v`
    display: flex;
    align-items: center;

    height: 56px;
    width: 100%;
    color: #555658;
    background: #fff;
    outline: 0;
    border: 1px solid;
    border-color: ${t.colors.colorGray300};
    border-radius: 8px;
    cursor: pointer;

    ${i&&yn(t)}
    ${e&&_n(t)}
  `}

  .image {
    width: 24px;
    height: 24px;
    margin: 16px;
    margin-left: auto;
  }
`,Sn=m.p`
  margin-left: 16px;
  font-size: 16px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;

  .placeholder-text {
    color: #898b8e;
    opacity: 0.55;
  }
`,wn=m.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  margin-top: 8px;
  padding: 0 16px;

  color: #555658;
  background: #fff;
  outline: 0;
  border: 1px solid #d5d5d6;
  border-radius: 8px;
`,En=m.div`
  .option-text {
    font-size: 16px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
  }

  padding: 16px 0;
  cursor: pointer;
  width: 100%;

  & + & {
    border-top: 1px solid #d5d5d6;
  }
`,kn=({label:i,value:n,placeholder:r,options:o,error:l,onSelect:d})=>{const[s,c]=a(!1),u=s?r:n&&n.length>0?n:r;return t(vn,{children:[i&&n&&e(bn,{children:i}),t(xn,{focus:s,onClick:()=>c(!s),children:[e(Sn,{children:e("span",s||!n?{className:"placeholder-text",children:r}:{children:u})}),e("img",s?{className:"image",src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/arrow-up.svg",alt:"arrow-up"}:{className:"image",src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/arrow-down.svg",alt:"arrow-down"})]}),l&&e("div",{className:"error-wrapper",children:e("small",{className:"error-message",children:l})}),s&&e(wn,{children:o.map((t=>e(En,{onClick:()=>{c(!1),d(t)},children:e("div",{className:"option-text",children:t})},t)))})]})},Tn=m.div`
  .error-message {
    color: red;
    margin-left: 16px;
    text-align: left;
  }
`,In=e=>v`
    border: 1px solid ${e.colors.colorSuccess};
    ${Nn} {
      color: ${e.colors.colorSuccess};
    }
  `,Cn=e=>v`
    border: 1px solid ${e.colors.colorDanger};
  `,Pn=m.div`
  ${({isValid:e,isNotValid:t,theme:i})=>v`
    display: flex;
    align-items: center;
    /* position: relative; */
    background-color: #fff;
    border-radius: 8px;
    border: 1px solid #d5d5d6;
    position: relative;

    &:focus-within {
      border: 1px solid ${i.colors.blueEinstein};
      ${e&&In(i)}
      ${t&&Cn(i)}
    }

    ${t&&Cn(i)}
  `}
`,Nn=m.label`
  position: absolute;
  top: -8px;
  left: 16px;
  font-weight: 500;
  font-size: 12px;
  background-color: var(--background-color);
  padding: 0 1px;
  color: ${e=>e.isNotValid?"#EF4F4C":"var(--blue-einstein)"};
`,Mn=m.input`
  ${({icon:e,iconRight:t})=>v`
    height: 56px;
    width: 100%;
    color: #555658;
    background: #fff;
    outline: 0;
    border: 0;
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 24px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    border-radius: 8px;
    padding: 0 16px;
    padding-left: ${e?"0":"16px"};
    padding-right: ${t?"0":"16px"};
  `}

  &::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: #898b8e;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 16px;
  }
  &::-moz-placeholder {
    /* Firefox 19+ */
    color: #898b8e;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 16px;
  }
  &::-ms-input-placeholder {
    /* IE 10+ */
    color: #898b8e;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 16px;
  }
  &::-moz-placeholder {
    /* Firefox 18- */
    color: #898b8e;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 16px;
  }

  &[type='search'] {
    font-size: 18px;
    line-height: 26px;
    font-weight: 400;
  }
`,Dn=m.div`
  margin-top: 3px;
  margin-right: 16px;
  padding-left: 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  .icon {
    width: 16px;
    height: 16px;
  }
`,On=({clickOnIcon:i=(()=>{}),error:n,icon:r=null,label:o,value:l,onFocus:d,onBlur:s,iconRight:c,isValid:u,isNotValid:p,...h})=>{const[m,g]=a(!1);return t(Tn,{children:[t(Pn,{isFocus:m,isValid:!!u,isNotValid:!!p,children:[o&&l&&e(Nn,{isFocus:m,isValid:!!u,isNotValid:!!p,children:o}),!!r&&e(Dn,{onClick:()=>i(),children:r}),e(Mn,{value:l,...h,icon:!!r,iconRight:!!c,onKeyDown:e=>{"Enter"===e.key&&e.preventDefault()},onFocus:e=>{g(!0),d&&d(e)},onBlur:e=>{g(!1),s&&s(e)}}),!!c&&e(Dn,{onClick:()=>i(),children:c})]}),n&&e("small",{className:"error-message",children:n})]})},Rn=({error:t,label:n,value:a,onFocus:r,onBlur:o,filled:l,invalid:d,...s})=>{const c=!!t&&t.length>0;let u=null;return d&&(u=e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/invalid-icon.svg",alt:"invalid-icon"})),!d&&l&&(u=e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/valid-icon.svg",alt:"valid-icon"})),e(i,{children:e(On,{...s,value:a,label:n,iconRight:u,error:t,isNotValid:c||d,isValid:l&&!c})})},An=m.div`
  margin-top: 16px;
`,Ln=({setFieldValue:n,setFieldError:a,document:r,documentType:o,error:l,setIsValid:d,isValid:s,onConfirmIdentity:c,showConfirmIdentity:u})=>{function p(e){return"CPF"===e.toUpperCase()?"CPF":"Passaporte"}return t(i,{children:[e(An,{children:e(kn,{label:"Documento",placeholder:"Documento",value:p(o),onSelect:e=>{n("documentType",e),("CPF"===e||"Passaporte"===e)&&(n("document",""),a("document",""),d(!1))},options:["CPF","Passaporte"]})}),e(An,{children:e(Rn,{name:"document",id:"document",placeholder:`Digite seu ${p(o)}`,label:p(o),type:"text",filled:s&&!!r,invalid:!s&&!!r&&14===r.length,onChange:e=>{"CPF"===o?(e=>{const t=_t(e);n("document",t),pt(t)?(a("document",""),d(!0)):(t.length>0&&a("document","CPF inválido"),d(!1))})(e.target.value):"Passaporte"===o&&(e=>{const t=Et(e);n("document",t),ht(t)?(a("document",""),d(!0)):(t.length>0&&a("document","Passaporte inválido"),d(!1))})(e.target.value)},value:r,error:l})}),e(fn,{documentType:o,visible:u,onConfirmIdentity:c})]})},Un=m.label`
  div {
    display: block;
    position: relative;
    cursor: pointer;
    padding-left: 24px;
    margin-bottom: 20px;

    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }

    span {
      position: absolute;
      top: 0;
      left: 0;
      height: 24px;
      width: 24px;
      background-color: transparent;
      border: 1px solid #d5d5d6;
      border-radius: 100px;
    }

    input:checked ~ span {
      background-color: #004f92;
      border: none;
    }

    span:after {
      content: '';
      position: absolute;
      display: none;
      left: 10px;
      top: 6px;
      width: 3px;
      height: 8px;
      border: solid white;
      border-width: 0 2px 2px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }

    input:checked ~ span:after {
      display: block;
    }
  }
`,$n=({label:i,checked:n,onChange:a})=>t(Un,{children:[i,t("div",{children:[e("input",{name:"isGoing",type:"checkbox",checked:n,onChange:a}),e("span",{})]})]}),Fn=m.div`
  width: 100%;
`,Vn=({name:i,id:n,placeholder:a,onChange:r,value:o,options:l,error:d})=>t(Fn,{children:[e(On,{name:i,list:n,placeholder:a,onChange:r,value:o,error:d}),e("datalist",{id:n,children:l.map(((t,i)=>e("option",{value:t},i)))})]}),zn=m.form`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;

  & .info-wrapper {
    margin-bottom: 24px;
    margin-top: 32px;
  }
`,Hn=m.div`
  padding: 32px;
  height: 100%;
  overflow-y: auto;
`;m($n)`
  width: 100%;
`,m(Vn)`
  width: 100%;
`;const Bn=m.div`
  margin-top: 16px;
`,Gn=m.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: auto;
`,jn=({formik:a,validateGenderCatalogGenericRules:r})=>{const[o,l]=n.useState(!0);return t(i,{children:[e(Ln,{setFieldValue:a.setFieldValue,setFieldError:a.setFieldError,document:a.values.document,documentType:a.values.documentType,error:a.errors.document,setIsValid:l,isValid:o,onConfirmIdentity:()=>{},showConfirmIdentity:!1}),t(i,{children:[e(Bn,{children:e(kn,{value:a.values.citizenship,label:"Nacionalidade",placeholder:"Nacionalidade",options:["Brasileiro","Estrangeiro"],onSelect:e=>{a.setFieldValue("citizenship",e),a.setFieldError("citizenship","")},error:a.errors.citizenship})}),e(Bn,{children:e(On,{name:"name",id:"name",placeholder:"Nome",label:"Nome",onChange:e=>{const t=gt(e.target.value);a.setFieldValue("name",t),bt(t)?a.setFieldError("name",""):a.setFieldError("name","Digite nome completo")},value:a.values.name,error:a.errors.name})}),e(Bn,{children:e(On,{name:"birthDateDate",id:"birthDateDate",label:"Data de nascimento",placeholder:"Data de nascimento",maxLength:10,onChange:e=>{const t=(e=>{const t=e.replace(/[^\d]/g,""),{length:i}=t;return i<=4?e=t.replace(/(\d{2})(\d{1,2})/g,"$1/$2"):i<=9&&(e=t.replace(/(\d{2})(\d{2})(\d{1,4})/g,"$1/$2/$3")),e})(e.currentTarget.value);a.setFieldValue("birthDateDate",t);const i=vt(t);t.length<10||!i?a.setFieldError("birthDateDate","Data inválida"):(a.setFieldError("birthDateDate",""),a.setFieldValue("birthDate",i))},value:a.values.birthDateDate,error:a.errors.birthDateDate})}),e(Bn,{children:e(kn,{value:a.values.gender,label:"Sexo",placeholder:"Sexo",options:["Masculino","Feminino"],onSelect:e=>{a.setFieldValue("gender",e),a.setFieldError("gender",""),"Masculino"===e&&a.setFieldValue("pregnant","");r(e)||a.setFieldError("gender","O tipo de procedimento escolhido é somente para o sexo feminino")},error:a.errors.gender})}),"Feminino"===a.values.gender&&yt(a.values.birthDate,9)&&e(Bn,{children:e(kn,{value:a.values.pregnant,label:"Gestante",placeholder:"É gestante?",options:["Sim","Não"],onSelect:e=>{a.setFieldValue("pregnant",e),a.setFieldError("pregnant","")},error:a.errors.pregnant})}),e(Bn,{children:e(On,{name:"email",placeholder:"Email",label:"Email",type:"text",onChange:e=>{const t=e.target.value;a.setFieldValue("email",t),ft(t)?a.setFieldError("email",""):a.setFieldError("email","Digite um email válido")},value:a.values.email,error:a.errors.email})}),e(Bn,{children:e(On,{name:"phone",placeholder:"Telefone",label:"Telefone",type:"text",onChange:e=>{const t=St(e.target.value);a.setFieldValue("phone",t),t.length<13?a.setFieldError("phone","Telefone inválido"):a.setFieldError("phone","")},value:a.values.phone,error:a.errors.phone})})]})]})},qn=m.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  & .title {
    font-weight: 500;
    font-size: 24px;
    color: var(--color-gray-500);
    line-height: 32px;
    text-align: center;
    width: 308px;
  }

  & .subtitle {
    font-weight: 500;
    font-size: 16px;
    color: var(--color-gray-400);
    line-height: 24px;
    text-align: center;
  }
`,Wn=e=>e.find((e=>{return t=(null==e?void 0:e.rule_id)||"",process.env.REACT_APP_GENERIC_MODAL_RULEID===t;var t})),Yn=e=>e.find((e=>{return t=(null==e?void 0:e.rule_id)||"",process.env.REACT_APP_GENERIC_RULES_FRONT_RULEID===t;var t})),Xn=e=>{var t;return null===(t=e.find((e=>{return t=(null==e?void 0:e.rule_id)||"",process.env.REACT_APP_SERVICE_OPTIONS_TITLE_RULEID===t;var t})))||void 0===t?void 0:t.value},Kn=({genericModals:e,when:t,condition:i})=>e.find((e=>{if(Array.isArray(e.trigger.when)){if(e.trigger.when.some((e=>e===t))&&e.trigger.condition===i)return e}else if(e.trigger.when===t&&e.trigger.condition===i)return e}));function Qn(e){const t=Wn(e);if(null==t?void 0:t.value)return JSON.parse(t.value)}const Zn="https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/first-medical-appointment.svg",Jn="https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warning.svg",ea={is_first_appointment:Zn,always:Zn,schedule_consult:Zn,professional_without_schedule_available:Jn,diu_professional_without_schedule_available:Jn,open_whatsapp:Jn,unavailable_slots:Jn};function ta({icon:t,modalType:i}){return t?e("img",{src:t,alt:"modal illustration"}):i?e("img",{src:ea[i],alt:"image"}):null}const ia=({visible:a,isVisible:r,when:o,handleActionButton:l,condition:d})=>{const{genericModals:s}=ct(),[c,u]=n.useState(null),[p,h]=n.useState("");function m(){r(!1)}return n.useEffect((()=>{if(o&&d&&a){const t=s?(e={when:o,condition:d,genericModals:s}).genericModals.find((t=>{if(Array.isArray(t.trigger.when)){if(t.trigger.when.some((t=>t===e.when))&&t.trigger.condition===e.condition)return t}else if(t.trigger.when===e.when&&t.trigger.condition===e.condition)return t})):void 0;(null==t?void 0:t.content)&&(h(t.trigger.condition),u(t.content)),(null==t?void 0:t.content)||(u(null),m(),console.error(`Modal (when:${o} | condition: ${d}) not configured.`))}var e}),[s,a,d]),e(Ei,{visible:a,onClose:m,withoutCloseButton:!0,childrenFooter:c&&t(i,{children:[c.primary_button&&e(pi,{disabled:!a,type:"button",title:c.primary_button.text||"Confirmar",onClick:()=>function(e){l&&e.primary_button&&l(e.primary_button.action||"",e.primary_button.value)}(c)}),c.second_button&&e(pi,{disabled:!a,type:"button",title:c.second_button.text||"Cancelar",onClick:()=>function(e){l&&e.second_button&&l(e.second_button.action||"",e.second_button.value)}(c),tertiary:!0})]}),children:c&&t(qn,{children:[e(ta,{icon:c.icon,modalType:p}),e("h3",{className:"title",children:c.title}),e("p",{className:"subtitle",dangerouslySetInnerHTML:{__html:c.body}})]})})},na={ok:"ok",is_first_appointment:Q,only_telemedicine:"only_telemedicine"},aa=({goTo:e,openModal:t})=>{function i(e){var t;if(1===(null===(t=null==e?void 0:e.coverages)||void 0===t?void 0:t.length)){const[t]=e.coverages;if(t.care_type===se)return{type:na.only_telemedicine,coverage:t}}return null}function n(i){const n={is_first_appointment:()=>({type:Q}),ok:()=>(e(O.SERVICE_TYPE_PAGE.id),{type:na.ok}),default:()=>{t(Hi.PRODUCT_NOT_COVERED)}};return i?n[i]():n.default()}return{routeScheduleByProduct:function(e,t,a){var r,o;if(null===(r=e.coverages)||void 0===r?void 0:r.length){if(!e.is_b2b)return n(na.ok);if(e.is_b2b&&t){const t=i(e);if(t)return t;if(!t)return n(na.ok)}if(e.is_b2b&&!t){if(null==a?void 0:a.length){if((o={condition:Q,genericModals:a}).genericModals.find((e=>{if(e.trigger.condition===o.condition)return e})))return n(na.is_first_appointment)}return n(na.ok)}}return n()},handleTelemedicineProduct:i}};function ra({changeSchedule:e,selectedSchedule:t}){const[i,a]=n.useState({}),r=pe(i);return{addPatient:function(e){a(r.setPatient(e))},addProduct:function(e){a(r.setProduct(e))},addCareType:function(e){a(r.setScheduleType({careType:e}))},addPayment:function(e){a(r.setPayment(e))},addUnit:function(e){a(r.setUnit(e.unit,e.localId))},addSlotsOptions:function(e){a(r.setSlotsOptions(e))},addResource:function(e,t){a(r.setResource(e,t))},updateSchedule:function(){e({...t,...r.build()})},validateSchedule:function(){e(r.validateSchedule())},schedule:i,addChannel:function(e){a(r.setChannel(e))},resetPayment:function(){a(r.setPayment(void 0))}}}var oa,la,da,sa,ca,ua;!function(e){e.TELEORIENTATION="TELEORIENTATION"}(oa||(oa={})),function(e){e[e.NOT_PROVIDED=1]="NOT_PROVIDED",e[e.CALL_CENTER=2]="CALL_CENTER",e[e.CONECTA=3]="CONECTA",e[e.LOGGEDOUT_PLATFORM=4]="LOGGEDOUT_PLATFORM",e[e.QSAUDE_APP=5]="QSAUDE_APP",e[e.SCHEDULE_PLATFORM_MOBILE=6]="SCHEDULE_PLATFORM_MOBILE",e[e.SCHEDULE_PLATFORM_WEB=7]="SCHEDULE_PLATFORM_WEB",e[e.WHATSAPP=8]="WHATSAPP"}(la||(la={})),function(e){e[e.CLINIC_WEB=1]="CLINIC_WEB",e[e.SGH=2]="SGH",e[e.TELEMEDICINE_B2C=3]="TELEMEDICINE_B2C",e[e.WISE=4]="WISE",e[e.MDA_SCHEDULE=5]="MDA_SCHEDULE",e[e.SALES_FORCE=6]="SALES_FORCE"}(da||(da={})),function(e){e[e.PROCEDURE=1]="PROCEDURE",e[e.EXAM=2]="EXAM",e[e.CONSULTATION=3]="CONSULTATION",e[e.IMMUNIZATION=4]="IMMUNIZATION"}(sa||(sa={})),function(e){e[e.TELEMEDICINE=1]="TELEMEDICINE",e[e.PRESENTIAL=2]="PRESENTIAL",e[e.EINSTEIN_TO_YOU=3]="EINSTEIN_TO_YOU",e[e["DRIVE-THRU"]=4]="DRIVE-THRU"}(ca||(ca={})),function(e){e[e.PARTICULAR=1]="PARTICULAR",e[e.B2B=2]="B2B",e[e.HEALTH_INSURANCE=3]="HEALTH_INSURANCE"}(ua||(ua={}));const pa=async({unitId:e,itemId:t,isKit:i,startDate:n,endDate:a,resourceId:r,localId:o})=>{let l={unitId:e,itemId:t,isKit:i,startDate:n,endDate:a,resourceId:r};o&&(l={...l,localId:o});const d=await Te.get("slots/dates",{params:l}),{data:s}=d;return s},ha=async e=>{const t={error:!1,errorStatus:null,message:"",data:[]};try{const i=await Pe.get("slots",{params:{findThreeDates:!0,...e}});return t.data=i.data.slots,t}catch(e){return p.error("Sem horários disponíveis."),console.error(e),t.error=!0,t}};function ma(e){if(null===e||!0===e||!1===e)return NaN;var t=Number(e);return isNaN(t)?t:t<0?Math.ceil(t):Math.floor(t)}function ga(e,t){if(t.length<e)throw new TypeError(e+" argument"+(e>1?"s":"")+" required, but only "+t.length+" present")}function fa(e){return fa="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},fa(e)}function va(e){ga(1,arguments);var t=Object.prototype.toString.call(e);return e instanceof Date||"object"===fa(e)&&"[object Date]"===t?new Date(e.getTime()):"number"==typeof e||"[object Number]"===t?new Date(e):("string"!=typeof e&&"[object String]"!==t||"undefined"==typeof console||(console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"),console.warn((new Error).stack)),new Date(NaN))}function ba(e){return function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},i=t.width?String(t.width):e.defaultWidth,n=e.formats[i]||e.formats[e.defaultWidth];return n}}function ya(e){return function(t,i){var n;if("formatting"===(null!=i&&i.context?String(i.context):"standalone")&&e.formattingValues){var a=e.defaultFormattingWidth||e.defaultWidth,r=null!=i&&i.width?String(i.width):a;n=e.formattingValues[r]||e.formattingValues[a]}else{var o=e.defaultWidth,l=null!=i&&i.width?String(i.width):e.defaultWidth;n=e.values[l]||e.values[o]}return n[e.argumentCallback?e.argumentCallback(t):t]}}function _a(e){return function(t){var i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=i.width,a=n&&e.matchPatterns[n]||e.matchPatterns[e.defaultMatchWidth],r=t.match(a);if(!r)return null;var o,l=r[0],d=n&&e.parsePatterns[n]||e.parsePatterns[e.defaultParseWidth],s=Array.isArray(d)?Sa(d,(function(e){return e.test(l)})):xa(d,(function(e){return e.test(l)}));o=e.valueCallback?e.valueCallback(s):s,o=i.valueCallback?i.valueCallback(o):o;var c=t.slice(l.length);return{value:o,rest:c}}}function xa(e,t){for(var i in e)if(e.hasOwnProperty(i)&&t(e[i]))return i}function Sa(e,t){for(var i=0;i<e.length;i++)if(t(e[i]))return i}function wa(e){return function(t){var i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=t.match(e.matchPattern);if(!n)return null;var a=n[0],r=t.match(e.parsePattern);if(!r)return null;var o=e.valueCallback?e.valueCallback(r[0]):r[0];o=i.valueCallback?i.valueCallback(o):o;var l=t.slice(a.length);return{value:o,rest:l}}}function Ea(e,t){ga(2,arguments);var i=va(e).getTime(),n=ma(t);return new Date(i+n)}var ka={};function Ta(){return ka}function Ia(e){var t=new Date(Date.UTC(e.getFullYear(),e.getMonth(),e.getDate(),e.getHours(),e.getMinutes(),e.getSeconds(),e.getMilliseconds()));return t.setUTCFullYear(e.getFullYear()),e.getTime()-t.getTime()}function Ca(e){return Ca="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},Ca(e)}function Pa(e){return ga(1,arguments),e instanceof Date||"object"===Ca(e)&&"[object Date]"===Object.prototype.toString.call(e)}function Na(e){if(ga(1,arguments),!Pa(e)&&"number"!=typeof e)return!1;var t=va(e);return!isNaN(Number(t))}function Ma(e,t){ga(2,arguments);var i=ma(t);return Ea(e,-i)}var Da=864e5;function Oa(e){ga(1,arguments);var t=1,i=va(e),n=i.getUTCDay(),a=(n<t?7:0)+n-t;return i.setUTCDate(i.getUTCDate()-a),i.setUTCHours(0,0,0,0),i}function Ra(e){ga(1,arguments);var t=va(e),i=t.getUTCFullYear(),n=new Date(0);n.setUTCFullYear(i+1,0,4),n.setUTCHours(0,0,0,0);var a=Oa(n),r=new Date(0);r.setUTCFullYear(i,0,4),r.setUTCHours(0,0,0,0);var o=Oa(r);return t.getTime()>=a.getTime()?i+1:t.getTime()>=o.getTime()?i:i-1}function Aa(e){ga(1,arguments);var t=Ra(e),i=new Date(0);i.setUTCFullYear(t,0,4),i.setUTCHours(0,0,0,0);var n=Oa(i);return n}var La=6048e5;function Ua(e,t){var i,n,a,r,o,l,d,s;ga(1,arguments);var c=Ta(),u=ma(null!==(i=null!==(n=null!==(a=null!==(r=null==t?void 0:t.weekStartsOn)&&void 0!==r?r:null==t||null===(o=t.locale)||void 0===o||null===(l=o.options)||void 0===l?void 0:l.weekStartsOn)&&void 0!==a?a:c.weekStartsOn)&&void 0!==n?n:null===(d=c.locale)||void 0===d||null===(s=d.options)||void 0===s?void 0:s.weekStartsOn)&&void 0!==i?i:0);if(!(u>=0&&u<=6))throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");var p=va(e),h=p.getUTCDay(),m=(h<u?7:0)+h-u;return p.setUTCDate(p.getUTCDate()-m),p.setUTCHours(0,0,0,0),p}function $a(e,t){var i,n,a,r,o,l,d,s;ga(1,arguments);var c=va(e),u=c.getUTCFullYear(),p=Ta(),h=ma(null!==(i=null!==(n=null!==(a=null!==(r=null==t?void 0:t.firstWeekContainsDate)&&void 0!==r?r:null==t||null===(o=t.locale)||void 0===o||null===(l=o.options)||void 0===l?void 0:l.firstWeekContainsDate)&&void 0!==a?a:p.firstWeekContainsDate)&&void 0!==n?n:null===(d=p.locale)||void 0===d||null===(s=d.options)||void 0===s?void 0:s.firstWeekContainsDate)&&void 0!==i?i:1);if(!(h>=1&&h<=7))throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");var m=new Date(0);m.setUTCFullYear(u+1,0,h),m.setUTCHours(0,0,0,0);var g=Ua(m,t),f=new Date(0);f.setUTCFullYear(u,0,h),f.setUTCHours(0,0,0,0);var v=Ua(f,t);return c.getTime()>=g.getTime()?u+1:c.getTime()>=v.getTime()?u:u-1}function Fa(e,t){var i,n,a,r,o,l,d,s;ga(1,arguments);var c=Ta(),u=ma(null!==(i=null!==(n=null!==(a=null!==(r=null==t?void 0:t.firstWeekContainsDate)&&void 0!==r?r:null==t||null===(o=t.locale)||void 0===o||null===(l=o.options)||void 0===l?void 0:l.firstWeekContainsDate)&&void 0!==a?a:c.firstWeekContainsDate)&&void 0!==n?n:null===(d=c.locale)||void 0===d||null===(s=d.options)||void 0===s?void 0:s.firstWeekContainsDate)&&void 0!==i?i:1),p=$a(e,t),h=new Date(0);h.setUTCFullYear(p,0,u),h.setUTCHours(0,0,0,0);var m=Ua(h,t);return m}var Va=6048e5;function za(e,t){for(var i=e<0?"-":"",n=Math.abs(e).toString();n.length<t;)n="0"+n;return i+n}var Ha={y:function(e,t){var i=e.getUTCFullYear(),n=i>0?i:1-i;return za("yy"===t?n%100:n,t.length)},M:function(e,t){var i=e.getUTCMonth();return"M"===t?String(i+1):za(i+1,2)},d:function(e,t){return za(e.getUTCDate(),t.length)},a:function(e,t){var i=e.getUTCHours()/12>=1?"pm":"am";switch(t){case"a":case"aa":return i.toUpperCase();case"aaa":return i;case"aaaaa":return i[0];default:return"am"===i?"a.m.":"p.m."}},h:function(e,t){return za(e.getUTCHours()%12||12,t.length)},H:function(e,t){return za(e.getUTCHours(),t.length)},m:function(e,t){return za(e.getUTCMinutes(),t.length)},s:function(e,t){return za(e.getUTCSeconds(),t.length)},S:function(e,t){var i=t.length,n=e.getUTCMilliseconds();return za(Math.floor(n*Math.pow(10,i-3)),t.length)}},Ba="midnight",Ga="noon",ja="morning",qa="afternoon",Wa="evening",Ya="night",Xa={G:function(e,t,i){var n=e.getUTCFullYear()>0?1:0;switch(t){case"G":case"GG":case"GGG":return i.era(n,{width:"abbreviated"});case"GGGGG":return i.era(n,{width:"narrow"});default:return i.era(n,{width:"wide"})}},y:function(e,t,i){if("yo"===t){var n=e.getUTCFullYear(),a=n>0?n:1-n;return i.ordinalNumber(a,{unit:"year"})}return Ha.y(e,t)},Y:function(e,t,i,n){var a=$a(e,n),r=a>0?a:1-a;return"YY"===t?za(r%100,2):"Yo"===t?i.ordinalNumber(r,{unit:"year"}):za(r,t.length)},R:function(e,t){return za(Ra(e),t.length)},u:function(e,t){return za(e.getUTCFullYear(),t.length)},Q:function(e,t,i){var n=Math.ceil((e.getUTCMonth()+1)/3);switch(t){case"Q":return String(n);case"QQ":return za(n,2);case"Qo":return i.ordinalNumber(n,{unit:"quarter"});case"QQQ":return i.quarter(n,{width:"abbreviated",context:"formatting"});case"QQQQQ":return i.quarter(n,{width:"narrow",context:"formatting"});default:return i.quarter(n,{width:"wide",context:"formatting"})}},q:function(e,t,i){var n=Math.ceil((e.getUTCMonth()+1)/3);switch(t){case"q":return String(n);case"qq":return za(n,2);case"qo":return i.ordinalNumber(n,{unit:"quarter"});case"qqq":return i.quarter(n,{width:"abbreviated",context:"standalone"});case"qqqqq":return i.quarter(n,{width:"narrow",context:"standalone"});default:return i.quarter(n,{width:"wide",context:"standalone"})}},M:function(e,t,i){var n=e.getUTCMonth();switch(t){case"M":case"MM":return Ha.M(e,t);case"Mo":return i.ordinalNumber(n+1,{unit:"month"});case"MMM":return i.month(n,{width:"abbreviated",context:"formatting"});case"MMMMM":return i.month(n,{width:"narrow",context:"formatting"});default:return i.month(n,{width:"wide",context:"formatting"})}},L:function(e,t,i){var n=e.getUTCMonth();switch(t){case"L":return String(n+1);case"LL":return za(n+1,2);case"Lo":return i.ordinalNumber(n+1,{unit:"month"});case"LLL":return i.month(n,{width:"abbreviated",context:"standalone"});case"LLLLL":return i.month(n,{width:"narrow",context:"standalone"});default:return i.month(n,{width:"wide",context:"standalone"})}},w:function(e,t,i,n){var a=function(e,t){ga(1,arguments);var i=va(e),n=Ua(i,t).getTime()-Fa(i,t).getTime();return Math.round(n/Va)+1}(e,n);return"wo"===t?i.ordinalNumber(a,{unit:"week"}):za(a,t.length)},I:function(e,t,i){var n=function(e){ga(1,arguments);var t=va(e),i=Oa(t).getTime()-Aa(t).getTime();return Math.round(i/La)+1}(e);return"Io"===t?i.ordinalNumber(n,{unit:"week"}):za(n,t.length)},d:function(e,t,i){return"do"===t?i.ordinalNumber(e.getUTCDate(),{unit:"date"}):Ha.d(e,t)},D:function(e,t,i){var n=function(e){ga(1,arguments);var t=va(e),i=t.getTime();t.setUTCMonth(0,1),t.setUTCHours(0,0,0,0);var n=t.getTime(),a=i-n;return Math.floor(a/Da)+1}(e);return"Do"===t?i.ordinalNumber(n,{unit:"dayOfYear"}):za(n,t.length)},E:function(e,t,i){var n=e.getUTCDay();switch(t){case"E":case"EE":case"EEE":return i.day(n,{width:"abbreviated",context:"formatting"});case"EEEEE":return i.day(n,{width:"narrow",context:"formatting"});case"EEEEEE":return i.day(n,{width:"short",context:"formatting"});default:return i.day(n,{width:"wide",context:"formatting"})}},e:function(e,t,i,n){var a=e.getUTCDay(),r=(a-n.weekStartsOn+8)%7||7;switch(t){case"e":return String(r);case"ee":return za(r,2);case"eo":return i.ordinalNumber(r,{unit:"day"});case"eee":return i.day(a,{width:"abbreviated",context:"formatting"});case"eeeee":return i.day(a,{width:"narrow",context:"formatting"});case"eeeeee":return i.day(a,{width:"short",context:"formatting"});default:return i.day(a,{width:"wide",context:"formatting"})}},c:function(e,t,i,n){var a=e.getUTCDay(),r=(a-n.weekStartsOn+8)%7||7;switch(t){case"c":return String(r);case"cc":return za(r,t.length);case"co":return i.ordinalNumber(r,{unit:"day"});case"ccc":return i.day(a,{width:"abbreviated",context:"standalone"});case"ccccc":return i.day(a,{width:"narrow",context:"standalone"});case"cccccc":return i.day(a,{width:"short",context:"standalone"});default:return i.day(a,{width:"wide",context:"standalone"})}},i:function(e,t,i){var n=e.getUTCDay(),a=0===n?7:n;switch(t){case"i":return String(a);case"ii":return za(a,t.length);case"io":return i.ordinalNumber(a,{unit:"day"});case"iii":return i.day(n,{width:"abbreviated",context:"formatting"});case"iiiii":return i.day(n,{width:"narrow",context:"formatting"});case"iiiiii":return i.day(n,{width:"short",context:"formatting"});default:return i.day(n,{width:"wide",context:"formatting"})}},a:function(e,t,i){var n=e.getUTCHours()/12>=1?"pm":"am";switch(t){case"a":case"aa":return i.dayPeriod(n,{width:"abbreviated",context:"formatting"});case"aaa":return i.dayPeriod(n,{width:"abbreviated",context:"formatting"}).toLowerCase();case"aaaaa":return i.dayPeriod(n,{width:"narrow",context:"formatting"});default:return i.dayPeriod(n,{width:"wide",context:"formatting"})}},b:function(e,t,i){var n,a=e.getUTCHours();switch(n=12===a?Ga:0===a?Ba:a/12>=1?"pm":"am",t){case"b":case"bb":return i.dayPeriod(n,{width:"abbreviated",context:"formatting"});case"bbb":return i.dayPeriod(n,{width:"abbreviated",context:"formatting"}).toLowerCase();case"bbbbb":return i.dayPeriod(n,{width:"narrow",context:"formatting"});default:return i.dayPeriod(n,{width:"wide",context:"formatting"})}},B:function(e,t,i){var n,a=e.getUTCHours();switch(n=a>=17?Wa:a>=12?qa:a>=4?ja:Ya,t){case"B":case"BB":case"BBB":return i.dayPeriod(n,{width:"abbreviated",context:"formatting"});case"BBBBB":return i.dayPeriod(n,{width:"narrow",context:"formatting"});default:return i.dayPeriod(n,{width:"wide",context:"formatting"})}},h:function(e,t,i){if("ho"===t){var n=e.getUTCHours()%12;return 0===n&&(n=12),i.ordinalNumber(n,{unit:"hour"})}return Ha.h(e,t)},H:function(e,t,i){return"Ho"===t?i.ordinalNumber(e.getUTCHours(),{unit:"hour"}):Ha.H(e,t)},K:function(e,t,i){var n=e.getUTCHours()%12;return"Ko"===t?i.ordinalNumber(n,{unit:"hour"}):za(n,t.length)},k:function(e,t,i){var n=e.getUTCHours();return 0===n&&(n=24),"ko"===t?i.ordinalNumber(n,{unit:"hour"}):za(n,t.length)},m:function(e,t,i){return"mo"===t?i.ordinalNumber(e.getUTCMinutes(),{unit:"minute"}):Ha.m(e,t)},s:function(e,t,i){return"so"===t?i.ordinalNumber(e.getUTCSeconds(),{unit:"second"}):Ha.s(e,t)},S:function(e,t){return Ha.S(e,t)},X:function(e,t,i,n){var a=(n._originalDate||e).getTimezoneOffset();if(0===a)return"Z";switch(t){case"X":return Qa(a);case"XXXX":case"XX":return Za(a);default:return Za(a,":")}},x:function(e,t,i,n){var a=(n._originalDate||e).getTimezoneOffset();switch(t){case"x":return Qa(a);case"xxxx":case"xx":return Za(a);default:return Za(a,":")}},O:function(e,t,i,n){var a=(n._originalDate||e).getTimezoneOffset();switch(t){case"O":case"OO":case"OOO":return"GMT"+Ka(a,":");default:return"GMT"+Za(a,":")}},z:function(e,t,i,n){var a=(n._originalDate||e).getTimezoneOffset();switch(t){case"z":case"zz":case"zzz":return"GMT"+Ka(a,":");default:return"GMT"+Za(a,":")}},t:function(e,t,i,n){var a=n._originalDate||e;return za(Math.floor(a.getTime()/1e3),t.length)},T:function(e,t,i,n){return za((n._originalDate||e).getTime(),t.length)}};function Ka(e,t){var i=e>0?"-":"+",n=Math.abs(e),a=Math.floor(n/60),r=n%60;if(0===r)return i+String(a);var o=t||"";return i+String(a)+o+za(r,2)}function Qa(e,t){return e%60==0?(e>0?"-":"+")+za(Math.abs(e)/60,2):Za(e,t)}function Za(e,t){var i=t||"",n=e>0?"-":"+",a=Math.abs(e);return n+za(Math.floor(a/60),2)+i+za(a%60,2)}var Ja=Xa,er=function(e,t){switch(e){case"P":return t.date({width:"short"});case"PP":return t.date({width:"medium"});case"PPP":return t.date({width:"long"});default:return t.date({width:"full"})}},tr=function(e,t){switch(e){case"p":return t.time({width:"short"});case"pp":return t.time({width:"medium"});case"ppp":return t.time({width:"long"});default:return t.time({width:"full"})}},ir={p:tr,P:function(e,t){var i,n=e.match(/(P+)(p+)?/)||[],a=n[1],r=n[2];if(!r)return er(e,t);switch(a){case"P":i=t.dateTime({width:"short"});break;case"PP":i=t.dateTime({width:"medium"});break;case"PPP":i=t.dateTime({width:"long"});break;default:i=t.dateTime({width:"full"})}return i.replace("{{date}}",er(a,t)).replace("{{time}}",tr(r,t))}},nr=ir,ar=["D","DD"],rr=["YY","YYYY"];function or(e){return-1!==ar.indexOf(e)}function lr(e){return-1!==rr.indexOf(e)}function dr(e,t,i){if("YYYY"===e)throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t,"`) for formatting years to the input `").concat(i,"`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));if("YY"===e)throw new RangeError("Use `yy` instead of `YY` (in `".concat(t,"`) for formatting years to the input `").concat(i,"`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));if("D"===e)throw new RangeError("Use `d` instead of `D` (in `".concat(t,"`) for formatting days of the month to the input `").concat(i,"`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));if("DD"===e)throw new RangeError("Use `dd` instead of `DD` (in `".concat(t,"`) for formatting days of the month to the input `").concat(i,"`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"))}var sr={lessThanXSeconds:{one:"less than a second",other:"less than {{count}} seconds"},xSeconds:{one:"1 second",other:"{{count}} seconds"},halfAMinute:"half a minute",lessThanXMinutes:{one:"less than a minute",other:"less than {{count}} minutes"},xMinutes:{one:"1 minute",other:"{{count}} minutes"},aboutXHours:{one:"about 1 hour",other:"about {{count}} hours"},xHours:{one:"1 hour",other:"{{count}} hours"},xDays:{one:"1 day",other:"{{count}} days"},aboutXWeeks:{one:"about 1 week",other:"about {{count}} weeks"},xWeeks:{one:"1 week",other:"{{count}} weeks"},aboutXMonths:{one:"about 1 month",other:"about {{count}} months"},xMonths:{one:"1 month",other:"{{count}} months"},aboutXYears:{one:"about 1 year",other:"about {{count}} years"},xYears:{one:"1 year",other:"{{count}} years"},overXYears:{one:"over 1 year",other:"over {{count}} years"},almostXYears:{one:"almost 1 year",other:"almost {{count}} years"}},cr=function(e,t,i){var n,a=sr[e];return n="string"==typeof a?a:1===t?a.one:a.other.replace("{{count}}",t.toString()),null!=i&&i.addSuffix?i.comparison&&i.comparison>0?"in "+n:n+" ago":n},ur={date:ba({formats:{full:"EEEE, MMMM do, y",long:"MMMM do, y",medium:"MMM d, y",short:"MM/dd/yyyy"},defaultWidth:"full"}),time:ba({formats:{full:"h:mm:ss a zzzz",long:"h:mm:ss a z",medium:"h:mm:ss a",short:"h:mm a"},defaultWidth:"full"}),dateTime:ba({formats:{full:"{{date}} 'at' {{time}}",long:"{{date}} 'at' {{time}}",medium:"{{date}}, {{time}}",short:"{{date}}, {{time}}"},defaultWidth:"full"})},pr={lastWeek:"'last' eeee 'at' p",yesterday:"'yesterday at' p",today:"'today at' p",tomorrow:"'tomorrow at' p",nextWeek:"eeee 'at' p",other:"P"},hr=function(e,t,i,n){return pr[e]},mr={ordinalNumber:function(e,t){var i=Number(e),n=i%100;if(n>20||n<10)switch(n%10){case 1:return i+"st";case 2:return i+"nd";case 3:return i+"rd"}return i+"th"},era:ya({values:{narrow:["B","A"],abbreviated:["BC","AD"],wide:["Before Christ","Anno Domini"]},defaultWidth:"wide"}),quarter:ya({values:{narrow:["1","2","3","4"],abbreviated:["Q1","Q2","Q3","Q4"],wide:["1st quarter","2nd quarter","3rd quarter","4th quarter"]},defaultWidth:"wide",argumentCallback:function(e){return e-1}}),month:ya({values:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],abbreviated:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],wide:["January","February","March","April","May","June","July","August","September","October","November","December"]},defaultWidth:"wide"}),day:ya({values:{narrow:["S","M","T","W","T","F","S"],short:["Su","Mo","Tu","We","Th","Fr","Sa"],abbreviated:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],wide:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},defaultWidth:"wide"}),dayPeriod:ya({values:{narrow:{am:"a",pm:"p",midnight:"mi",noon:"n",morning:"morning",afternoon:"afternoon",evening:"evening",night:"night"},abbreviated:{am:"AM",pm:"PM",midnight:"midnight",noon:"noon",morning:"morning",afternoon:"afternoon",evening:"evening",night:"night"},wide:{am:"a.m.",pm:"p.m.",midnight:"midnight",noon:"noon",morning:"morning",afternoon:"afternoon",evening:"evening",night:"night"}},defaultWidth:"wide",formattingValues:{narrow:{am:"a",pm:"p",midnight:"mi",noon:"n",morning:"in the morning",afternoon:"in the afternoon",evening:"in the evening",night:"at night"},abbreviated:{am:"AM",pm:"PM",midnight:"midnight",noon:"noon",morning:"in the morning",afternoon:"in the afternoon",evening:"in the evening",night:"at night"},wide:{am:"a.m.",pm:"p.m.",midnight:"midnight",noon:"noon",morning:"in the morning",afternoon:"in the afternoon",evening:"in the evening",night:"at night"}},defaultFormattingWidth:"wide"})},gr={ordinalNumber:wa({matchPattern:/^(\d+)(th|st|nd|rd)?/i,parsePattern:/\d+/i,valueCallback:function(e){return parseInt(e,10)}}),era:_a({matchPatterns:{narrow:/^(b|a)/i,abbreviated:/^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,wide:/^(before christ|before common era|anno domini|common era)/i},defaultMatchWidth:"wide",parsePatterns:{any:[/^b/i,/^(a|c)/i]},defaultParseWidth:"any"}),quarter:_a({matchPatterns:{narrow:/^[1234]/i,abbreviated:/^q[1234]/i,wide:/^[1234](th|st|nd|rd)? quarter/i},defaultMatchWidth:"wide",parsePatterns:{any:[/1/i,/2/i,/3/i,/4/i]},defaultParseWidth:"any",valueCallback:function(e){return e+1}}),month:_a({matchPatterns:{narrow:/^[jfmasond]/i,abbreviated:/^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,wide:/^(january|february|march|april|may|june|july|august|september|october|november|december)/i},defaultMatchWidth:"wide",parsePatterns:{narrow:[/^j/i,/^f/i,/^m/i,/^a/i,/^m/i,/^j/i,/^j/i,/^a/i,/^s/i,/^o/i,/^n/i,/^d/i],any:[/^ja/i,/^f/i,/^mar/i,/^ap/i,/^may/i,/^jun/i,/^jul/i,/^au/i,/^s/i,/^o/i,/^n/i,/^d/i]},defaultParseWidth:"any"}),day:_a({matchPatterns:{narrow:/^[smtwf]/i,short:/^(su|mo|tu|we|th|fr|sa)/i,abbreviated:/^(sun|mon|tue|wed|thu|fri|sat)/i,wide:/^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i},defaultMatchWidth:"wide",parsePatterns:{narrow:[/^s/i,/^m/i,/^t/i,/^w/i,/^t/i,/^f/i,/^s/i],any:[/^su/i,/^m/i,/^tu/i,/^w/i,/^th/i,/^f/i,/^sa/i]},defaultParseWidth:"any"}),dayPeriod:_a({matchPatterns:{narrow:/^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,any:/^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i},defaultMatchWidth:"any",parsePatterns:{any:{am:/^a/i,pm:/^p/i,midnight:/^mi/i,noon:/^no/i,morning:/morning/i,afternoon:/afternoon/i,evening:/evening/i,night:/night/i}},defaultParseWidth:"any"})},fr={code:"en-US",formatDistance:cr,formatLong:ur,formatRelative:hr,localize:mr,match:gr,options:{weekStartsOn:0,firstWeekContainsDate:1}},vr=/[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,br=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,yr=/^'([^]*?)'?$/,_r=/''/g,xr=/[a-zA-Z]/;function Sr(e,t,i){var n,a,r,o,l,d,s,c,u,p,h,m,g,f,v,b,y,_;ga(2,arguments);var x=String(t),S=Ta(),w=null!==(n=null!==(a=null==i?void 0:i.locale)&&void 0!==a?a:S.locale)&&void 0!==n?n:fr,E=ma(null!==(r=null!==(o=null!==(l=null!==(d=null==i?void 0:i.firstWeekContainsDate)&&void 0!==d?d:null==i||null===(s=i.locale)||void 0===s||null===(c=s.options)||void 0===c?void 0:c.firstWeekContainsDate)&&void 0!==l?l:S.firstWeekContainsDate)&&void 0!==o?o:null===(u=S.locale)||void 0===u||null===(p=u.options)||void 0===p?void 0:p.firstWeekContainsDate)&&void 0!==r?r:1);if(!(E>=1&&E<=7))throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");var k=ma(null!==(h=null!==(m=null!==(g=null!==(f=null==i?void 0:i.weekStartsOn)&&void 0!==f?f:null==i||null===(v=i.locale)||void 0===v||null===(b=v.options)||void 0===b?void 0:b.weekStartsOn)&&void 0!==g?g:S.weekStartsOn)&&void 0!==m?m:null===(y=S.locale)||void 0===y||null===(_=y.options)||void 0===_?void 0:_.weekStartsOn)&&void 0!==h?h:0);if(!(k>=0&&k<=6))throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");if(!w.localize)throw new RangeError("locale must contain localize property");if(!w.formatLong)throw new RangeError("locale must contain formatLong property");var T=va(e);if(!Na(T))throw new RangeError("Invalid time value");var I=Ia(T),C=Ma(T,I),P={firstWeekContainsDate:E,weekStartsOn:k,locale:w,_originalDate:T},N=x.match(br).map((function(e){var t=e[0];return"p"===t||"P"===t?(0,nr[t])(e,w.formatLong):e})).join("").match(vr).map((function(n){if("''"===n)return"'";var a=n[0];if("'"===a)return wr(n);var r=Ja[a];if(r)return null!=i&&i.useAdditionalWeekYearTokens||!lr(n)||dr(n,t,String(e)),null!=i&&i.useAdditionalDayOfYearTokens||!or(n)||dr(n,t,String(e)),r(C,n,w.localize,P);if(a.match(xr))throw new RangeError("Format string contains an unescaped latin alphabet character `"+a+"`");return n})).join("");return N}function wr(e){var t=e.match(yr);return t?t[1].replace(_r,"'"):e}var Er={lessThanXSeconds:{one:"menos de um segundo",other:"menos de {{count}} segundos"},xSeconds:{one:"1 segundo",other:"{{count}} segundos"},halfAMinute:"meio minuto",lessThanXMinutes:{one:"menos de um minuto",other:"menos de {{count}} minutos"},xMinutes:{one:"1 minuto",other:"{{count}} minutos"},aboutXHours:{one:"cerca de 1 hora",other:"cerca de {{count}} horas"},xHours:{one:"1 hora",other:"{{count}} horas"},xDays:{one:"1 dia",other:"{{count}} dias"},aboutXWeeks:{one:"cerca de 1 semana",other:"cerca de {{count}} semanas"},xWeeks:{one:"1 semana",other:"{{count}} semanas"},aboutXMonths:{one:"cerca de 1 mês",other:"cerca de {{count}} meses"},xMonths:{one:"1 mês",other:"{{count}} meses"},aboutXYears:{one:"cerca de 1 ano",other:"cerca de {{count}} anos"},xYears:{one:"1 ano",other:"{{count}} anos"},overXYears:{one:"mais de 1 ano",other:"mais de {{count}} anos"},almostXYears:{one:"quase 1 ano",other:"quase {{count}} anos"}},kr=function(e,t,i){var n,a=Er[e];return n="string"==typeof a?a:1===t?a.one:a.other.replace("{{count}}",String(t)),null!=i&&i.addSuffix?i.comparison&&i.comparison>0?"em "+n:"há "+n:n},Tr={date:ba({formats:{full:"EEEE, d 'de' MMMM 'de' y",long:"d 'de' MMMM 'de' y",medium:"d MMM y",short:"dd/MM/yyyy"},defaultWidth:"full"}),time:ba({formats:{full:"HH:mm:ss zzzz",long:"HH:mm:ss z",medium:"HH:mm:ss",short:"HH:mm"},defaultWidth:"full"}),dateTime:ba({formats:{full:"{{date}} 'às' {{time}}",long:"{{date}} 'às' {{time}}",medium:"{{date}}, {{time}}",short:"{{date}}, {{time}}"},defaultWidth:"full"})},Ir={lastWeek:function(e){var t=e.getUTCDay();return"'"+(0===t||6===t?"último":"última")+"' eeee 'às' p"},yesterday:"'ontem às' p",today:"'hoje às' p",tomorrow:"'amanhã às' p",nextWeek:"eeee 'às' p",other:"P"},Cr=function(e,t,i,n){var a=Ir[e];return"function"==typeof a?a(t):a},Pr={ordinalNumber:function(e,t){var i=Number(e);return"week"===(null==t?void 0:t.unit)?i+"ª":i+"º"},era:ya({values:{narrow:["AC","DC"],abbreviated:["AC","DC"],wide:["antes de cristo","depois de cristo"]},defaultWidth:"wide"}),quarter:ya({values:{narrow:["1","2","3","4"],abbreviated:["T1","T2","T3","T4"],wide:["1º trimestre","2º trimestre","3º trimestre","4º trimestre"]},defaultWidth:"wide",argumentCallback:function(e){return e-1}}),month:ya({values:{narrow:["j","f","m","a","m","j","j","a","s","o","n","d"],abbreviated:["jan","fev","mar","abr","mai","jun","jul","ago","set","out","nov","dez"],wide:["janeiro","fevereiro","março","abril","maio","junho","julho","agosto","setembro","outubro","novembro","dezembro"]},defaultWidth:"wide"}),day:ya({values:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sab"],abbreviated:["domingo","segunda","terça","quarta","quinta","sexta","sábado"],wide:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},defaultWidth:"wide"}),dayPeriod:ya({values:{narrow:{am:"a",pm:"p",midnight:"mn",noon:"md",morning:"manhã",afternoon:"tarde",evening:"tarde",night:"noite"},abbreviated:{am:"AM",pm:"PM",midnight:"meia-noite",noon:"meio-dia",morning:"manhã",afternoon:"tarde",evening:"tarde",night:"noite"},wide:{am:"a.m.",pm:"p.m.",midnight:"meia-noite",noon:"meio-dia",morning:"manhã",afternoon:"tarde",evening:"tarde",night:"noite"}},defaultWidth:"wide",formattingValues:{narrow:{am:"a",pm:"p",midnight:"mn",noon:"md",morning:"da manhã",afternoon:"da tarde",evening:"da tarde",night:"da noite"},abbreviated:{am:"AM",pm:"PM",midnight:"meia-noite",noon:"meio-dia",morning:"da manhã",afternoon:"da tarde",evening:"da tarde",night:"da noite"},wide:{am:"a.m.",pm:"p.m.",midnight:"meia-noite",noon:"meio-dia",morning:"da manhã",afternoon:"da tarde",evening:"da tarde",night:"da noite"}},defaultFormattingWidth:"wide"})},Nr={ordinalNumber:wa({matchPattern:/^(\d+)[ºªo]?/i,parsePattern:/\d+/i,valueCallback:function(e){return parseInt(e,10)}}),era:_a({matchPatterns:{narrow:/^(ac|dc|a|d)/i,abbreviated:/^(a\.?\s?c\.?|d\.?\s?c\.?)/i,wide:/^(antes de cristo|depois de cristo)/i},defaultMatchWidth:"wide",parsePatterns:{any:[/^ac/i,/^dc/i],wide:[/^antes de cristo/i,/^depois de cristo/i]},defaultParseWidth:"any"}),quarter:_a({matchPatterns:{narrow:/^[1234]/i,abbreviated:/^T[1234]/i,wide:/^[1234](º)? trimestre/i},defaultMatchWidth:"wide",parsePatterns:{any:[/1/i,/2/i,/3/i,/4/i]},defaultParseWidth:"any",valueCallback:function(e){return e+1}}),month:_a({matchPatterns:{narrow:/^[jfmajsond]/i,abbreviated:/^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,wide:/^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i},defaultMatchWidth:"wide",parsePatterns:{narrow:[/^j/i,/^f/i,/^m/i,/^a/i,/^m/i,/^j/i,/^j/i,/^a/i,/^s/i,/^o/i,/^n/i,/^d/i],any:[/^ja/i,/^fev/i,/^mar/i,/^abr/i,/^mai/i,/^jun/i,/^jul/i,/^ago/i,/^set/i,/^out/i,/^nov/i,/^dez/i]},defaultParseWidth:"any"}),day:_a({matchPatterns:{narrow:/^(dom|[23456]ª?|s[aá]b)/i,short:/^(dom|[23456]ª?|s[aá]b)/i,abbreviated:/^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,wide:/^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i},defaultMatchWidth:"wide",parsePatterns:{short:[/^d/i,/^2/i,/^3/i,/^4/i,/^5/i,/^6/i,/^s[aá]/i],narrow:[/^d/i,/^2/i,/^3/i,/^4/i,/^5/i,/^6/i,/^s[aá]/i],any:[/^d/i,/^seg/i,/^t/i,/^qua/i,/^qui/i,/^sex/i,/^s[aá]b/i]},defaultParseWidth:"any"}),dayPeriod:_a({matchPatterns:{narrow:/^(a|p|mn|md|(da) (manhã|tarde|noite))/i,any:/^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i},defaultMatchWidth:"any",parsePatterns:{any:{am:/^a/i,pm:/^p/i,midnight:/^mn|^meia[-\s]noite/i,noon:/^md|^meio[-\s]dia/i,morning:/manhã/i,afternoon:/tarde/i,evening:/tarde/i,night:/noite/i}},defaultParseWidth:"any"})},Mr={code:"pt-BR",formatDistance:kr,formatLong:Tr,formatRelative:Cr,localize:Pr,match:Nr,options:{weekStartsOn:0,firstWeekContainsDate:1}};const Dr=e=>{const t=new Date,i=new Date;return{today:t,endDate:i.setDate(i.getDate()+e)}},Or=e=>{return t=e.getMonth()+1,i=e.getFullYear(),new Date(i,t,0).getDate();var t,i},Rr=e=>{const t=`${`${w(e,"ccc",{locale:Mr}).slice(0,3)}, ${w(e,"dd/MM/yyyy")}`} às ${w(e,"HH:mm")}`;return t.charAt(0).toUpperCase()+t.slice(1)},Ar=e=>{const t=[],i=["domingo","segunda","terça","quarta","quinta","sexta","sábado"],n=[];n.push(!1),n.push(e.business_unit_work_hour.monday),n.push(e.business_unit_work_hour.tuesday),n.push(e.business_unit_work_hour.wednesday),n.push(e.business_unit_work_hour.thursday),n.push(e.business_unit_work_hour.friday),n.push(!1);const a=[],r=n.reduce(((e,t,i,n)=>{if(0===i){const e=n[n.length-1];return t&&!e?[i]:[]}{const a=n[i-1];return t&&!a?[...e,i]:[...e]}}),a),o=n.reduce(((e,t,i,n)=>{if(0===i){const e=6,i=n[e];return!t&&i?[e]:[]}{const a=i-1,r=n[a];return!t&&r?[...e,a]:[...e]}}),a);if(1===r.length&&1===o.length){const n=r[0],a=o[0];let l;l=n===a?`${i[n].charAt(0).toUpperCase()+i[n].slice(1)}`:`${i[n].charAt(0).toUpperCase()+i[n].slice(1)} a ${i[a]}`;const d=`${e.business_unit_work_hour.work_hour_start} às ${e.business_unit_work_hour.work_hour_end}`;t.push(`${l}: ${d}`)}else if(r.length>1&&o.length>1){const a=n.map(((e,t)=>e?t:-1)).filter((e=>-1!==e)).map((e=>i[e])).reverse().reduce(((e,t,i)=>0===i?t:1===i?`${t} e ${e}`:`${t}, ${e}`),""),r=a.charAt(0).toUpperCase()+a.slice(1),o=`${e.business_unit_work_hour.work_hour_start} às ${e.business_unit_work_hour.work_hour_end}`;t.push(`${r}: ${o}`)}if(!!e.business_unit_work_hour.different_work_hour_start&&!!e.business_unit_work_hour.different_work_hour_end){const i=`${e.business_unit_work_hour.different_work_hour_start} às ${e.business_unit_work_hour.different_work_hour_end}`;e.business_unit_work_hour.saturday&&e.business_unit_work_hour.sunday?t.push(`Sábado e domingo: ${i}`):e.business_unit_work_hour.saturday?t.push(`Sábado: ${i}`):e.business_unit_work_hour.sunday&&t.push(`Domingo: ${i}`)}if(e.business_unit_work_hour.holiday){const i=`${e.business_unit_work_hour.holiday_work_hour_start} às ${e.business_unit_work_hour.holiday_work_hour_end}`;t.push(`Feriados: ${i}`)}return t},Lr=e=>{const t=e.find((e=>e.ruleId===process.env.REACT_APP_RANGE_DATES_RULEID));return t?Number(t.ruleValue):30},Ur=(e,t,i,n)=>{var r;const[l,d]=a(!1),[s,c]=a([]),[u,h]=a([]),[m,g]=a([]);function f({unit:e,rules:t}){const i=t.find((e=>e.ruleId===process.env.REACT_APP_OPEN_TO_SCHEDULE_RULEID));return!((null==i?void 0:i.ruleValue)?JSON.parse(String(i.ruleValue)):[]).find((t=>String(t)===e.id_sgh))}const v=async e=>{let t=!1;return(await Promise.all(e)).map((e=>{if(e){const i=(e=>{let t=!1;return Object.entries(e).map((([e,i])=>{t=t||!!i.length})),t})(e);t=t||i}})),t},b=(e,n,a)=>{const r=function(e,t,i){var n,a;let r=null===(n=null==e?void 0:e.resource)||void 0===n?void 0:n.id;(null==e?void 0:e.useResouce)||(r="");const o=null===(a=null==t?void 0:t.resources)||void 0===a?void 0:a.find((e=>e.unitId===i));return o?o.idResource:null==r?void 0:r.toString()}(t,i,n.id);return async()=>{var t,i;const o=await(async({unitIdSGH:e,itemId:t,isKit:i,resourceId:n,rules:a,localId:r})=>{try{const o=Lr(a),{today:l,endDate:d}=Dr(o),{slotDates:s}=await pa({unitId:e,itemId:t,isKit:i,startDate:w(l,"yyyy-MM-dd"),endDate:w(d,"yyyy-MM-dd"),resourceId:n,localId:r});return{[e]:s}}catch(e){p.error("Falha ao carregar dados. Tente novamente mais tarde.")}})({unitIdSGH:n.id_sgh,itemId:e.item_SGH_id,isKit:e.is_kit,resourceId:r||"",rules:e.rules,localId:(null===(t=null==n?void 0:n.locations)||void 0===t?void 0:t.length)?null===(i=null==n?void 0:n.locations[0])||void 0===i?void 0:i.name:""});return o&&a.push(o),o}},y=async e=>{d(!0);const{is_kit:a,id:r,rules:o,care_type:l,item_SGH_id:s}=e;let u=[];if(i?u=i.units:e&&e.units&&(u=e.units),u){h([]),g([]);const i=[],d=[],p=[],m=[];u.forEach((async t=>{t.isKit=a,t.itemId=s,t.catalogItemId=r;let n=!0;if(l===le&&(n=f({unit:t,rules:o})),l===de&&(n=!1),n){const n=b(e,t,i);n&&m.push(n()),d.push(t)}else p.push(t)}));(e=>{var i,a,r,o;e||((null===(a=null===(i=null==t?void 0:t.resource)||void 0===i?void 0:i.id)||void 0===a?void 0:a.toString())?(null===(r=t.productName)||void 0===r?void 0:r.toUpperCase().includes("DIU"))?n({condition:J,visible:!0}):n({condition:K,visible:!0}):((null===(o=null==t?void 0:t.productName)||void 0===o?void 0:o.toUpperCase().includes("DIU"))&&!(null==t?void 0:t.useResouce)&&n({condition:K,visible:!0}),n({condition:ee,visible:!0})))})(await v(m)),c(i),h(d),g(p)}d(!1)};return o((()=>{e&&y(e)}),[e,null===(r=null==t?void 0:t.resource)||void 0===r?void 0:r.id,null==i?void 0:i.units]),{loading:l,openToScheduleUnits:u,closedToScheduleUnits:m,unitDatesAvailable:s}},$r=({handleModalProps:e,openModal:t,scheduleSelected:i,changeSchedule:a})=>{const[r,o]=n.useState(),[l,d]=n.useState(),[s,c]=n.useState(),[u,p]=n.useState(),h=ra({changeSchedule:a,selectedSchedule:i}),{loading:m,openToScheduleUnits:g,closedToScheduleUnits:f,unitDatesAvailable:v}=Ur(s,i,r,e);n.useEffect((()=>{let e=!1,t="";if(v.map((i=>{const n=Object.entries(i)[0];n&&(e=!!n[1].length),e&&(t=n[0])})),1===g.length&&e&&b(g[0]),"TELEMEDICINE"===(null==s?void 0:s.care_type)&&g.length>0&&e){const e=g.find((e=>e.id_sgh===t));e&&b(e)}}),[g]);const b=async e=>{var t;p(e),h.addUnit({unit:e,localId:(null===(t=null==e?void 0:e.locations)||void 0===t?void 0:t.length)?e.locations[0].name:""}),h.updateSchedule()},y=()=>{p(void 0)};return{coverageUnit:l,selectedCoverage:s,setSpecificUnitsResources:o,loading:m,openToScheduleUnits:g,closedToScheduleUnits:f,unitDatesAvailable:v,handleSelectedCoverage:async e=>{var i;const n=e.coverage.care_type;if(y(),0===(null===(i=e.coverage.units)||void 0===i?void 0:i.length)&&e.coverage.channel!==oa.TELEORIENTATION&&t(Hi.PRODUCT_NOT_COVERED),"WHATSAPP_DIRECTION"===e.coverage.appointment_status&&t(Hi.SERVICE_UNAVAILABLE),"WHATSAPP_DIRECTION"!==e.coverage.appointment_status){if(n===ce){if(e.patientSelected){if(E(new Date,new Date(e.patientSelected.birthDate))<9)return void t(Hi.NINE_YEARS_DRIVE_THRU)}}else n===de&&e.patientSelected&&await(async e=>{const t={error:!1,errorStatus:null,message:"",data:{}};try{const i=await Ce.post("/specialist/eav/register-patient",e);return t.data=i.data,t}catch(e){return console.error(e),t.error=!0,t}})({patient:{firstName:e.patientSelected.name.slice(0,1),lastName:e.patientSelected.name.slice(1),document:e.patientSelected.document,phoneNumber:e.patientSelected.phone,email:e.patientSelected.email,birthDate:e.patientSelected.birthDate,documentType:e.patientSelected.documentType,sex:e.patientSelected.gender}});c(e.coverage),d({...l,coverage:e.coverage,unit:void 0})}h.addCareType(e.coverage.care_type)},setUnitToSchedule:b,resetCoverageSelection:y,selectedUnit:u}},Fr=({goTo:t,genericModal:i,selectedProduct:a,patientSelected:r,selectedService:o,routeProductSelector:l,handleSchedulePatient:d,addAdditionalInformations:s,setLoading:c})=>{const{selectItemToSchedule:u,handleSelectProduct:p}=_(Le,(e=>e)),{addUnitDatesAvailable:h,changeSchedule:m,selectedItem:g}=_(he,(e=>e)),{findProduct:f}=_(ge,(e=>e)),{openModal:v}=_(Bi,(e=>e)),{handleSelectedCoverage:b,loading:y,unitDatesAvailable:x,selectedUnit:S,selectedCoverage:w}=$r({handleModalProps:i.handleModalProps,changeSchedule:m,openModal:v,scheduleSelected:g}),E=aa({goTo:t,openModal:v}),k=ra({changeSchedule:m,selectedSchedule:g});return n.useEffect((()=>{c(y)}),[y]),n.useEffect((()=>{h(x)}),[x]),n.useEffect((()=>{S&&(null==w?void 0:w.care_type)===se&&function(e){var i,n;k.addUnit({unit:e,localId:(null===(i=null==e?void 0:e.locations)||void 0===i?void 0:i.length)?null===(n=null==e?void 0:e.locations[0])||void 0===n?void 0:n.name:""}),k.updateSchedule(),u("PRODUCT");const r=f((null==a?void 0:a.id)||"");r&&p(r);t(O.SERVICE_UNIT.id)}(S)}),[S,w]),e(ia,{when:U,condition:i.genericModalCondition,visible:i.modalGenericVisible,isVisible:i.setModalGenericVisible,handleActionButton:async function(e,n){if(e!==B&&e!==G||i.setModalGenericVisible(!1),e===j&&i.setGenericModalCondition(n),e===H&&(i.setModalGenericVisible(!1),a&&r)){const e=f(a.id),n=E.handleTelemedicineProduct(e);(null==n?void 0:n.type)===na.only_telemedicine&&n.coverage&&b({coverage:n.coverage,patientSelected:r}),n||(i.genericModalCondition===Q?t(O.SERVICE_TYPE_PAGE.id):await l({showGenericModal:!0,product:a,patient:r}))}if(e===z&&(i.setModalGenericVisible(!1),o)){const e=(e=>o.products.find((t=>t.id===e)))(n);e&&r&&(s({productRules:e.rules}),await d({product:e,showGenericModal:!0,patient:r}))}}})};function Vr({goTo:e,findAnotherDoctor:t,schedule:i}){ct((e=>e.genericModals));const n=ct((e=>e.setGenericModals)),[r,o]=a(""),[l,d]=a(!1),[s,c]=a("");return{genericModalCondition:r,setGenericModalCondition:o,handleActionButtonModal:async function(t,i){if(t===H&&e&&e(O.SERVICE_TYPE_PAGE.id),t===j&&o(i),t===z)return d(!1),{action:z};if(t===V)return d(!1),{action:V};if(t===B&&d(!1),t===q&&window.open(`https://wa.me/${i}`),t===X&&(window.location.href=`tel:${i}`),t===W&&i.units&&i.resources){d(!1);const e=i.resources,t=[],n=[];return e.map((async e=>{n.push((async()=>{const i=await(async e=>{const t=await ke.get(`branch/${e}`),{data:i}=t;return i})(e.unitId);t.push(Ee(i))})())})),await Promise.all(n),{action:W,data:{units:t,resources:e}}}return t===Y?{action:Y,data:{}}:void 0},modalGenericVisible:l,setModalGenericVisible:d,handleModalProps:function(e){e.condition&&o(e.condition),d(e.visible)},addGenericModals:({additional:e,productRules:t})=>{let i=[],a=[];if(t){const e=Qn(t);e&&(a=e)}e&&(i=e);const r=[...i,...a];return n(r),r},genericModalWhen:s,setGenericModalWhen:c,openModal:function(e,t){c(e),o(t),d(!0)}}}const zr=()=>{function e(e,t){const i=Yn(e);if(null==i?void 0:i.value){return JSON.parse(i.value).find((e=>e.rule===t))}}return{getGenericRuleCatalog:e,validateGenericRules:function(e,t){return"gender"===e.rule&&("instrict"===e.action&&t===e.value)},hasGenericRuleCatalog:(t,i)=>{if(i)return e(i,t)}}},Hr=e=>{const t=e||{};return{setSpecialist:function(e){return t.specialityList=e.specialityList,t.image=e.image,t.interval=e.interval,t},setPatient:function(e){return t.idPatient=e,t},setUnit:function(e){var i;const n={name:e.resourceName,specialty:null===(i=e.specialty)||void 0===i?void 0:i.name,professionalId:e.professionalId,medicalProcedureId:e.medicalProcedureId,companyId:e.companyId,specialistId:e.specialistId,professionalCode:e.crm},a={name:e.unitName,catalogId:e.catalogUnitId,address:e.unitAddress,officeId:e.office_id};return t.unit=a,t.resource=n,t.catalog={name:"Consulta médica"},t.attendanceType=e.attendanceType,t.unitHealthPlans=e.unitHealthPlans,e.price&&(t.payment={...t.payment,price:e.price}),t},setDateHour:function(e){return t.date=e.date,t.hour=e.hour,t},setDateHours:function(e){return t.dateHours=e,t},validateSchedule:function(){return t.resource.companyId||re("Missing schedule.resource.companyId property"),t.resource.professionalId||re("Missing schedule.resource.professionalId property"),t.date||re("Missing schedule.date property"),t.hour||re("Missing schedule.hour property"),t.resource.medicalProcedureId||re("Missing schedule.medicalProcedureId property"),t.resource.name||re("Missing schedule.resource.name property"),t.resource.specialty||re("Missing schedule.resource.specialty property"),t.attendanceType||re("Missing schedule.attendanceType property"),t.interval||re("Missing schedule.interval property"),t.idPatient||re("Missing schedule.idPatient property"),t.dateHours||re("Missing schedule.dateHours property"),t.payment||re("Missing schedule.payment property"),t},setPayment:function(e){return t.payment=e,t},schedule:t,build:function(){return t}}};function Br(e){const t={firstName:"",lastName:""};return e.split(" ").forEach(((e,i)=>{0===i?t.firstName=e:t.lastName?e&&(t.lastName=t.lastName+" "+e):e&&(t.lastName=e)})),t}const Gr=e=>e.split(" ").map((e=>jr(e)?qr(e):e.toLowerCase())).join(" "),jr=e=>{switch(e){case"e":case"a":case"ao":case"ou":case"de":case"da":case"das":case"do":case"dos":return!1;default:return!0}},qr=e=>e.charAt(0).toUpperCase()+e.slice(1).toLowerCase(),Wr="Masculino";const Yr=e=>{const t={},{firstName:i,lastName:n}=Br(e);t.firstName=i,t.lastName=n;return{setDocument:(e,i)=>{t.document=e,t.documentType=i.toUpperCase()},setBirthDate:e=>t.birthDate=e,setPhone:e=>t.phoneNumber=e,setEmail:e=>t.email=e,setGender:e=>t.sex=e===Wr?"M":"F",setIsPregnant:e=>t.isPregnant=e,build:()=>(t.document||re("Missing document property "),t.documentType||re("Missing documentType property "),t.birthDate||re("Missing birthDate property "),t.phoneNumber||re("Missing phoneNumber property "),t.email||re("Missing email property "),t.sex||re("Missing sex property "),t)}};function Xr(e){const t=xt(e.document),i=xt(e.phone),n=e.gender?e.gender:"não informado",{firstName:a,lastName:r}=Br(e.name),o={firstName:a,lastName:r,holderDocument:t,documentType:e.documentType,birthDate:e.birthDate,phoneNumber:i,email:e.email,sex:n};return e.pregnant&&(o.isPregnant=!0),o}const Kr="PARTICULAR",Qr="B2B";var Zr;function Jr(){return async function({patient:e,product:t,schedule:i}){const n={};if(i.payment){const a=Xr(e),r=function(e){var t,i;return e.type===Qr&&(null===(t=e.eligibility)||void 0===t?void 0:t.codPlan)?{type:Qr,additional_info:{plan_code:null===(i=e.eligibility)||void 0===i?void 0:i.codPlan}}:e.type===Kr?{type:Kr}:{}}(i.payment),o=await(async e=>{const t={error:!1,errorStatus:null,message:"",data:{}};try{const i=await Ce.post("rule-validator/validate-aps",e);return t.data=i.data,t}catch(e){return t.error=!0,console.error(e),t}})({patient:a,product:t,payment:r});if(o.data.statusCode!==Zr.OK)return n.errorMessage=o.message,n.error=!0,n;const{product:l,resource:d,additional_information:s}=o.data.data;n.error=!1,n.data={schedule:i,product:l,resource:d,modals:s}}return n}}!function(e){e.OK="ISC200",e.GENERIC_EXCEPTION="ISC300",e.TRIAD_EXCEPTION="ISC400",e.COVERAGE_EXCEPTION="ISC500",e.MULTIPLE_APPOINTMENTS_EXCEPTION="ISC600",e.VALIDATION_EXCEPTION="ISC700",e.GET_MEDICAL_RECORD_EXCEPTION="ISC800",e.GET_MCIID_EXCEPTION="ISC801",e.AUTH_SALESFORCE_EXCEPTION="ISC900",e.GET_SLOTS_EXCEPTION="ISC901",e.CREATE_SERVICE_APPOINTMENT_EXCEPTION="ISC902",e.UPDATE_SERVICE_APPOINTMENT_EXCEPTION="ISC903",e.CONFIRM_SERVICE_APPOINTMENT_EXCEPTION="ISC904",e.DB_SAVE_DATA_EXCEPTION="ISC1000",e.DB_GET_DATA_EXCEPTION="ISC1001",e.SEND_EMAIL_EXCEPTION="ISC1100"}(Zr||(Zr={}));const eo=({addPatientList:e,changeProduct:t,eligibilityPlans:i,setEligibilityPlans:a,goTo:r,changeSchedule:o,selectedSchedule:l,openModal:d,scheduleSpecialistSelected:s,setScheduleSpecialistSelected:c,changeScheduleSpecialist:u})=>{const[p,h]=n.useState(!1),[m,g]=n.useState(!1),[f,v]=n.useState(!1),[b,y]=n.useState(!1),_=ra({changeSchedule:o,selectedSchedule:l}),x=Jr(),S=Vr({goTo:r,schedule:_.schedule}),w=aa({goTo:r,openModal:d});async function E({schedule:e,patient:t}){let n=i;const o=function(e){return e.payment||void 0}(e);if(!o){const{data:i,error:a}=await(async({eligibilityType:e,document:t,documentType:i,itemId:n})=>{const a={error:!1,errorStatus:null,message:"",data:{}},r={eligibilityType:e,document:t,documentType:i,itemId:n};try{const{data:e}=await Ce.post("coverage-service/eligibility",r);return a.data=e,a}catch(e){return a.error=!0,a}})({eligibilityType:"PRODUCT",document:t.document,documentType:t.documentType,itemId:e.productId});a&&v(!0),!a&&i.length&&(n=i)}if(o)return o;if(n.length>1&&a(n),0===n.length&&v(!0),n.length>1&&r(O.PAYMENT_VIEW.id),1===n.length){const[e]=n;return{type:ie,eligibility:{idInsurance:e.id_convenio,idCustomer:e.id_cliente,codInsurance:e.cod_convenio,codPlan:e.cod_plano,codOffice:e.cod_escritorio,plan:e.nome,image:e.image}}}}async function k({patient:e,product:i}){let n=null;const a=await async function({patient:e,product:t,schedule:i}){const n=await x({patient:e,product:t,schedule:i});if(!n.error)return n.data;n.error&&h(!0)}({patient:e,product:i,schedule:_.schedule});if(a&&(n=a),n){t(n.product);const e=S.addGenericModals({productRules:n.product.rules,additional:n.modals});return r=n.resource,_.addResource(!!r,r||void 0),_.updateSchedule(),{product:n.product,resource:n.resource,genericModals:e}}var r}async function T(e){const t=await k(e);if(t)return w.routeScheduleByProduct(t.product,t.resource,t.genericModals)}const I=async({productSelected:t,patient:i,itemToSchedule:n,specialist:a})=>{const o=e(i);if("SPECIALIST"===n&&o.idPatient)return function(e){const t=Hr();t.setPayment({type:te}),t.setPatient(e.patientId),e.specialist&&t.setSpecialist({specialityList:e.specialist.specialties,image:e.specialist.profile_picture,interval:30}),(null==s?void 0:s.interval)?u(t.build()):c(t.build())}({specialist:a,patientId:o.idPatient}),r(O.SERVICE_TYPE_PAGE.id),{type:na.ok};if(("PRODUCT"===n||"PRODUCT_ENV"===n)&&_.schedule&&t){if(_.addPatient(o.idPatient||""),t.is_b2b){const e=await E({patient:o,schedule:_.schedule});if(e&&_.addPayment(e),t.is_b2b&&!e)return;if(_.schedule.payment)return await T({patient:o,product:t})}if(!t.is_b2b)return _.schedule.payment||_.addPayment({type:te}),await T({patient:o,product:t})}};return{handleAddPatient:I,isModalSystemUnavailableVisible:p,isModalHealthInsuranceUnavailableVisible:m,isModalNoEligibility:f,isModalProductNotCoveredVisible:b,setIsModalHealthInsuranceUnavailableVisible:g,setIsModalProductNotCoveredVisible:y,setIsModalSystemUnavailableVisible:h,setIsModalNoEligibility:v,genericModal:S,createSchedule:async e=>(_.addProduct(e.product),e.payment?_.addPayment(e.payment):_.resetPayment(),await I({patient:e.patient,productSelected:e.product,itemToSchedule:e.itemToSchedule})),useScheduling:_}},to=C.object().shape({name:C.string().min(3,"Nome muito curto").required("Digite o nome completo"),document:C.string().required("Digite o documento"),citizenship:C.string().required("Selecione a nacionalidade"),birthDateDate:C.string().min(10,"Data inválida").required("Digite a data de nascimento"),phone:C.string().min(13,"Digite um telefone válido").required("Digite o número de telefone"),email:C.string().min(3,"muito curto").required("Digite o Email")}),io={documentType:"CPF",document:"",citizenship:"",gender:"",pregnant:"",name:"",birthDate:"",birthDateDate:"",phone:"",email:"",idPatient:""};function no(){const{goTo:e}=_(A,(e=>e)),{openModal:t}=_(Bi,(e=>e)),{changeProduct:i,findProductOriginal:n}=_(ge,(e=>e)),{setEligibilityPlans:r,eligibilityPlans:o}=_(ve,(e=>e)),{selectedItem:l,changeSchedule:d,scheduleSpecialistSelected:s,setScheduleSpecialistSelected:c,changeScheduleSpecialist:u}=_(he,(e=>e)),{addPatientList:p,setPatientSelected:h,patientSelected:m}=_(_e,(e=>e)),{selectedProduct:g,handleSelectProduct:f,selectedItemToSchedule:v}=_(Le,(e=>e)),[b,y]=a(!1),{hasGenericRuleCatalog:x,validateGenericRules:S}=zr(),{handleAddPatient:w,genericModal:E,isModalSystemUnavailableVisible:k,setIsModalSystemUnavailableVisible:T,isModalProductNotCoveredVisible:C,setIsModalProductNotCoveredVisible:P,isModalNoEligibility:N,setIsModalNoEligibility:M,createSchedule:D}=eo({addPatientList:p,changeProduct:i,eligibilityPlans:o,setEligibilityPlans:r,goTo:e,changeSchedule:d,selectedSchedule:l,openModal:t,scheduleSpecialistSelected:s,setScheduleSpecialistSelected:c,changeScheduleSpecialist:u}),O=I({initialValues:io,validationSchema:to,validateOnChange:!1,validateOnBlur:!1,onSubmit:async e=>{y(!0);const t=!function({values:e,formik:t,checkGenericRulesCatalog:i}){let n=!1;const a=vt(e.birthDateDate),{validateGenericRules:r}=zr();a?e.birthDate=a:(t.setFieldError("birthDateDate","Data inválida"),n=!0),"CPF"===t.values.documentType?pt(e.document)||(t.setFieldError("document","Documento inválido"),n=!0):"Passaporte"===t.values.documentType&&(ht(e.document)||(t.setFieldError("document","Documento inválido"),n=!0)),""===e.citizenship&&(t.setFieldError("citizenship","Selecione a nacionalidade"),n=!0);const o=i("gender");return o&&(r(o,"Feminino"===e.gender?"female":"male")||(t.setFieldError("gender","O tipo de procedimento escolhido é somente para o sexo feminino"),n=!0)),""==e.gender&&(t.setFieldError("gender","Selecione o gênero"),n=!0),"Feminino"===e.gender&&""===e.pregnant&&yt(e.birthDate,9)&&(t.setFieldError("pregnant","Selecione se é gestante"),n=!0),bt(e.name)||(t.setFieldError("name","Digite nome completo"),n=!0),ft(e.email)||(t.setFieldError("email","Digite um email válido"),n=!0),n}({values:e,formik:O,checkGenericRulesCatalog:e=>x(e,null==g?void 0:g.rules)}),i=function(e){const t={};t.name=e.name.trim(),t.email=e.email.trim(),t.document=xt(e.document),t.phone=xt(e.phone),yt(e.birthDate,9)?t.pregnant="Sim"===e.pregnant:t.pregnant=!1;return{...e,...t}}(e);t&&"SPECIALIST"===v&&await w({productSelected:g,itemToSchedule:v,patient:i}),"PRODUCT"!==v&&"SERVICE_ENV"!==v&&"PRODUCT_ENV"!==v||t&&g&&(h(i),await L({product:g,patient:i})),y(!1)}});async function R({product:e,patient:t,showGenericModal:i}){y(!0),f(e);const n=await D({product:e,patient:t,itemToSchedule:"PRODUCT"});i&&!n||(null==n?void 0:n.type)===Q&&(E.setGenericModalCondition(Q),E.setModalGenericVisible(!0)),y(!1)}async function L({product:e,showGenericModal:t,patient:i}){let n;y(!0),e.rules&&!t&&(n=function({productRules:e,genericModalWhen:t}){const i=Qn(e);if(i&&Kn({genericModals:i,condition:Z,when:t}))return E.setGenericModalCondition(Z),E.setModalGenericVisible(!0),!0;return!1}({productRules:e.rules,genericModalWhen:U})),!t&&n||await R({patient:i,product:e,showGenericModal:!!t}),y(!1)}return{updateFormPatient:function(e){O.setValues({...e,document:"CPF"===e.documentType?_t(e.document):Et(e.document),phone:St(e.phone),birthDateDate:wt(e.birthDate)||"",pregnant:"Feminino"===e.gender?e.pregnant?"Sim":"Não":"",gender:"não informado"===e.gender?"":e.gender,idPatient:e.idPatient||""})},loading:b,formik:O,setLoading:y,genericModal:E,patientSelected:m,selectedProduct:g,routeProductSelector:L,handleSchedulePatient:R,validateGenderCatalogGenericRules:function(e){const t=n((null==l?void 0:l.productId)||""),i=x("gender",null==t?void 0:t.rules),a=e||O.values.gender;return!i||S(i,"Feminino"===a?"female":"male")},isModalSystemUnavailableVisible:k,setIsModalSystemUnavailableVisible:T,isModalNoEligibility:N,setIsModalNoEligibility:M,isModalProductNotCoveredVisible:C,setIsModalProductNotCoveredVisible:P}}const ao=m.div`
  height: var(--height-body-without-header);
  max-height: var(--height-body-without-header);
  display: flex;
  flex-direction: column;
`,ro=m.p`
  font-size: 16px;
  font-weight: 500;
  text-align: left;
  color: #898b8e;
`,oo=m.div`
  padding: 32px;
  height: 100%;
  overflow-y: auto;

  list {
    list-style: none;
    padding: 0;
    margin-top: 29px;
  }
`,lo=m.div`
  margin-top: 29px;
`,so=m.li`
  margin-bottom: 19px;
  height: 80px;
  width: 100%;

  border-radius: 8px;
  list-style: none;
`;m.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: auto;
`;const co=m.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`,uo=m.div`
  ${({standardSpacing:e})=>v`
    padding: ${e?"0":"0 32px"};
    padding-top: ${e?"0":"36px"};
    overflow-y: auto;
  `}
`;m.div`
  margin-top: 16px;
`;const po=({children:i,childrenFooter:n,standardSpacing:a})=>t(co,{children:[e(uo,{standardSpacing:a,children:i}),n&&e(mi,{children:n})]}),ho=m.div`
  ${({theme:e})=>v`
    display: grid;
    gap: 16px;
    grid-template-areas: 'image info';
    align-items: center;
    justify-content: start;

    & .image {
      grid-area: image;
      height: 64px;
      width: 64px;
      border-radius: 50%;
      object-fit: cover;
    }

    & .info {
      grid-area: info;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .title {
        font-size: 16px;
        color: ${e.colors.colorGray500};
        font-weight: 500;
      }

      .subtitle {
        margin-top: 4px;
        font-size: 14px;
        color: ${e.colors.colorGray400};
        font-weight: 500;
      }
    }
  `}
`,mo=({imgSrc:i,title:n,description:a})=>t(ho,{children:[e("img",{className:"image",src:i,alt:"Specialist",onError:({currentTarget:e})=>{e.onerror=null,e.src="https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/patient.svg"}}),t("div",{className:"info",children:[e("p",{className:"title",children:n}),e("p",{className:"subtitle",children:a})]})]});m.div`
  padding: 32px 0;
`,m.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`,m.p`
  font-size: 14px;
  color: #898b8e;
  font-weight: 400;
`,m.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(52px, 1fr));
  grid-gap: 10px;
  grid-auto-rows: 30px;
  margin-top: 20px;
`;const go=b`
  100% {
    background-color: #004F92;
    color: #FFFFFF;
    border: 0;
  }
`,fo=m.p`
  display: flex;
  align-items: center;
  justify-content: center;
  /* width: 57px; */
  /* height: 27px; */

  border-radius: 16px;
  border: 1px solid #d5d5d6;
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
  animation-name: ${e=>e.active?go:""};

  font-weight: 500;
  font-size: 14px;
  color: var(--color-gray-500);
  cursor: pointer;
`,vo=({time:t,active:i,onClick:n})=>e(fo,{active:i,onClick:n,children:t.toTimeString().split(" ")[0].split(":").slice(0,2).join(":")}),bo=m.div`
  padding: 32px 0;
`;m.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;const yo=m.p`
  font-size: 14px;
  color: #898b8e;
  font-weight: 400;
`,_o=m.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(52px, 1fr));
  grid-gap: 10px;
  grid-auto-rows: 30px;
  margin-top: 20px;
`,xo=b`
  100% {
    background-color: #004F92;
    color: #FFFFFF;
    border: 0;
  }
`;m.p`
  display: flex;
  align-items: center;
  justify-content: center;
  /* width: 57px; */
  /* height: 27px; */

  border-radius: 16px;
  border: 1px solid #d5d5d6;
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
  animation-name: ${e=>e.active?xo:""};

  font-weight: 500;
  font-size: 14px;
  color: var(--color-gray-500);
  cursor: pointer;
`;const So=({times:i,onSelectedTime:n,selectedTime:a})=>t(bo,{children:[(null==i?void 0:i.length)?e(yo,{children:"Horários disponíveis"}):null,e(_o,{children:(null==i?void 0:i.length)?i.map((t=>e(vo,{time:t.time,active:(null==t?void 0:t.id)===(null==a?void 0:a.id),onClick:()=>{n(t)}},t.id))):null})]});m.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  & .btn-wrapper {
    position: absolute;
    bottom: 0;
    width: 100%;
    background: rgb(255, 255, 255);
    background: linear-gradient(0deg, rgba(255, 255, 255, 1) 16%, rgba(255, 255, 255, 0) 64%);
  }
`,m.div`
  h1 {
    font-weight: 600;
    font-size: 24px;
    margin: 10px 5px;
  }
`;const wo=m.div`
  display: flex;
  flex-direction: column;
`;m.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  margin-top: 24px;
`,m.div`
  box-sizing: border-box;
  background-color: white;
  margin-top: 15px;
  padding: 10px;
  height: 70px;
  border: 1px solid #d5d5d6;
  width: 100%;
  display: flex;
  align-items: center;
  span {
    font-size: 14px;
    color: #555658;
  }
`,m.div`
  display: flex;
  justify-content: space-around;
  flex-direction: column;
`,m.div`
  text-align: left;
`,m.div`
  display: flex;
  align-items: center;

  img {
    display: inline-block;
    height: 20px;
    width: 20px;
  }

  p {
    font-size: 14px;
    display: inline-block;
    margin-left: 10px;
  }
`;const Eo=m.p`
  font-weight: 500;
  text-align: left;
  color: #898b8e;

  font-size: 14px;
`,ko=m.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  text-align: center;
  margin-top: 20px;
`,To=m.div`
  border: ${e=>e.active?"0":"1px solid #ccc"};
  border-radius: 8px;

  /* width: 100%; */
  width: 72px;
  height: 72px;
  margin: 2px;
  & + & {
    margin-left: 12px;
  }

  display: flex;
  flex-direction: column;
  justify-content: center;

  background-color: ${e=>e.active?"#004F92":"transparent"};

  padding-top: 5px;
  padding-bottom: 5px;
  cursor: pointer;
`,Io=m.span`
  font-size: 28px;
  font-weight: 600;
  color: ${e=>e.active?"#FFFFFF":"#555658"};
  width: 100%;
`,Co=m.span`
  font-size: 12px;
  color: ${e=>e.active?"#FFFFFF":"#898b8e"};
  width: 100%;
`,Po=m.p`
  font-size: 7px;
  color: #898b8e;
  width: 100%;
`;m.div`
  padding-bottom: 110px;
`,m.div`
  display: none;

  @media (min-width: 900px) {
    display: block;
  }
`;const No=m.div`
  margin-top: 37px;
  margin-bottom: 32px;
`,Mo=({displayDates:i,selectedDate:n,onSelectDate:a,handleClickSeeMore:r})=>t(wo,{children:[e(Eo,{children:"Datas mais próximas disponíveis"}),t(ko,{children:[null==i?void 0:i.slice(0,3).map((i=>t(To,{active:!!n&&k(i,n),onClick:()=>a(i),children:[e(Io,{active:!!n&&k(i,n),children:i.toLocaleDateString("pt-BR",{day:"2-digit"})}),e(Co,{active:!!n&&k(i,n),children:i.toLocaleDateString("pt-BR",{month:"long"}).slice(0,3).toUpperCase()})]},i.getTime()))),t(To,{active:!1,onClick:r,children:[e(Po,{children:e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/datePlus.svg",alt:"seemore"})}),e(Co,{active:!1,children:"Ver mais"})]})]})]});var Do={color:void 0,size:void 0,className:void 0,style:void 0,attr:void 0},Oo=n.createContext&&n.createContext(Do),Ro=function(){return Ro=Object.assign||function(e){for(var t,i=1,n=arguments.length;i<n;i++)for(var a in t=arguments[i])Object.prototype.hasOwnProperty.call(t,a)&&(e[a]=t[a]);return e},Ro.apply(this,arguments)},Ao=function(e,t){var i={};for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&t.indexOf(n)<0&&(i[n]=e[n]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var a=0;for(n=Object.getOwnPropertySymbols(e);a<n.length;a++)t.indexOf(n[a])<0&&Object.prototype.propertyIsEnumerable.call(e,n[a])&&(i[n[a]]=e[n[a]])}return i};function Lo(e){return e&&e.map((function(e,t){return n.createElement(e.tag,Ro({key:t},e.attr),Lo(e.child))}))}function Uo(e){return function(t){return n.createElement($o,Ro({attr:Ro({},e.attr)},t),Lo(e.child))}}function $o(e){var t=function(t){var i,a=e.attr,r=e.size,o=e.title,l=Ao(e,["attr","size","title"]),d=r||t.size||"1em";return t.className&&(i=t.className),e.className&&(i=(i?i+" ":"")+e.className),n.createElement("svg",Ro({stroke:"currentColor",fill:"currentColor",strokeWidth:"0"},t.attr,a,l,{className:i,style:Ro(Ro({color:e.color||t.color},t.style),e.style),height:d,width:d,xmlns:"http://www.w3.org/2000/svg"}),o&&n.createElement("title",null,o),e.children)};return void 0!==Oo?n.createElement(Oo.Consumer,null,(function(e){return t(e)})):t(Do)}function Fo(e){return Uo({tag:"svg",attr:{viewBox:"0 0 24 24"},child:[{tag:"path",attr:{fill:"none",d:"M0 0h24v24H0z"}},{tag:"path",attr:{d:"M17.77 3.77L16 2 6 12l10 10 1.77-1.77L9.54 12z"}}]})(e)}function Vo(e){return Uo({tag:"svg",attr:{viewBox:"0 0 24 24"},child:[{tag:"path",attr:{fill:"none",d:"M0 0h24v24H0V0z"}},{tag:"path",attr:{d:"M6.23 20.23L8 22l10-10L8 2 6.23 3.77 14.46 12z"}}]})(e)}const zo=m.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;

  & h5 {
    font-size: 18px;
    font-weight: 600;
    line-height: 22px;
    color: #555658;
    text-transform: uppercase;
  }

  & button {
    border: 0;
    background: #fff;
    color: #555658;

    & svg {
      width: 20px;
      height: 20px;
    }
  }
`,Ho=i=>{const[a,r]=n.useState(!1);n.useEffect((()=>{const e=new Date;i.monthDate.getFullYear()===e.getFullYear()&&i.monthDate.getMonth()===e.getMonth()?r(!1):r(!0)}),[i.monthDate]);let o=!0;return i.initialDate&&i.monthDate.getMonth()<=i.initialDate.getMonth()&&(o=!1),t(zo,{children:[e("button",a&&o?{onClick:i.decreaseMonth,children:e(Fo,{size:50})}:{}),e("h5",{children:Sr(i.monthDate,"MMM YYY",{locale:Mr})}),e("button",{onClick:i.increaseMonth,children:e(Vo,{})})]})},Bo=m.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-year-read-view--down-arrow,
  .react-datepicker__navigation-icon::before {
    border-color: #ccc;
    border-style: solid;
    border-width: 3px 3px 0 0;
    content: '';
    display: block;
    height: 9px;
    position: absolute;
    top: 6px;
    width: 9px;
  }
  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle,
  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle {
    margin-left: -4px;
    position: absolute;
    width: 0;
  }
  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before,
  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before,
  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::after,
  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::after {
    box-sizing: content-box;
    position: absolute;
    border: 8px solid transparent;
    height: 0;
    width: 1px;
    content: '';
    z-index: -1;
    border-width: 8px;
    left: -8px;
  }
  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before,
  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before {
    border-bottom-color: #aeaeae;
  }

  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle {
    top: 0;
    margin-top: -8px;
  }
  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before,
  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::after {
    border-top: none;
    border-bottom-color: #f0f0f0;
  }
  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::after {
    top: 0;
  }
  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before {
    top: -1px;
    border-bottom-color: #aeaeae;
  }

  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle {
    bottom: 0;
    margin-bottom: -8px;
  }
  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before,
  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::after {
    border-bottom: none;
    border-top-color: #fff;
  }
  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::after {
    bottom: 0;
  }
  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before {
    bottom: -1px;
    border-top-color: #aeaeae;
  }

  .react-datepicker-wrapper {
    display: inline-block;
    padding: 0;
    border: 0;
    width: 100%;
  }

  .react-datepicker {
    font-family: 'Helvetica Neue', helvetica, arial, sans-serif;
    font-size: 0.8rem;
    background-color: #fff;
    color: #000;
    border: 1px solid #aeaeae;
    border-radius: 0.3rem;
    display: inline-block;
    position: relative;
  }

  .react-datepicker--time-only .react-datepicker__triangle {
    left: 35px;
  }
  .react-datepicker--time-only .react-datepicker__time-container {
    border-left: 0;
  }
  .react-datepicker--time-only .react-datepicker__time,
  .react-datepicker--time-only .react-datepicker__time-box {
    border-bottom-left-radius: 0.3rem;
    border-bottom-right-radius: 0.3rem;
  }

  .react-datepicker__triangle {
    position: absolute;
    left: 50px;
  }

  .react-datepicker-popper {
    z-index: 1;
  }
  .react-datepicker-popper[data-placement^='bottom'] {
    padding-top: 10px;
  }
  .react-datepicker-popper[data-placement='bottom-end'] .react-datepicker__triangle,
  .react-datepicker-popper[data-placement='top-end'] .react-datepicker__triangle {
    left: auto;
    right: 50px;
  }
  .react-datepicker-popper[data-placement^='top'] {
    padding-bottom: 10px;
  }
  .react-datepicker-popper[data-placement^='right'] {
    padding-left: 8px;
  }
  .react-datepicker-popper[data-placement^='right'] .react-datepicker__triangle {
    left: auto;
    right: 42px;
  }
  .react-datepicker-popper[data-placement^='left'] {
    padding-right: 8px;
  }
  .react-datepicker-popper[data-placement^='left'] .react-datepicker__triangle {
    left: 42px;
    right: auto;
  }

  .react-datepicker__header {
    text-align: center;
    background-color: #f0f0f0;
    border-bottom: 1px solid #aeaeae;
    border-top-left-radius: 0.3rem;
    padding: 8px 0;
    position: relative;
  }
  .react-datepicker__header--time {
    padding-bottom: 8px;
    padding-left: 5px;
    padding-right: 5px;
  }
  .react-datepicker__header--time:not(.react-datepicker__header--time--only) {
    border-top-left-radius: 0;
  }
  .react-datepicker__header:not(.react-datepicker__header--has-time-select) {
    border-top-right-radius: 0.3rem;
  }

  .react-datepicker__year-dropdown-container--select,
  .react-datepicker__month-dropdown-container--select,
  .react-datepicker__month-year-dropdown-container--select,
  .react-datepicker__year-dropdown-container--scroll,
  .react-datepicker__month-dropdown-container--scroll,
  .react-datepicker__month-year-dropdown-container--scroll {
    display: inline-block;
    margin: 0 2px;
  }

  .react-datepicker__current-month,
  .react-datepicker-time__header,
  .react-datepicker-year-header {
    margin-top: 0;
    color: #000;
    font-weight: bold;
    font-size: 0.944rem;
  }

  .react-datepicker-time__header {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .react-datepicker__navigation {
    align-items: center;
    background: none;
    display: flex;
    justify-content: center;
    text-align: center;
    cursor: pointer;
    position: absolute;
    top: 2px;
    padding: 0;
    border: none;
    z-index: 1;
    height: 32px;
    width: 32px;
    text-indent: -999em;
    overflow: hidden;
  }
  .react-datepicker__navigation--previous {
    left: 2px;
  }
  .react-datepicker__navigation--next {
    right: 2px;
  }
  .react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {
    right: 85px;
  }
  .react-datepicker__navigation--years {
    position: relative;
    top: 0;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .react-datepicker__navigation--years-previous {
    top: 4px;
  }
  .react-datepicker__navigation--years-upcoming {
    top: -4px;
  }
  .react-datepicker__navigation:hover *::before {
    border-color: #a6a6a6;
  }

  .react-datepicker__navigation-icon {
    position: relative;
    top: -1px;
    font-size: 20px;
    width: 0;
  }
  .react-datepicker__navigation-icon--next {
    left: -2px;
  }
  .react-datepicker__navigation-icon--next::before {
    transform: rotate(45deg);
    left: -7px;
  }
  .react-datepicker__navigation-icon--previous {
    right: -2px;
  }
  .react-datepicker__navigation-icon--previous::before {
    transform: rotate(225deg);
    right: -7px;
  }

  .react-datepicker__month-container {
    float: left;
  }

  .react-datepicker__year {
    margin: 0.4rem;
    text-align: center;
  }
  .react-datepicker__year-wrapper {
    display: flex;
    flex-wrap: wrap;
    max-width: 180px;
  }
  .react-datepicker__year .react-datepicker__year-text {
    display: inline-block;
    width: 4rem;
    margin: 2px;
  }

  .react-datepicker__month {
    margin: 0.4rem;
    text-align: center;
  }
  .react-datepicker__month .react-datepicker__month-text,
  .react-datepicker__month .react-datepicker__quarter-text {
    display: inline-block;
    width: 4rem;
    margin: 2px;
  }

  .react-datepicker__input-time-container {
    clear: both;
    width: 100%;
    float: left;
    margin: 5px 0 10px 15px;
    text-align: left;
  }
  .react-datepicker__input-time-container .react-datepicker-time__caption {
    display: inline-block;
  }
  .react-datepicker__input-time-container .react-datepicker-time__input-container {
    display: inline-block;
  }
  .react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input {
    display: inline-block;
    margin-left: 10px;
  }
  .react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input {
    width: auto;
  }
  .react-datepicker__input-time-container
    .react-datepicker-time__input-container
    .react-datepicker-time__input
    input[type='time']::-webkit-inner-spin-button,
  .react-datepicker__input-time-container
    .react-datepicker-time__input-container
    .react-datepicker-time__input
    input[type='time']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .react-datepicker__input-time-container
    .react-datepicker-time__input-container
    .react-datepicker-time__input
    input[type='time'] {
    -moz-appearance: textfield;
  }
  .react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter {
    margin-left: 5px;
    display: inline-block;
  }

  .react-datepicker__time-container {
    float: right;
    border-left: 1px solid #aeaeae;
    width: 85px;
  }
  .react-datepicker__time-container--with-today-button {
    display: inline;
    border: 1px solid #aeaeae;
    border-radius: 0.3rem;
    position: absolute;
    right: -72px;
    top: 0;
  }
  .react-datepicker__time-container .react-datepicker__time {
    position: relative;
    background: white;
    border-bottom-right-radius: 0.3rem;
  }
  .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
    width: 85px;
    overflow-x: hidden;
    margin: 0 auto;
    text-align: center;
    border-bottom-right-radius: 0.3rem;
  }
  .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
    list-style: none;
    margin: 0;
    height: calc(195px + (1.7rem / 2));
    overflow-y: scroll;
    padding-right: 0;
    padding-left: 0;
    width: 100%;
    box-sizing: content-box;
  }
  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item {
    height: 30px;
    padding: 5px 10px;
    white-space: nowrap;
  }
  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item:hover {
    cursor: pointer;
    background-color: #f0f0f0;
  }
  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--selected {
    background-color: #216ba5;
    color: white;
    font-weight: bold;
  }
  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--selected:hover {
    background-color: #216ba5;
  }
  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--disabled {
    color: #ccc;
  }
  .react-datepicker__time-container
    .react-datepicker__time
    .react-datepicker__time-box
    ul.react-datepicker__time-list
    li.react-datepicker__time-list-item--disabled:hover {
    cursor: default;
    background-color: transparent;
  }

  .react-datepicker__week-number {
    color: #ccc;
    display: inline-block;
    width: 1.7rem;
    line-height: 1.7rem;
    text-align: center;
    margin: 0.166rem;
  }
  .react-datepicker__week-number.react-datepicker__week-number--clickable {
    cursor: pointer;
  }
  .react-datepicker__week-number.react-datepicker__week-number--clickable:hover {
    border-radius: 0.3rem;
    background-color: #f0f0f0;
  }

  .react-datepicker__day-names,
  .react-datepicker__week {
    white-space: nowrap;
  }

  .react-datepicker__day-names {
    margin-bottom: -8px;
  }

  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    color: #000;
    display: inline-block;
    width: 1.7rem;
    line-height: 1.7rem;
    text-align: center;
    margin: 0.166rem;
  }

  .react-datepicker__month--selected,
  .react-datepicker__month--in-selecting-range,
  .react-datepicker__month--in-range,
  .react-datepicker__quarter--selected,
  .react-datepicker__quarter--in-selecting-range,
  .react-datepicker__quarter--in-range {
    border-radius: 0.3rem;
    background-color: #216ba5;
    color: #fff;
  }
  .react-datepicker__month--selected:hover,
  .react-datepicker__month--in-selecting-range:hover,
  .react-datepicker__month--in-range:hover,
  .react-datepicker__quarter--selected:hover,
  .react-datepicker__quarter--in-selecting-range:hover,
  .react-datepicker__quarter--in-range:hover {
    background-color: #1d5d90;
  }
  .react-datepicker__month--disabled,
  .react-datepicker__quarter--disabled {
    color: #ccc;
    pointer-events: none;
  }
  .react-datepicker__month--disabled:hover,
  .react-datepicker__quarter--disabled:hover {
    cursor: default;
    background-color: transparent;
  }

  .react-datepicker__day,
  .react-datepicker__month-text,
  .react-datepicker__quarter-text,
  .react-datepicker__year-text {
    cursor: pointer;
  }
  .react-datepicker__day:hover,
  .react-datepicker__month-text:hover,
  .react-datepicker__quarter-text:hover,
  .react-datepicker__year-text:hover {
    border-radius: 0.3rem;
    background-color: #f0f0f0;
  }
  .react-datepicker__day--today,
  .react-datepicker__month-text--today,
  .react-datepicker__quarter-text--today,
  .react-datepicker__year-text--today {
    font-weight: bold;
  }
  .react-datepicker__day--highlighted,
  .react-datepicker__month-text--highlighted,
  .react-datepicker__quarter-text--highlighted,
  .react-datepicker__year-text--highlighted {
    border-radius: 0.3rem;
    background-color: #3dcc4a;
    color: #fff;
  }
  .react-datepicker__day--highlighted:hover,
  .react-datepicker__month-text--highlighted:hover,
  .react-datepicker__quarter-text--highlighted:hover,
  .react-datepicker__year-text--highlighted:hover {
    background-color: #32be3f;
  }
  .react-datepicker__day--highlighted-custom-1,
  .react-datepicker__month-text--highlighted-custom-1,
  .react-datepicker__quarter-text--highlighted-custom-1,
  .react-datepicker__year-text--highlighted-custom-1 {
    color: magenta;
  }
  .react-datepicker__day--highlighted-custom-2,
  .react-datepicker__month-text--highlighted-custom-2,
  .react-datepicker__quarter-text--highlighted-custom-2,
  .react-datepicker__year-text--highlighted-custom-2 {
    color: green;
  }
  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range,
  .react-datepicker__month-text--selected,
  .react-datepicker__month-text--in-selecting-range,
  .react-datepicker__month-text--in-range,
  .react-datepicker__quarter-text--selected,
  .react-datepicker__quarter-text--in-selecting-range,
  .react-datepicker__quarter-text--in-range,
  .react-datepicker__year-text--selected,
  .react-datepicker__year-text--in-selecting-range,
  .react-datepicker__year-text--in-range {
    border-radius: 0.3rem;
    background-color: #216ba5;
    color: #fff;
  }
  .react-datepicker__day--selected:hover,
  .react-datepicker__day--in-selecting-range:hover,
  .react-datepicker__day--in-range:hover,
  .react-datepicker__month-text--selected:hover,
  .react-datepicker__month-text--in-selecting-range:hover,
  .react-datepicker__month-text--in-range:hover,
  .react-datepicker__quarter-text--selected:hover,
  .react-datepicker__quarter-text--in-selecting-range:hover,
  .react-datepicker__quarter-text--in-range:hover,
  .react-datepicker__year-text--selected:hover,
  .react-datepicker__year-text--in-selecting-range:hover,
  .react-datepicker__year-text--in-range:hover {
    background-color: #1d5d90;
  }
  .react-datepicker__day--keyboard-selected,
  .react-datepicker__month-text--keyboard-selected,
  .react-datepicker__quarter-text--keyboard-selected,
  .react-datepicker__year-text--keyboard-selected {
    border-radius: 0.3rem;
    background-color: #2579ba;
    color: #fff;
  }
  .react-datepicker__day--keyboard-selected:hover,
  .react-datepicker__month-text--keyboard-selected:hover,
  .react-datepicker__quarter-text--keyboard-selected:hover,
  .react-datepicker__year-text--keyboard-selected:hover {
    background-color: #1d5d90;
  }
  .react-datepicker__day--in-selecting-range:not(
      .react-datepicker__day--in-range,
      .react-datepicker__month-text--in-range,
      .react-datepicker__quarter-text--in-range,
      .react-datepicker__year-text--in-range
    ),
  .react-datepicker__month-text--in-selecting-range:not(
      .react-datepicker__day--in-range,
      .react-datepicker__month-text--in-range,
      .react-datepicker__quarter-text--in-range,
      .react-datepicker__year-text--in-range
    ),
  .react-datepicker__quarter-text--in-selecting-range:not(
      .react-datepicker__day--in-range,
      .react-datepicker__month-text--in-range,
      .react-datepicker__quarter-text--in-range,
      .react-datepicker__year-text--in-range
    ),
  .react-datepicker__year-text--in-selecting-range:not(
      .react-datepicker__day--in-range,
      .react-datepicker__month-text--in-range,
      .react-datepicker__quarter-text--in-range,
      .react-datepicker__year-text--in-range
    ) {
    background-color: rgba(33, 107, 165, 0.5);
  }
  .react-datepicker__month--selecting-range
    .react-datepicker__day--in-range:not(
      .react-datepicker__day--in-selecting-range,
      .react-datepicker__month-text--in-selecting-range,
      .react-datepicker__quarter-text--in-selecting-range,
      .react-datepicker__year-text--in-selecting-range
    ),
  .react-datepicker__month--selecting-range
    .react-datepicker__month-text--in-range:not(
      .react-datepicker__day--in-selecting-range,
      .react-datepicker__month-text--in-selecting-range,
      .react-datepicker__quarter-text--in-selecting-range,
      .react-datepicker__year-text--in-selecting-range
    ),
  .react-datepicker__month--selecting-range
    .react-datepicker__quarter-text--in-range:not(
      .react-datepicker__day--in-selecting-range,
      .react-datepicker__month-text--in-selecting-range,
      .react-datepicker__quarter-text--in-selecting-range,
      .react-datepicker__year-text--in-selecting-range
    ),
  .react-datepicker__month--selecting-range
    .react-datepicker__year-text--in-range:not(
      .react-datepicker__day--in-selecting-range,
      .react-datepicker__month-text--in-selecting-range,
      .react-datepicker__quarter-text--in-selecting-range,
      .react-datepicker__year-text--in-selecting-range
    ) {
    background-color: #f0f0f0;
    color: #000;
  }
  .react-datepicker__day--disabled,
  .react-datepicker__month-text--disabled,
  .react-datepicker__quarter-text--disabled,
  .react-datepicker__year-text--disabled {
    cursor: default;
    color: #ccc;
  }
  .react-datepicker__day--disabled:hover,
  .react-datepicker__month-text--disabled:hover,
  .react-datepicker__quarter-text--disabled:hover,
  .react-datepicker__year-text--disabled:hover {
    background-color: transparent;
  }

  .react-datepicker__month-text.react-datepicker__month--selected:hover,
  .react-datepicker__month-text.react-datepicker__month--in-range:hover,
  .react-datepicker__month-text.react-datepicker__quarter--selected:hover,
  .react-datepicker__month-text.react-datepicker__quarter--in-range:hover,
  .react-datepicker__quarter-text.react-datepicker__month--selected:hover,
  .react-datepicker__quarter-text.react-datepicker__month--in-range:hover,
  .react-datepicker__quarter-text.react-datepicker__quarter--selected:hover,
  .react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover {
    background-color: #216ba5;
  }
  .react-datepicker__month-text:hover,
  .react-datepicker__quarter-text:hover {
    background-color: #f0f0f0;
  }

  .react-datepicker__input-container {
    position: relative;
    display: inline-block;
    width: 100%;
  }

  .react-datepicker__year-read-view,
  .react-datepicker__month-read-view,
  .react-datepicker__month-year-read-view {
    border: 1px solid transparent;
    border-radius: 0.3rem;
    position: relative;
  }
  .react-datepicker__year-read-view:hover,
  .react-datepicker__month-read-view:hover,
  .react-datepicker__month-year-read-view:hover {
    cursor: pointer;
  }
  .react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {
    border-top-color: #b3b3b3;
  }
  .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-year-read-view--down-arrow {
    transform: rotate(135deg);
    right: -16px;
    top: 0;
  }

  .react-datepicker__year-dropdown,
  .react-datepicker__month-dropdown,
  .react-datepicker__month-year-dropdown {
    background-color: #f0f0f0;
    position: absolute;
    width: 50%;
    left: 25%;
    top: 30px;
    z-index: 1;
    text-align: center;
    border-radius: 0.3rem;
    border: 1px solid #aeaeae;
  }
  .react-datepicker__year-dropdown:hover,
  .react-datepicker__month-dropdown:hover,
  .react-datepicker__month-year-dropdown:hover {
    cursor: pointer;
  }
  .react-datepicker__year-dropdown--scrollable,
  .react-datepicker__month-dropdown--scrollable,
  .react-datepicker__month-year-dropdown--scrollable {
    height: 150px;
    overflow-y: scroll;
  }

  .react-datepicker__year-option,
  .react-datepicker__month-option,
  .react-datepicker__month-year-option {
    line-height: 20px;
    width: 100%;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .react-datepicker__year-option:first-of-type,
  .react-datepicker__month-option:first-of-type,
  .react-datepicker__month-year-option:first-of-type {
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
  }
  .react-datepicker__year-option:last-of-type,
  .react-datepicker__month-option:last-of-type,
  .react-datepicker__month-year-option:last-of-type {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border-bottom-left-radius: 0.3rem;
    border-bottom-right-radius: 0.3rem;
  }
  .react-datepicker__year-option:hover,
  .react-datepicker__month-option:hover,
  .react-datepicker__month-year-option:hover {
    background-color: #ccc;
  }
  .react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,
  .react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,
  .react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {
    border-bottom-color: #b3b3b3;
  }
  .react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,
  .react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,
  .react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {
    border-top-color: #b3b3b3;
  }
  .react-datepicker__year-option--selected,
  .react-datepicker__month-option--selected,
  .react-datepicker__month-year-option--selected {
    position: absolute;
    left: 15px;
  }

  .react-datepicker__close-icon {
    cursor: pointer;
    background-color: transparent;
    border: 0;
    outline: 0;
    padding: 0 6px 0 0;
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    display: table-cell;
    vertical-align: middle;
  }
  .react-datepicker__close-icon::after {
    cursor: pointer;
    background-color: #216ba5;
    color: #fff;
    border-radius: 50%;
    height: 16px;
    width: 16px;
    padding: 2px;
    font-size: 12px;
    line-height: 1;
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    content: '×';
  }

  .react-datepicker__today-button {
    background: #f0f0f0;
    border-top: 1px solid #aeaeae;
    cursor: pointer;
    text-align: center;
    font-weight: bold;
    padding: 5px 0;
    clear: left;
  }

  .react-datepicker__portal {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.8);
    left: 0;
    top: 0;
    justify-content: center;
    align-items: center;
    display: flex;
    z-index: 2147483647;
  }
  .react-datepicker__portal .react-datepicker__day-name,
  .react-datepicker__portal .react-datepicker__day,
  .react-datepicker__portal .react-datepicker__time-name {
    width: 3rem;
    line-height: 3rem;
  }
  @media (max-width: 400px), (max-height: 550px) {
    .react-datepicker__portal .react-datepicker__day-name,
    .react-datepicker__portal .react-datepicker__day,
    .react-datepicker__portal .react-datepicker__time-name {
      width: 2rem;
      line-height: 2rem;
    }
  }
  .react-datepicker__portal .react-datepicker__current-month,
  .react-datepicker__portal .react-datepicker-time__header {
    font-size: 1.44rem;
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range,
  .react-datepicker__month-text--selected,
  .react-datepicker__month-text--in-selecting-range,
  .react-datepicker__month-text--in-range,
  .react-datepicker__quarter-text--selected,
  .react-datepicker__quarter-text--in-selecting-range,
  .react-datepicker__quarter-text--in-range,
  .react-datepicker__year-text--selected,
  .react-datepicker__year-text--in-selecting-range,
  .react-datepicker__year-text--in-range {
    border-radius: 1rem;
    background-color: #004f92 !important;
    color: #fff !important;
  }

  .react-datepicker__header {
    text-align: center;
    background-color: transparent;
    border-bottom: 0;
    border-top-left-radius: 0.3rem;
    padding: 8px 0;
    position: relative;
  }

  .react-datepicker__day:hover,
  .react-datepicker__month-text:hover,
  .react-datepicker__quarter-text:hover,
  .react-datepicker__year-text:hover {
    border-radius: 1rem;
    background-color: #f0f0f0;
    color: #555658;
  }

  .react-datepicker__day--keyboard-selected,
  .react-datepicker__month-text--keyboard-selected,
  .react-datepicker__quarter-text--keyboard-selected,
  .react-datepicker__year-text--keyboard-selected {
    border-radius: 1rem;
  }

  .datePicker {
    border-radius: 0;
    box-shadow: none;
    border: 0px solid #fff;
    font-family: Montserrat;
  }

  .datePicker .react-datepicker__current-month {
    color: #555658;
    font-size: 18px;
    font-weight: bolder;
    text-transform: capitalize;
  }

  .datePicker .react-datepicker__day-names {
    margin-top: 30px;
  }

  .datePicker .react-datepicker__day-name {
    color: #555658;
    font-size: 14px;
    font-weight: 600;
    text-transform: capitalize;
    margin: 0 10px;
  }

  .datePicker .react-datepicker__week {
    font-size: 14px;
    line-height: 18px;
    font-weight: 500;
    opacity: 1;
  }

  .datePicker .react-datepicker__day {
    color: #555658;
    font-weight: 600;

    margin: 10px;
  }

  .datePicker .react-datepicker__day--disabled {
    color: #8e959a;
    font-weight: 500;
    opacity: 0.7;
  }

  .datePicker .react-datepicker__navigation-icon::before {
    border-color: #161616;
    border-top-width: 2px;
    border-right-width: 2px;
  }

  .react-datepicker__day--outside-month {
    opacity: 0 !important;
    pointer-events: none;
  }

  .react-datepicker__day--keyboard-selected {
    background-color: #fff !important;
    color: #000;
  }
`,Go=m(pi)`
  @media (min-width: 900px) {
    display: none;
  }
`;N("pt-BR",Mr);const jo=({schedule:n,selectedDate:a,setSelectedDate:r,displayDates:o,setDisplayDates:l,displayDatesPicker:d,getSchedulesDatesByMonth:s,isOpen:c,setIsOpen:u,selectedItemToSchedule:p,loadSpecialistSlotsMonth:h})=>{const m=(null==o?void 0:o.length)?o[0]:void 0;return e(Ei,{visible:c,onClose:()=>u(!1),withoutCloseButton:!0,childrenFooter:t(i,{children:[e(pi,{title:"Pronto",onClick:()=>u(!1)}),e(Go,{tertiary:!0,title:"Fechar",onClick:()=>u(!1)})]}),children:e(Bo,{children:e(P,{calendarClassName:"datePicker",locale:"pt-BR",selectsStart:!1,openToDate:m,showPreviousMonths:!1,renderCustomHeader:t=>e(Ho,{...t,initialDate:m}),selected:a,onChange:e=>{if(null==o?void 0:o.length){if(!(null==o?void 0:o.slice(0,3)).some((t=>k(t,e)))){const t=null==o?void 0:o.slice(0,2);t&&l([...t,e])}}r(e)},inline:!0,includeDates:d,onMonthChange:e=>{var t;"SPECIALIST"===p&&h(e),(null==n?void 0:n.unitId)&&(null==n?void 0:n.itemId)&&(null==n?void 0:n.unitId)!==oa.TELEORIENTATION&&(null==n?void 0:n.itemId)!==oa.TELEORIENTATION&&s({unitIdSGH:n.unitId,itemId:n.itemId,isKit:n.isKit||!1,date:e,changeMonth:!0,resourceId:n.useResouce&&(null===(t=n.resource)||void 0===t?void 0:t.id)||null,localId:n.localId||""}),r(null)},placeholderText:"Selecione a data."})})})};function qo({selectedItemToSchedule:e,scheduleSpecialist:t,onSelectDate:i,setDisplayDates:a,setDisplayDatesPicker:r,setLoading:o,setSelectedDate:l,setProductTimes:d}){const[s,c]=n.useState([]),{resource:u,dateHours:p}=t;async function h(e){o(!0);const t=await ha({professionalId:Number(u.professionalId),companyId:u.companyId,medicalProcedureIds:Number(u.medicalProcedureId),startDate:w(e.startDate,"yyyy-MM-dd"),endDate:w(e.endDate,"yyyy-MM-dd")}),i=p?[...p,...t.data]:t.data;!function(e){const t=[];e.map(((e,i)=>{const n=new Date(e.date+"T00:00:00");t.push(n)})),a(t),r(t)}(i),c(i),o(!1)}function m(e){l(e);const t=s.find((t=>t.date===w(e,"yyyy-MM-dd"))),i=[];null==t||t.hours.map((e=>{i.push({id:x(),time:new Date(t.date+`T${e}:00`),slots:[]})})),d(i)}return n.useEffect((()=>{if("SPECIALIST"===e&&p){!async function(e){const{endDate:t}=Dr(Or(e)-(new Date).getDate());await h({startDate:e,endDate:new Date(t)})}(new Date(p[p.length-1].date+"T00:00:00"))}}),[]),n.useEffect((()=>{if(s.length){m(new Date(s[0].date+"T00:00:00"))}}),[s]),{getSpecialistTimes:m,loadSpecialistSlotsMonth:async function(e){const t=new Date(e);t.setDate(1);const i=new Date(e);i.setDate(Or(e)),await h({startDate:t,endDate:new Date(i)})},onSelectDateSpecialist:t=>{l(t),"SPECIALIST"===e&&m&&m(t)}}}const Wo=({schedules:a,schedule:r,setHasScheduleSameDateTime:o,setLoadingSlots:l,setSelectedDate:d,selectedDate:s,selectedTime:c,setSelectedTime:u,selectedItemToSchedule:h,handleGoBack:m,setIsProductWithProfessional:g,scheduleSpecialist:f})=>{const[v,b]=n.useState(),[y,S]=n.useState(!1),[E,I]=n.useState(),[C,P]=n.useState(),[N,M]=n.useState([]),{findUnitDatesAvailable:D,eavSlotsData:O}=_(he,(e=>e)),{state:R}=_(A,(e=>e)),{scheduleForRemove:L,scheduleDateToRemove:U,scheduleHourToRemove:$}=R;n.useEffect((()=>{g(N.some((e=>!!e.slots.some((e=>!!e.resourceId)))))}),[N]),n.useEffect((()=>{var e,t;if("PRODUCT"===h||"PRODUCT_ENV"===h||"SERVICE_ENV"===h){if(null==r?void 0:r.unitId){const i=D(r.unitId);if(i){const n=F(i);I(n.slice(0,3)),P(n);const[a]=n;a&&z({unitId:(null==r?void 0:r.unitId)||"",itemId:(null==r?void 0:r.itemId)||"",isKit:(null==r?void 0:r.isKit)||!1,date:a,resourceId:r.useResouce&&(null===(t=null===(e=null==r?void 0:r.resource)||void 0===e?void 0:e.id)||void 0===t?void 0:t.toString())||null,localId:r.localId||""})}}if("EINSTEIN_TO_YOU"===(null==r?void 0:r.careType)){if(!O)return;const e=Object.keys(null==O?void 0:O.availableSchedules),t=F(e);I(t.slice(0,3)),P(t);const i=t[0];z({isKit:!1,itemId:"",resourceId:null,date:i,unitId:"",localId:""})}"TELEORIENTATION"===(null==r?void 0:r.channel)&&G()}}),[]);const F=e=>e.map((e=>new Date(e+"T00:00:00"))),V=e=>{a.map((t=>{t.idPatient===(null==t?void 0:t.idPatient)&&(null==t?void 0:t.id)!==t.id&&((e,t)=>{e&&(T(e.time,t.time)?(o(!0),p.warning("Já existe um agendamento nesse horário para o mesmo paciente.")):o(!1))})(t.time,e)}))},z=async({unitId:e,itemId:t,isKit:i,date:n,resourceId:a,localId:o})=>{if(u(void 0),"EINSTEIN_TO_YOU"===(null==r?void 0:r.careType)){if(!O)return;const e=Object.keys(null==O?void 0:O.availableSchedules).filter((e=>e===w(n,"yyyy-MM-dd"))).map((e=>null==O?void 0:O.availableSchedules[e].map((({intervalStart:t})=>{const i=new Date(t);return{id:x(),slots:[{date:e,hour:`${i.getHours()}:${i.getMinutes()}`}],time:i}})))).flat(1);e.length||p.warning("Essa data não possui horários disponíveis. Selecione outra data.");const t=e.sort(((e,t)=>e.time>t.time?1:-1));console.log("orderedLiost=>:",t),M(t),l(!1)}else{(e=>{var t;(null==r?void 0:r.unitId)&&(null==r?void 0:r.itemId)&&H({unitIdSGH:r.unitId,itemId:r.itemId,isKit:r.isKit||!1,date:e,resourceId:r.useResouce&&(null===(t=null==r?void 0:r.resource)||void 0===t?void 0:t.id)||null,localId:r.localId||""})})(n),l(!0);const d=(e=>e.toISOString().split("T")[0])(n);try{const n=await(async({unitId:e,itemId:t,isKit:i,date:n,resourceId:a,localId:r})=>{let o={unitId:e,itemId:t,isKit:i,date:n,resourceId:a};r&&(o={...o,localId:r});const l=await Te.get("slots/hours",{params:o}),{availableSchedules:d}=l.data;return d})({unitId:e,itemId:t,isKit:i,date:d,resourceId:a,localId:o}),r=n.map((e=>{const t=((e,t)=>{const i=new Date(e);return{id:x(),time:i,slots:t}})(`${e.date}T${e.hour}`,[e]);return t}));r.length||p.warning("Essa data não possui horários disponíveis. Selecione outra data.");const s=r.filter((e=>L&&e.slots[0].date===U?e.slots[0].hour!==$:e)).sort(((e,t)=>e.time>t.time?1:-1));M(s),l(!1)}catch(e){l(!1),console.error(e)}}},H=async({unitIdSGH:e,itemId:t,isKit:i,date:n,resourceId:a,changeMonth:r,localId:o})=>{try{l(!0),r||d(n);const u=new Date;n.getMonth()>u.getMonth()&&(u.setDate(1),u.setMonth(n.getMonth()),u.setFullYear(n.getFullYear()));const p=(s=n.getMonth()+1,c=n.getFullYear(),new Date(c,s,0).getDate()),h=new Date(n.getFullYear(),n.getMonth(),p),m=await pa({unitId:e,itemId:t,isKit:i,startDate:w(u,"yyyy-MM-dd"),endDate:w(h,"yyyy-MM-dd"),resourceId:a,localId:o}),g=F(m.slotDates);P(g),l(!1)}catch(e){l(!1),p.error("Falha ao carregar dados. Tente novamente mais tarde.")}var s,c},B=(e,t)=>{var i;if(d(e),"TELEORIENTATION"===(null==r?void 0:r.channel)){let i;i=t?null==t?void 0:t.find((t=>k(new Date(t.time),e))):null==v?void 0:v.find((t=>k(new Date(t.time),e)));const n=[];null==i||i.slots.map((e=>{n.push({time:new Date(e.hour),slots:[e],id:x()})})),M(n.sort(((e,t)=>e.time>t.time?1:-1)))}"TELEORIENTATION"!==(null==r?void 0:r.channel)&&("PRODUCT"!==h&&"PRODUCT_ENV"!==h&&"SERVICE_ENV"!==h||z({unitId:(null==r?void 0:r.unitId)||"",itemId:(null==r?void 0:r.itemId)||"",isKit:(null==r?void 0:r.isKit)||!1,date:e,resourceId:(null==r?void 0:r.useResouce)&&(null===(i=null==r?void 0:r.resource)||void 0===i?void 0:i.id)||null,localId:(null==r?void 0:r.localId)||""}),"SPECIALIST"===h&&j&&j(e))},G=async()=>{l(!0);const e=Dr(15),t=await(async e=>{const t={error:!1,errorStatus:null,message:"",data:[]};try{const i=await Me.get("slots",{params:e});return{...t,data:i.data}}catch(e){return{...t,error:!0}}})({startDate:w(e.today,"yyyy-MM-dd"),endDate:w(e.endDate,"yyyy-MM-dd")}),{data:i,error:n}=t;if(n&&(p.error("Não foi possível consultar agenda no momento."),m()),!n&&(i.length||(p.error("Sem agenda disponível no momento."),m()),i.length)){const e=[],t=i.map((t=>(e.push(new Date(t.date)),{id:"",time:new Date(t.date),slots:t.slots})));b(t),I(e);const[n]=e;B(n,t),P(e)}l(!1)},{getSpecialistTimes:j,loadSpecialistSlotsMonth:q}=qo({onSelectDate:B,selectedItemToSchedule:h||"",setDisplayDates:I,setDisplayDatesPicker:P,scheduleSpecialist:f,setLoading:l,setProductTimes:M,setSelectedDate:d});return t(i,{children:[e(Mo,{displayDates:E||[],selectedDate:s,onSelectDate:B,handleClickSeeMore:()=>S(!0)}),!!s&&e(So,{times:N,selectedTime:c,onSelectedTime:e=>{u(e),V(e)}}),e(jo,{schedule:r,selectedDate:s,setSelectedDate:e=>{e&&B(e)},displayDates:E,setDisplayDates:I,displayDatesPicker:C,getSchedulesDatesByMonth:H,isOpen:y,setIsOpen:S,selectedItemToSchedule:h,loadSpecialistSlotsMonth:q})]})};function Yo(e){const t=e.split(" - Digital")[0];if("Enfermeiro da Família"===t||"Médico da Família"===t){const e=t.split(" da");return`${e[0]}(a) da${e[1]}`}return t}const Xo=()=>v`
    border-radius: 8px;
  `,Ko=()=>v`
    border-radius: 28px;
  `,Qo=m.div`
  ${({hasResults:e,fullWidth:t,rounded:i})=>v`
    position: relative;
    height: 58px;

    .input-wrapper {
      position: absolute;
      z-index: 5;
      width: 100%;
      box-shadow: ${e||t?"0px 5px 6px -2px #00000014;":"none"};
    }

    ${Pn} {
      border-radius: 8px;
      border: ${t?0:"1px solid #d5d5d6;"};
      ${t&&Xo()}
      ${i&&Ko()}
    }

    ${Zo} {
      box-shadow: ${t?"none":"0px 5px 6px -2px #00000014"};
    }

    ${Dn} {
      margin-right: ${t?"0":"0 10px"};
      padding-left: ${t?"0":"16px"};
    }

    ${Jo} {
      padding: ${t?"15px 32px":"15px 20px"};
    }

    ${Pn} {
      padding: ${t?"0 32px":"0"};
    }

    .loading-wrapper {
      padding-top: 3rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `}
`,Zo=m.ul`
  padding: 0;
  position: absolute;
  background-color: #fff;
  width: 100%;
  margin: 10px 0;
  padding-top: 56px;
  list-style: none;
  box-shadow: 0px 5px 6px -2px #00000014;
`,Jo=m.li`
  display: flex;
  align-items: center;
  justify-content: space-between;

  cursor: pointer;

  p {
    color: var(--blue-einstein);
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
    margin-right: 16px;
  }

  img {
    width: 24px;
    height: 24px;
  }
`,el=m.div`
  svg {
    width: 100px;
  }
`,tl=({loading:t})=>t?e(el,{children:e("svg",{version:"1.1",id:"L9",xmlns:"http://www.w3.org/2000/svg",xmlnsXlink:"http://www.w3.org/1999/xlink",x:"0px",y:"0px",viewBox:"0 0 100 100",enableBackground:"new 0 0 0 0",xmlSpace:"preserve",children:e("path",{fill:"#e9e9e9",d:"M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50",children:e("animateTransform",{attributeName:"transform",attributeType:"XML",type:"rotate",dur:"1s",from:"0 50 50",to:"360 50 50",repeatCount:"indefinite"})})})}):null,il=({onChange:n,placeholder:r,debounceTime:d,results:s=[],searchIcon:c=!0,onClickResult:u=(()=>{}),onFocus:p,fullWidth:h=!1,label:m,iconLeft:g=!1,clickOnIcon:f,error:v,autoFocus:b,clearIcon:y,rounded:_,value:x="",onBlur:S=(()=>{}),handleChangeValue:w=(()=>{}),handleClearIcon:E=(()=>{}),testId:k=""})=>{const[T,I]=a(x),C=function(e,t){const i=l();return function(...n){i.current&&window.clearTimeout(i.current),i.current=window.setTimeout((()=>{e(...n)}),t)}}(n,d||500),[P,N]=a(!1);o((()=>{N(!1)}),[s,v]),o((()=>{I(x)}),[x]);const M=()=>g?e(i,{children:g}):c?e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/search.svg",alt:""}):null;return t(Qo,{hasResults:!!s.length,fullWidth:h,rounded:_,children:[e("div",{className:"input-wrapper",children:e(On,{icon:M()?M():null,clickOnIcon:f,value:T,onChange:async e=>{e.currentTarget.value.length>0&&N(!0),w(e.currentTarget.value),I(e.currentTarget.value),C(e.currentTarget.value)},placeholder:r,label:m,onFocus:()=>{p&&p(T)},autoFocus:b,onBlur:S,"data-testid":k,iconRight:e(i,{children:y&&T?e("div",{style:{cursor:"pointer"},onClick:()=>{I(""),E&&E()},children:t("svg",{xmlns:"http://www.w3.org/2000/svg",xmlnsXlink:"http://www.w3.org/1999/xlink",width:"24",height:"24",viewBox:"0 0 24 24",children:[e("defs",{children:e("clipPath",{id:"clip-path",children:e("rect",{id:"Frame",width:"24",height:"24",transform:"translate(334 192)",fill:"#d5d5d6"})})}),e("g",{id:"Apagar",transform:"translate(-334 -192)",clipPath:"url(#clip-path)",children:t("g",{id:"Icon",transform:"translate(334.586 192.586)",children:[e("line",{id:"Line",x1:"12",y1:"12",transform:"translate(5.415 5.414)",fill:"none",stroke:"#d5d5d6",strokeLinecap:"round",strokeWidth:"2"}),e("line",{id:"Line-2","data-name":"Line",x1:"12",y2:"12",transform:"translate(5.415 5.414)",fill:"none",stroke:"#d5d5d6",strokeLinecap:"round",strokeWidth:"2"})]})})]})}):null})})}),P?e("div",{className:"loading-wrapper",children:e(tl,{loading:!0})}):null,s.length>0&&!P&&e(Zo,{children:s.map(((i,n)=>t(Jo,{onClick:()=>{u(i.value),I(i.value)},children:[e("p",{children:i.key}),e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/arrow-right.svg",alt:"Arrow Icon"})]},n+i.value)))})]})},nl=m.div`
  ${({theme:e})=>v`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 14px 0;
    cursor: pointer;

    &:not(:last-child) {
      border-bottom: 1px solid ${e.colors.colorGray300};
    }

    .icon {
      width: 48px;
      border-radius: 50%;
    }
  `}
`,al=m.div`
  ${({theme:e})=>v`
    padding: 0 16px;
    gap: 4px;
    width: 100%;

    .title {
      font-size: 16px;
      font-weight: ${e.fontWeight.medium};
      color: ${e.colors.colorGray500};
    }

    .subtitle {
      font-size: 14px;
      font-weight: ${e.fontWeight.medium};
      color: ${e.colors.colorGray400};
    }
  `}
`,rl="https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/estetoscopio.svg",ol=({subtitle:i,icon:n,title:a,type:r,onClick:o})=>{const l=e=>`https://agendamento-images-nprd.telemedicinaeinstein.com.br/icons/${e}`;return t(nl,{onClick:o,children:["SPECIALIST"===r&&e("img",{className:"icon",src:n||"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/patient.svg",alt:"specialist"}),"PRODUCT"===r&&e("img",{className:"icon",src:n&&l(n)||rl,alt:"product"}),"SPECIALTY"===r&&e("img",{className:"icon",src:rl,alt:"specialty"}),"SERVICE"===r&&e("img",{className:"icon",src:n&&l(n)||rl,alt:"service"}),t(al,{children:[e("p",{className:"title",children:a}),e("p",{className:"subtitle",children:i})]}),e("img","SPECIALTY"===r?{className:"icon",src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/searchIconBlue.svg",alt:"specialty"}:{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/arrow-right.svg",alt:""})]})},ll=({resources:t,handleSelectResource:n,...a})=>e(i,{children:null==t?void 0:t.map((e=>d(ol,{...a,key:e.id,title:e.name,icon:e.icon,type:e.type.toUpperCase(),onClick:()=>n(e)})))}),dl=m.div`
  display: flex;
  align-items: baseline;
`,sl=m.input`
  width: 24px;
  height: 24px;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  background-clip: content-box;
  border: 1px solid #949494 !important;
  border-radius: 50%;
  padding: 0.375rem;
  margin: 0 0.75rem 0 0 !important;

  &:checked {
    border: 6px solid #004f92 !important;
  }
`,cl=m.label`
  font-size: 18px;
  cursor: pointer;
  color: #555658;
`,ul=({id:i,isChecked:n,label:a,onChange:r})=>t(dl,{children:[e(sl,{type:"radio",id:`check-${i}`,name:a,value:a,checked:n,onChange:r,readOnly:!r}),!!a&&e(cl,{htmlFor:a,children:a})]}),pl=m.div`
  padding: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  border-radius: 8px;
  box-shadow: 0px 8px 20px 0px #0000000f;
  gap: 16px;

  & + & {
    margin-top: 16px;
  }

  .icon-wrapper {
    background-color: #f2f6f9;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`,hl=m.div`
  display: grid;
  grid-template-columns: 1fr 4fr;
  align-items: center;
  width: 100%;

  .img-with-wrapper {
    display: inline-block;
    width: 30px;
    border-radius: 30px;
  }

  .img-without-wrapper {
    display: inline-block;
    width: 40px;
    border-radius: 30px;
  }

  & .info {
    display: flex;
    align-items: left;
    flex-direction: column;

    & .title {
      display: inline-block;
      margin: 0;
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
      color: var(--color-gray-500);
    }

    & .description {
      margin: 0;
      color: var(--color-gray-400);
      font-size: 14px;
      font-weight: 400;
    }
  }

  & .radio {
    margin-left: auto;
  }
`,ml=({onClick:i,iconSrc:n,iconWrapper:a,checked:r,title:o,description:l})=>t(pl,{onClick:i,children:[t(hl,{children:[n&&a&&e("div",{className:"icon-wrapper",children:e("img",{className:"img-with-wrapper",src:n,alt:"an icon"})}),n&&!a&&e("img",{className:"img-without-wrapper",src:n,alt:"an icon"}),t("div",{className:"info",children:[e("p",{className:"title",children:o}),!!l&&e("p",{className:"description",children:l})]})]}),e(ul,{id:o,isChecked:r})]}),gl=({serviceList:t,selectedService:n,handleSelectService:a})=>{function r(e){return ei[e]||ei.DEFAULT}return e(i,{children:t.map((t=>{return e(ml,{title:t.name,description:(i=t.name,{"Equipe do cuidado":"Consultas Clínicas Einstein","Imunização":"Vacinas","Médicos Einstein":"Consulte por médicos ou especialidades","PCR Covid-19":"Exames","Telemedicina Einstein":"Consulta virtual","Atenção Primária à Saúde Clínicas":"Consultas Clínicas Einstein","Saúde Ocupacional":"Exclusivo para colaborador Einstein"}[i]),iconSrc:r(t.name),onClick:()=>a(t),checked:!!n&&n.id===t.id},t.id);var i}))})};function fl(e){let t="";return e.map(((i,n)=>{t.length&&e.length!==n+1&&(t=`${t}, ${i}`),0===t.length&&(t=i),e.length===n+1&&(t=`${t} e ${i}`),1===e.length&&(t=i)})),t}function vl(e){const t=[];return e.map((e=>{t.push(e.name)})),t}function bl(e){return vl(e.filter((e=>"SPECIALTY"===e.item_type)))}function yl(e){return vl(e.filter((e=>"MEDICAL_FIELD"===e.item_type)))}function _l(e){const t=bl(e),i=yl(e);return fl(t.concat(i))}function xl(e){const t=bl(e),i=yl(e),n=function(e){return vl(e.filter((e=>"AREA_EXPERTISE"===e.item_type)))}(e);return fl(t.concat(i,n))}const Sl=({specialists:t,handleSelectResource:n,...a})=>e(i,{children:null==t?void 0:t.map((e=>d(ol,{...a,key:e.id,title:e.name,subtitle:_l(e.specialties),icon:e.profile_picture,type:"SPECIALIST",onClick:()=>n(e)})))}),wl=m.div`
  ${({theme:e})=>v`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 32px;

    h3 {
      margin-top: 16px;
      font-weight: ${e.fontWeight.medium};
      font-size: 16px;
      color: ${e.colors.colorGray400};
      text-align: center;
    }
  `}
`,El=({visible:n,info:a})=>e(i,{children:n&&t(wl,{children:[e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/searchIcon.svg",alt:"search icon"}),e("h3",{children:a})]})}),kl=({list:t,handleSelect:n,...a})=>e(i,{children:null==t?void 0:t.map((e=>d(ol,{...a,key:e.id,title:Gr(e.name),type:"SPECIALTY",onClick:()=>n(e)})))}),Tl=m.div`
  height: 100%;

  .loading-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`,Il=m.div`
  ${({standardSpacing:e})=>v`
    position: relative;
    padding: ${e?"0 32px":"20px 0"};
  `}
`,Cl=({fetchResources:a,standardSpacing:r,loading:o,resourcesSchedule:l,handleClickResult:d,changeContext:s,rounded:c,type:u,selectedService:p,handleSelectService:h,fetchSpecialists:m,specialistList:g=[],specialtyList:f=[]})=>{const[v,b]=n.useState("");return n.useEffect((()=>{b("")}),[u]),t(i,{children:[e(il,{fullWidth:r,onFocus:()=>{!r&&s&&s()},onChange:e=>{"RESOURCES"===u&&a(e),"SPECIALISTS"===u&&m&&m(e)},placeholder:"Pesquisar",rounded:c,value:v,handleChangeValue:b,iconLeft:r&&e("div",{style:{marginRight:"16px"},onClick:()=>{s&&s()},children:e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/arrow_left.svg"})}),autoFocus:r,clearIcon:!0}),e(Il,{className:"results-wrapper",standardSpacing:r,children:e(Tl,{"data-testid":"RESOURCES"===u?"resource-list":"service-list",children:o?e("div",{className:"loading-wrapper",children:e(tl,{loading:!0})}):t(i,{children:[t(i,{children:["RESOURCES"===u&&l&&t(i,{children:[e(kl,{list:f,handleSelect:e=>{d({type:"SPECIALTY",item:e}),b(e.name)}}),e(Sl,{specialists:g,handleSelectResource:e=>d({type:"SPECIALIST",item:e})}),e(ll,{resources:l,handleSelectResource:e=>d({type:"RESOURCE_SCHEDULE",item:e})}),e(El,{visible:!l.length&&!g.length&&!f.length,info:"Busque por vacinas, médicos ou especialidades"})]}),"SPECIALISTS"===u&&t(i,{children:[e(kl,{list:f,handleSelect:e=>{d({type:"SPECIALTY",item:e}),b(e.name)}}),e(Sl,{specialists:g,handleSelectResource:e=>d({type:"SPECIALIST",item:e})}),e(El,{visible:!g.length&&!f.length,info:"Busque por médicos ou especialidades"})]})]}),e(i,{children:"SERVICES"===u&&p&&h&&e(gl,{serviceList:l,selectedService:p,handleSelectService:h})})]})})})]})},Pl=m.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 24px;
`,Nl=m.div``,Ml=async e=>{const t={error:!1,errorStatus:null,message:"",data:{}};try{const i=await De.get("validate-specialist",{params:{active:1,limit:60,...e}});return t.data=i.data,t}catch(e){return t.error=!0,console.error(e),t}},Dl=async()=>{const e={error:!1,errorStatus:null,message:"",data:{}};try{const t=await De.get("validate-specialties",{params:{medical_indicator:1}});return e.data=t.data,e}catch(t){return e.error=!0,console.error(t),e}},Ol=m.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  h1 {
    font-weight: 600;
    font-size: 24px;
    margin: 10px 5px;
  }
`;m.div`
  height: var(--height-body-without-header);
  margin-top: 30px;
`,m.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;const Rl=C.object().shape({insuranceName:C.string().min(3,"muito curto").required(""),plan:C.string().min(3,"muito curto").required(""),benefiarcyNumber:C.string().min(3,"muito curto").required("")}),Al=m.div`
  box-sizing: border-box;
  background-color: #fff;
  margin: 8px 0;
  padding: 16px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  border-radius: 8px;
  box-shadow: 0px 8px 16px 0px #00000014;

  img {
    width: 40px;
    height: 40px;
  }

  .info-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;

    .column {
      display: flex;
      flex-direction: column;
      margin-left: 16px;

      .title {
        display: inline-block;
        font-size: 16px;
        line-height: 24px;
        color: #555658;
        font-weight: 500;
      }
      .subtitle {
        font-size: 14px;
        line-height: 22px;
        color: #898b8e;
        font-weight: 400;
      }
    }
  }

  a {
    margin-top: 16px;
    display: inline-block;
    font-size: 14px;
    text-decoration: underline;
    cursor: pointer;
    color: #009ddc;
  }
`,Ll=({icon:i,title:n,subtitle:a,onClick:r,checked:o})=>t(Al,{onClick:r,children:[t("div",{className:"info-wrapper",children:[e("img",{src:i,onError:({currentTarget:e})=>{e.onerror=null,e.src="https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/helth-plan.svg"},alt:"plan icon"}),t("div",{className:"column",children:[e("span",{className:"title",children:n||""}),e("span",{className:"subtitle",children:a||""})]})]}),e(ul,{id:n,isChecked:o})]}),Ul=m.form`
  display: flex;
  flex-direction: column;

  margin-top: 6px;
`,$l=m.p`
  font-size: 14px;
  font-weight: 500;
  color: var(--color-gray-400);
  margin-bottom: 6px;
`;m($n)`
  width: 100%;
`,m(Vn)`
  width: 100%;
`;const Fl=m.div`
  margin-top: 10px;
`;m.div`
  border-bottom: 1px solid var(--color-gray-100);
  margin: 16px 0;
`;const Vl=s((({handleChange:i,values:r,insuranceList:o,handleChangeTestOnly:l,errors:d},s)=>{const[c,u]=a([]),[p,h]=n.useState(""),m=e=>{if(h(e),e.length){const t=o.filter((t=>{if(t.value.toUpperCase().includes(e.toUpperCase()))return t}));u(t)}else u([]);o.find((({key:t})=>t===e))||i("insuranceName","")};return t(Ul,{ref:s,children:[e($l,{children:"Informe os dados do convênio"}),e(Fl,{children:e(il,{testId:"test-insurance-name",onChange:m,handleChangeValue:null!=l?l:m,onClickResult:e=>{i("insuranceName",e),u([])},onFocus:m,onBlur:()=>{p.length||u([])},placeholder:"Convênio",results:c,label:"Convênio",searchIcon:!1,value:p})})]})})),zl=m.div`
  height: 100%;
  padding: 0 32px;
  padding-top: 32px;
  overflow-y: auto;
`,Hl=m.div`
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  margin-bottom: 24px;
`,Bl=m.p`
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  color: #898b8e;

  margin-bottom: 24px;
`,Gl=m(Xi)``,jl=({payment:i,setPayment:n,handlePayment:a,setIsModalHealthInsuranceUnavailableVisible:r})=>{const l=I({initialValues:{insuranceName:"",plan:"",benefiarcyNumber:""},validationSchema:Rl,validateOnChange:!0,onSubmit:async e=>{n({...i,...e})}}),{eligibilityPlans:d,clearEligibilityPlans:s}=_(ve,(e=>e)),{selectedItemToSchedule:u}=_(Le,(e=>e)),{selectedSpecialist:p}=_(Tt,(e=>e)),{scheduleSpecialistSelected:h,changeScheduleSpecialist:m}=_(he,(e=>e)),{goBack:g}=_(A,(e=>e));o((()=>{i&&l.setValues({insuranceName:i.insuranceName||"",plan:i.plan||"",benefiarcyNumber:i.benefiarcyNumber||""})}),[]);const f=Hr(h);o((()=>{Object.keys(l.errors).map((e=>n({...i,[e]:""})))}),[l.errors]),o((()=>{l.isValid&&l.submitForm()}),[l.isValid,l.values]);const v=c((()=>{var e,t;return(null===(e=f.schedule)||void 0===e?void 0:e.unitHealthPlans)?null===(t=f.schedule.unitHealthPlans)||void 0===t?void 0:t.filter((e=>"PARTICULAR"!==e.health_plan.description)).map((({health_plan:e})=>({key:e.health_insurance.name,value:e.health_insurance.name}))):[]}),[f]),b=c((()=>{var e,t,i,n;return"PRESENTIAL"===f.schedule.attendanceType?null===(i=null===(t=null===(e=f.schedule)||void 0===e?void 0:e.unitHealthPlans)||void 0===t?void 0:t.find((({health_plan:e})=>"PARTICULAR"===e.description)))||void 0===i?void 0:i.price:null===(n=null==p?void 0:p.units.find((({name:e})=>e===f.schedule.unit.name)))||void 0===n?void 0:n.telemedicine_consultation.price}),[p,f]);return t(zl,{children:[e(en,{goBack:()=>{m({...h,payment:{type:te}}),s(),g()},title:"Escolha o método de compra"}),"SPECIALIST"===u?t(Hl,{children:[(null==i?void 0:i.type)===oe.PARTICULAR&&e(Gl,{info:"O pagamento será feito no ato do atendimento.",icon:e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warningBlue.svg"})}),e(Ll,{icon:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/particularDollar.svg",title:"Particular",onClick:()=>{n({type:oe.PARTICULAR,price:b})},checked:(null==i?void 0:i.type)===oe.PARTICULAR}),e(Ll,{icon:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/helth-plan.svg",title:"Plano de saúde",onClick:()=>{r(!0)},checked:(null==i?void 0:i.type)===oe.HEALTH_INSURANCE}),(null==i?void 0:i.type)===oe.HEALTH_INSURANCE&&e(Vl,{insuranceList:v,values:l.values,errors:l.errors,handleChange:(e,t)=>{var i,a,r,o;l.setFieldValue(e,t);const d=null===(a=null===(i=f.schedule)||void 0===i?void 0:i.unitHealthPlans)||void 0===a?void 0:a.find((({health_plan:e})=>e.health_insurance.name===t));n({type:oe.HEALTH_INSURANCE,insuranceName:null!==(r=null==d?void 0:d.health_plan.health_insurance.name)&&void 0!==r?r:"",plan:null!==(o=null==d?void 0:d.health_plan.description)&&void 0!==o?o:"",healthInsuranceId:null==d?void 0:d.health_plan.health_insurance.id})}})]}):d&&t(Hl,{children:[e(Bl,{children:"Planos cadastrados"}),d.map(((t,n)=>{var r;return e(Ll,{icon:t.image?t.image:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/helth-plan.svg",title:t.nome,onClick:()=>a({type:ie,eligibility:{idInsurance:t.id_convenio,idCustomer:t.id_cliente,codInsurance:t.cod_convenio,codPlan:t.cod_plano,codOffice:t.cod_escritorio,plan:t.nome,image:t.image}}),checked:(null===(r=null==i?void 0:i.eligibility)||void 0===r?void 0:r.plan)===t.nome&&(null==i?void 0:i.type)===ie},n)}))]})]})},ql=m.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  & .title {
    font-weight: 500;
    font-size: 24px;
    color: var(--color-gray-500);
    line-height: 32px;
    text-align: center;
    width: 308px;
  }

  & .subtitle {
    font-weight: 500;
    font-size: 16px;
    color: var(--color-gray-400);
    line-height: 24px;
    text-align: center;
  }

  & .tel {
    font-weight: 600;
    font-size: 16px;
    color: var(--blue-einstein);
    line-height: 24px;
  }
`,Wl=m(pi)``,Yl=({visible:n,onClickClose:a})=>e(Ei,{visible:n,onClose:a,withoutCloseButton:!0,childrenFooter:e(i,{children:e(Wl,{disabled:!n,type:"button",title:"Fechar",tertiary:!0,onClick:a})}),children:t(ql,{children:[e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warning.svg",alt:"warning"}),e("h3",{className:"title",children:"Ainda não é possível agendar por aqui"}),t("p",{className:"subtitle",children:["Por enquanto, para informações relacionadas à operadoras de saúde entre em contato na central de atendimento:"," ",e("a",{className:"tel",href:"tel:+551121511233",children:"(11) 2151-1233"})," ","de segunda à sexta das 07h às 19hs."]})]})}),Xl=m.div`
  margin-top: 24px;
`,Kl=m.p`
  font: 16px Montserrat;
  font-weight: 400;
  color: #898b8e;
  line-height: 24px;
`,Ql=m.div`
  padding-top: 16px;
  padding-bottom: 24px;
`;m.div`
  img {
    display: inline-block;
    width: 56px;
    height: 56px;
  }

  h1 {
    font: 24px Montserrat;
    font-weight: 600;
    color: #000000;
  }

  p {
    font: 16px Montserrat;
    font-weight: 500;
    color: #555658;
  }

  margin-bottom: 16px;
`;const Zl=m.div`
  height: 1px;
  width: 100%;
  background-color: #e8e8e8;
  margin: 16px 0;
`,Jl=m.div`
  padding: 16px;
  box-shadow: 0px 8px 20px 0px #0000000f;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  cursor: pointer;

  & + & {
    margin-top: 16px;
  }
`,ed=m.p`
  display: inline-block;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #555658;
`,td=m.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: #898b8e;

  display: block;
  margin-top: 16px;

  & + & {
    margin-top: 8px;
  }
`;m.p`
  font-size: 14px;
  color: var(--blue-einstein);
  font-weight: 500;
`;const id=m.div`
  ${({isUnavailable:e})=>v`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    opacity: ${e?"0.5":"1"};
  `}
`,nd=m.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
`,ad=m.div`
  margin-top: 32px;
`,rd=({unit:i,isChecked:n,onSelectUnit:a,showRadio:r})=>e(Jl,{onClick:()=>a(i),children:e(id,{children:t(nd,{children:[t(id,{children:[e(ed,{children:Gr(i.name)}),e(td,{children:e("span",{children:`${i.unit_full_address||""}`})})]}),e(ad,{children:r&&e(ul,{isChecked:n})})]})})}),od=({units:i,onSelectUnit:n,selectedUnit:a})=>t(Xl,{children:[e(Zl,{}),e(Ql,{children:e(Kl,{children:"Unidade de atendimento"})}),i.map(((t,i)=>e(rd,{onSelectUnit:()=>{n(t)},unit:t,isChecked:(null==a?void 0:a.id)===t.id,showRadio:!0},t.id+i)))]}),ld=C.object().shape({cep:C.string().min(7,"CEP incompleto").required("Digite o CEP"),numero:C.string().min(1,"Numero inválido").required("Digite o numero"),logradouro:C.string().required("Informe o logradouro"),complemento:C.string().min(1,"muito curto").required("Digite o complemento")}),dd=m.div`
  ${({theme:e})=>v`
    margin: 24px 0;
    padding-top: 24px;
    border-top: 1px solid ${e.colors.colorGray100};
  `}
`,sd=m.p`
  ${({theme:e})=>v`
    font-size: 16px;
    font-weight: 400;
    color: ${e.colors.colorGray500};
    margin-bottom: 17px;
    line-height: 26px;
  `}
`,cd=m.form`
  display: flex;
  align-items: center;
  flex-direction: column;
`,ud=m.div`
  margin-top: 16px;
  width: 100%;
`,pd=m.div`
  display: flex;
  flex-direction: row;
  margin-top: 16px;

  div + div {
    margin-left: 16px;
  }
`,hd=m(pi)`
  padding: 16px;
`,md=m.div`
  height: 25rem;

  & iframe {
    width: 100%;
    height: 100%;
    border: 0;
  }
`,gd=({location:a,setLocation:r,setValidForm:l})=>{var d;const s=I({initialValues:{cep:"",logradouro:"",numero:"",complemento:"",pontoReferencia:"",cidade:"",uf:""},validationSchema:ld,validateOnChange:!1,onSubmit:async e=>{r({...a,...e})}}),[c,u]=n.useState(!1),[p,h]=n.useState(!1),[m,g]=n.useState({valid:!1,logradouro:""});o((()=>{a&&s.setValues({cep:a.cep||"",complemento:a.complemento||"",logradouro:a.logradouro||"",numero:a.numero||"",pontoReferencia:a.pontoReferencia||"",cidade:"",uf:""})}),[]);const f=async e=>{g({...m,valid:!1});const t=e.replace("-","").trim();if(8===t.length){h(!0);try{const{logradouro:e,localidade:i,uf:n,erro:a}=await(async e=>{const{data:t}=await Ie.get(`${e}/json/`);return t})(t);e&&(s.setFieldValue("logradouro",e),s.setFieldValue("cidade",i),s.setFieldValue("uf",n),s.setFieldValue("numero",""),g({valid:!0,logradouro:e})),a&&g({...m,valid:!1}),h(!1)}catch(e){h(!1),console.error(e)}}},v=async(e,t)=>{await s.setFieldValue(e,t);const i={...s.values,[e]:t};await ld.isValid(i)?(l(!0),s.submitForm()):l(!1)};return t(dd,{children:[e(sd,{children:"Informe seu CEP para verificarmos a disponibilidade"}),t(cd,{children:[e(ud,{children:e(Rn,{name:"cep",type:"text",placeholder:"CEP",label:"CEP",filled:m.valid,invalid:!m.valid&&9===s.values.cep.length,onChange:e=>{const t=(e=>{const t=e.replace(/[^\d]/g,""),i=t.length;return i<=8?e=t.replace(/(\d{5})(\d{1,3})/g,"$1-$2"):i>=9&&(e=e.substr(0,9)),e})(e.target.value);v("cep",t),!function(e){const t=/^[0-9]{5}-[0-9]{3}$/;return e.length>0&&t.test(e)}(t)?s.setFieldError("cep","CEP incompleto"):s.setFieldError("cep",""),f(e.target.value)},value:s.values.cep,error:s.errors.cep})}),m.valid&&t(i,{children:[e(ud,{children:e(On,{name:"logradouro",type:"text",placeholder:"Logradouro",label:"Logradouro",disabled:!0,onChange:e=>{const t=gt(e.target.value);v("logradouro",t)},value:s.values.logradouro,error:s.errors.logradouro})}),t(pd,{children:[e(Rn,{name:"numero",type:"text",placeholder:"Número",label:"Número",maxLength:8,filled:0===(null===(d=s.errors.numero)||void 0===d?void 0:d.length),onChange:e=>{const t=e.target.value.replace(/\D/g,"").replace(/[&/\\#,+()$~%.'":*?<>{}[\]@!]/g,"");v("numero",t),!function(e){const t=/^[0-9]+$/;return e.length>0&&t.test(e)}(t)?s.setFieldError("numero","Número inválido"):s.setFieldError("numero","")},value:s.values.numero,error:s.errors.numero}),e(On,{name:"complemento",type:"text",maxLength:30,placeholder:"Complemento",label:"Complemento",onChange:e=>{v("complemento",e.target.value)},value:s.values.complemento,error:s.errors.complemento})]}),e(ud,{children:e(On,{type:"text",name:"pontoReferencia",maxLength:30,placeholder:"Ponto de referência",label:"Ponto de referencia",onChange:e=>{v("pontoReferencia",e.target.value)},value:s.values.pontoReferencia,error:s.errors.pontoReferencia})})]}),e(hd,{link:!0,title:"Não sei o CEP",type:"button",onClick:()=>{u(!c)}})]}),e(nn,{loading:p}),e(hn,{onClose:()=>{u(!c)},visible:c,buttonClosePrimary:!0,children:c&&e(md,{children:e("iframe",{src:"https://buscacepinter.correios.com.br/app/endereco/index.php"})})})]})},fd=({genericModal:t,setLoadingChangeProduct:i,handleRemoveResource:n,selectedService:a,resetCoverageSelection:r,patientSelected:o,setSpecificUnitsResources:l})=>{const{goTo:d}=_(A,(e=>e)),{openModal:s}=_(Bi,(e=>e)),{changeProduct:c}=_(ge,(e=>e)),{selectedItem:u,changeSchedule:p,scheduleSpecialistSelected:h,setScheduleSpecialistSelected:m,changeScheduleSpecialist:g}=_(he,(e=>e)),{setEligibilityPlans:f,eligibilityPlans:v}=_(ve,(e=>e)),{addPatientList:b}=_(_e,(e=>e)),{handleAddPatient:y}=eo({addPatientList:b,changeProduct:c,eligibilityPlans:v,setEligibilityPlans:f,goTo:d,changeSchedule:p,selectedSchedule:u,openModal:s,scheduleSpecialistSelected:h,setScheduleSpecialistSelected:m,changeScheduleSpecialist:g});const x=async({product:e,showGenericModal:i,patient:n})=>{let a;if(e.rules&&!i&&(a=function({productRules:e,genericModalWhen:i}){const n=Qn(e);if(n&&Kn({genericModals:n,condition:Z,when:i}))return t.handleModalProps({condition:" INFO_GENERIC_RULES_CONDITION.always",visible:!0}),!0;return!1}({productRules:e.rules,genericModalWhen:$})),i||!a){const a=pe().setProduct(e),r=await y({patient:n,productSelected:e,itemToSchedule:"PRODUCT",schedule:a});i||(null==r?void 0:r.type)===Q&&t.handleModalProps({condition:Q,visible:!0})}};return e(ia,{when:$,condition:t.genericModalCondition,visible:t.modalGenericVisible,isVisible:t.setModalGenericVisible,handleActionButton:async(e,d)=>{i(!0);const s=await t.handleActionButtonModal(e,d);if((null==s?void 0:s.action)===V&&n(),(null==s?void 0:s.action)===z&&a){r();const e=(e=>a.products.find((t=>t.id===e)))(d);e&&o&&await x({product:e,showGenericModal:!0,patient:o})}(null==s?void 0:s.action)===W&&(l(s.data),n()),(null==s?void 0:s.action)===Y&&n(),i(!1)}})},vd=m.div`
  padding-bottom: 16px;
`,bd="https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/LocationBlue2.svg",yd="https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/TelemedicineCamera.svg",_d={PRESENTIAL:"Presencial",EINSTEIN_TO_YOU:"Einstein até você",TELEMEDICINE:"Telemedicina",DRIVE_THRU:"Drive-thru",PROCEDURE:"PROCEDURE"},xd=({coverages:n,selectedCoverage:a,handleSelectCoverage:r,productName:l,selectedItemToSchedule:d,coveragesSpecialists:s,selectedCoverageSpecialist:c,setSelectedCoverageSpecialist:u})=>{const p=e=>{switch(e.care_type){case le:return 1;case ce:return 2;case de:return 3;case se:return 4;default:return 10}},h=e=>{if(!(null==l?void 0:l.toUpperCase().includes("DIU")))switch(e.care_type){case le:return"Escolha uma unidade";case ce:return"Direto no seu carro";case de:return"Atendimento domiciliar";case se:return"Consulta virtual";default:return}},m=e=>{if(!(null==l?void 0:l.toUpperCase().includes("DIU")))switch(e.care_type){case le:return bd;case ce:return"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/car-front-blue.svg";case de:return"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/HomeBlue.svg";case se:return yd;default:return}},g=null==n?void 0:n.map((e=>e));return g&&g.sort(((e,t)=>p(e)-p(t))),o((()=>{1===(null==n?void 0:n.length)&&r(n[0])}),[n]),"PRODUCT"===d||"PRODUCT_ENV"===d||"SERVICE_ENV"===d?e(vd,{children:e(i,{children:null==g?void 0:g.map((t=>{return e(ml,{checked:!!a&&a.id===t.id,onClick:()=>r(t),title:(i=t.item_alias,n=t.care_type,"PROCEDURE"===n||(null==l?void 0:l.toUpperCase().includes("DIU"))?i:_d[n]),description:h(t),iconSrc:m(t)},t.id);var i,n}))})}):"SPECIALIST"===d?e(vd,{children:t(i,{children:[s.presential.length?e(ml,{checked:c.presencial,onClick:()=>{u({presencial:!0,telemedicine:!1,eav:!1})},title:"Presencial",description:"Escolha uma unidade",iconSrc:bd}):null,s.telemedicine.length?e(ml,{checked:c.telemedicine,onClick:()=>{u({presencial:!1,telemedicine:!0,eav:!1})},title:"Telemedicina",description:"Consulta virtual",iconSrc:yd}):null]})}):null},Sd=m.div`
  margin-top: 24px;
`,wd=m.p`
  font: 16px Montserrat;
  font-weight: 400;
  color: #898b8e;
  line-height: 24px;
`,Ed=m.div`
  padding-top: 16px;
  padding-bottom: 24px;
`;m.div`
  img {
    display: inline-block;
    width: 56px;
    height: 56px;
  }

  h1 {
    font: 24px Montserrat;
    font-weight: 600;
    color: #000000;
  }

  p {
    font: 16px Montserrat;
    font-weight: 500;
    color: #555658;
  }

  margin-bottom: 16px;
`;const kd=m.div`
  padding: 16px;
  box-shadow: 0px 8px 20px 0px #0000000f;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  cursor: pointer;

  & + & {
    margin-top: 16px;
  }
`,Td=m.p`
  display: inline-block;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #555658;
`,Id=m.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: #898b8e;

  display: block;
  margin-top: 16px;

  & + & {
    margin-top: 8px;
  }
`,Cd=m.p`
  font-size: 14px;
  color: var(--blue-einstein);
  font-weight: 500;
`,Pd=m.div`
  ${({isUnavailable:e})=>v`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    opacity: ${e?"0.5":"1"};
  `}
`,Nd=m.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
`,Md=m.div`
  margin-top: 32px;
`,Dd=({location:n,isChecked:a,closestDateAvailable:r,isOpenToSchedule:o,onLocationSelected:l,showRadio:d})=>{const s=o&&!r;return e(kd,{onClick:()=>!s&&l(n),children:t(Pd,{isUnavailable:s,children:[t(Nd,{children:[t(Pd,{children:[e(Td,{children:n.name}),t(Id,{children:[e("span",{children:`${n.address}, ${n.address_number}`}),e("br",{}),e("span",{children:`${n.neighborhood}, ${n.address_complement?n.address_complement+", ":""} ${n.city+" - "+n.state}`})]})]}),e(Md,{children:d&&e(ul,{id:n.id,isChecked:!s&&a})})]}),e(Zl,{}),o?e(Cd,{children:s?"Indisponível":`Data mais próxima: ${r}`}):n.business_unit_work_hour&&e(Cd,{children:(c=n,Ar(c).reduce(((n,a,r)=>0===r?e("span",{children:a}):t(i,{children:[n,e("br",{}),e("span",{children:a})]})),e(i,{})))})]})});var c};function Od(e,t){(null==t||t>e.length)&&(t=e.length);for(var i=0,n=new Array(t);i<t;i++)n[i]=e[i];return n}function Rd(e,t){var i="undefined"!=typeof Symbol&&e[Symbol.iterator]||e["@@iterator"];if(i)return(i=i.call(e)).next.bind(i);if(Array.isArray(e)||(i=function(e,t){if(e){if("string"==typeof e)return Od(e,t);var i=Object.prototype.toString.call(e).slice(8,-1);return"Object"===i&&e.constructor&&(i=e.constructor.name),"Map"===i||"Set"===i?Array.from(e):"Arguments"===i||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)?Od(e,t):void 0}}(e))||t&&e&&"number"==typeof e.length){i&&(e=i);var n=0;return function(){return n>=e.length?{done:!0}:{done:!1,value:e[n++]}}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var Ad={xs:0,sm:576,md:768,lg:992,xl:1200},Ld=function(){function e(e){var t=this,i=this;void 0===e&&(e=Ad),this.breakpoints=Ad,this.events={in:[],out:[],changed:[]},this.media=function(e){return window.matchMedia(e).matches},this.query=function(e){return t.media(e)},this.min=function(e){return t.query("(min-width: "+e+"px)")},this.max=function(e){return t.query("(max-width: "+e+"px)")},this.up=function(e){return t.min(e)},this.down=function(e){return t.max(e)},this.between=function(e,i){return t.query("(min-width: "+e+"px) and (max-width: "+i+"px)")},this.isTouch=function(){return t.query("(pointer: coarse)")},this.isMouse=function(){return t.query("(pointer: fine)")},this.xs=function(){return t.up(t.breakpoints.xs)},this.sm=function(){return t.up(t.breakpoints.sm)},this.md=function(){return t.up(t.breakpoints.md)},this.lg=function(){return t.up(t.breakpoints.lg)},this.xl=function(){return t.up(t.breakpoints.xl)},this.on=function(e,i,n){i instanceof Function&&t.events[e].push({media:n,callback:i,value:n()}),t.initEvents()},this.off=function(){var e=[].slice.call(arguments),t=e[0],n=e[1],a=e[2];i.events[t]=void 0===n?[]:i.events[t].filter(void 0===a?function(e){return!(e.callback===n)}:function(e){return!(e.callback===n&&e.media===a)}),i.initEvents()},this.resize=function(){for(var e in t.events)for(var i,n=Rd(t.events[e]);!(i=n()).done;){var a=i.value,r=a.media();a.value!==r&&("changed"===e?a.callback():"in"===e?!0===r&&a.callback():"out"===e&&!1===r&&a.callback(),a.value=r)}},this.initEvents=function(){for(var e in t.events)if(t.events[e].length)return void window.addEventListener("resize",(function(){t.resize()}));window.removeEventListener("resize",t.resize)},this.setBreakpoints(e)}return e.prototype.setBreakpoints=function(e){this.breakpoints={xs:e.xs,sm:e.sm,md:e.md,lg:e.lg,xl:e.xl}},e}(),Ud=new Ld;Ud.query;var $d=Ud.min;Ud.max,Ud.up,Ud.down,Ud.between,Ud.isTouch,Ud.isMouse,Ud.xs,Ud.sm,Ud.md,Ud.lg,Ud.xl,Ud.setBreakpoints;var Fd={xs:0,sm:576,md:768,lg:992,xl:1200};new(function(){function e(e){var t=this,i=this;void 0===e&&(e=Fd),this.breakpoints=Fd,this.events={in:[],out:[],changed:[]},this.media=function(e){return window.matchMedia(e).matches},this.query=function(e){return t.media(e)},this.min=function(e){return t.query("(min-width: "+e+"px)")},this.max=function(e){return t.query("(max-width: "+e+"px)")},this.up=function(e){return t.min(e)},this.down=function(e){return t.max(e)},this.between=function(e,i){return t.query("(min-width: "+e+"px) and (max-width: "+i+"px)")},this.isTouch=function(){return t.query("(pointer: coarse)")},this.isMouse=function(){return t.query("(pointer: fine)")},this.xs=function(){return t.up(t.breakpoints.xs)},this.sm=function(){return t.up(t.breakpoints.sm)},this.md=function(){return t.up(t.breakpoints.md)},this.lg=function(){return t.up(t.breakpoints.lg)},this.xl=function(){return t.up(t.breakpoints.xl)},this.on=function(e,i,n){i instanceof Function&&t.events[e].push({media:n,callback:i,value:n()}),t.initEvents()},this.off=function(){var e=[].slice.call(arguments),t=e[0],n=e[1],a=e[2];i.events[t]=void 0===n?[]:i.events[t].filter(void 0===a?function(e){return!(e.callback===n)}:function(e){return!(e.callback===n&&e.media===a)}),i.initEvents()},this.resize=function(){for(var e in t.events)for(var i,n=Rd(t.events[e]);!(i=n()).done;){var a=i.value,r=a.media();a.value!==r&&("changed"===e?a.callback():"in"===e?!0===r&&a.callback():"out"===e&&!1===r&&a.callback(),a.value=r)}},this.initEvents=function(){for(var e in t.events)if(t.events[e].length)return void window.addEventListener("resize",(function(){t.resize()}));window.removeEventListener("resize",t.resize)},this.setBreakpoints(e)}return e.prototype.setBreakpoints=function(e){this.breakpoints={xs:e.xs,sm:e.sm,md:e.md,lg:e.lg,xl:e.xl}},e}());const Vd=m.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;

  & .title {
    font-weight: 500;
    font-size: 24px;
    color: var(--color-gray-500);
    line-height: 32px;
    text-align: center;
    width: 308px;
  }

  & .subtitle {
    font-weight: 500;
    font-size: 16px;
    color: var(--color-gray-400);
    line-height: 24px;
    text-align: center;
  }

  & .date {
    font-weight: 600;
    font-size: 16px;
    color: var(--color-gray-500);
    line-height: 24px;
    text-align: left;
    width: 100%;
  }

  & .link {
    font-weight: 600;
    font-size: 16px;
    color: var(--blue-einstein);
    line-height: 24px;
    padding-top: 8px;
  }

  img {
    width: 120px;
    height: 120px;
  }
`,zd=m.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`,Hd=({visible:i,onClickClose:a,unit:r})=>{const[o,l]=n.useState([""]);return n.useEffect((()=>{r&&l(Ar(r))}),[r]),e(Ei,{visible:i,onClose:a,withoutCloseButton:!0,childrenFooter:e(pi,{disabled:!i,type:"button",title:$d(900)?"Voltar":"Fechar",onClick:a}),children:e(Vd,{children:t(zd,{children:[e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warning.svg",alt:"warning"}),e("h3",{className:"title",children:"Você não precisa agendar nessa unidade"}),r&&t("p",{className:"subtitle",children:["O atendimento presencial na ",`${Gr(r.name)}`," é por ordem de chegada.",e("p",{children:"Abaixo o horário de funcionamento:"})]}),t("p",{className:"date",children:[`${o.length>0&&o[0]}`,o.length>1&&o.slice(1,o.length).map(((i,n)=>t("span",{children:[e("br",{}),i]},n)))]}),e("a",{className:"link",href:"https://www.einstein.br/estrutura/centro-imunizacao/vacinas-disponiveis-no-einstein",target:"_blank",rel:"noreferrer",children:"Consulte aqui a disponibilidade da vacina nas nossas unidades"})]})})})},Bd=({openToScheduleUnits:r,closedToScheduleUnits:o,typePayment:l,onLocationSelected:d,selectedLocation:s,careType:c,hasResource:u})=>{const[p,h]=a(!0),[m,g]=a(),[f,v]=a(!1),[b,y]=a([]),[x,S]=a([]),{findUnitDatesAvailable:w,unitDatesAvailable:E}=_(he,(e=>e)),k=e=>{const t=w(e);return t&&t.length>0?Sr(new Date(t[0]+"T00:00:00"),"dd/MM/yyyy",{locale:Mr}):""};return n.useEffect((()=>{if(1===r.length){const e=r[0];k(e.id_sgh)&&d(e)}if(r.length&&E.length){const e=[],t=[];r.forEach((i=>{k(i.id_sgh)?e.push(i):t.push(i)})),y(e),S(t)}}),[r,E]),t(Sd,{children:[e(Zl,{}),c!==se&&e(Ed,{children:r.length+o.length>0&&e(i,{children:l===te||u?e(wd,{children:"Escolha uma unidade"}):p&&e(Xi,{icon:e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warningBlue.svg"}),info:"Unidades mais próximas atendidas pelo seu plano",closeButton:!0,onClickClose:()=>h(!1)})})}),b.map(((t,i)=>e(Dd,{onLocationSelected:()=>{d(t)},location:t,isChecked:(null==s?void 0:s.id)===t.id,closestDateAvailable:k(t.id_sgh),isOpenToSchedule:!0,showRadio:r.length+o.length!==1},t.id+i))),o.map((t=>e(Dd,{onLocationSelected:()=>{v(!0),g(t)},location:t,isChecked:(null==s?void 0:s.id)===t.id,closestDateAvailable:k(t.id_sgh),isOpenToSchedule:!1},t.id))),x.map(((t,i)=>e(Dd,{onLocationSelected:()=>{d(t)},location:t,isChecked:(null==s?void 0:s.id)===t.id,closestDateAvailable:k(t.id_sgh),isOpenToSchedule:!0},t.id+i))),e(Hd,{visible:f,unit:m,onClickClose:()=>v(!1)})]})},Gd=({selectedItemToSchedule:t,specialistUnitSelected:i,selectedUnit:a,eavLocation:r,setLoadingChangeProduct:o,coverageUnit:l,patientList:d,findProduct:s,findPatiendById:c,selectedCoverage:u,coveragesSpecialist:h,selectedSpecialist:m,selectedCoverageSpecialist:g,setEavSlotsData:f,getNotScheduledProducts:v,scheduleSpecialistSelected:b,changeScheduleSpecialist:y,changeSchedule:x,selectedItem:S})=>{const{productList:E}=_(ge,(e=>e)),{goTo:k}=_(A,(e=>e)),T=ra({changeSchedule:x,selectedSchedule:S}),I=async()=>{var e,n,a,_,x,I,C,P,N,M,D,R,A,L;if(o(!0),("PRODUCT"===t||"PRODUCT_ENV"===t||"SERVICE_ENV"===t)&&l&&S){if("EINSTEIN_TO_YOU"===(null===(e=l.coverage)||void 0===e?void 0:e.care_type))try{const{schedule:e}=v({patientList:d,productList:E})[0],t=s(e.productId),i=null===(n=null==t?void 0:t.coverages)||void 0===n?void 0:n.find((({care_type:e})=>"EINSTEIN_TO_YOU"===e)),{cep:u,logradouro:h,cidade:m,uf:g,numero:b,complemento:y,pontoReferencia:w}=r,k=l.coverage.rules.find((e=>e.ruleId===process.env.REACT_APP_SALES_FORCE_RULE_VALUE_ID)),T=l.coverage.rules.find((e=>e.ruleId===process.env.REACT_APP_SALES_FORCE_RULE_NAME_ID)),M=c(null!==(a=S.idPatient)&&void 0!==a?a:"");if(!M)return void p.error("Paciente não encontrado!");if(!k||!T)return void p.error("Regra do SalesForce não encontrada!");const{document:D,documentType:O,birthDate:R,email:A,gender:L,name:U,phone:$}=M,F=U.split(" "),V={patient:{document:D,documentType:O,birthDate:R,firstName:F.slice(0,-1).join(" "),lastName:F.slice(-1).join(" "),sex:"Masculino"===L?"M":"F",phoneNumber:$,email:A,address:{street:`${h}`,city:m,state:g,country:"Brasil",postalCode:u,number:b,complement:y,...w?{referencePoint:w}:{}}},schedules:[{itemId:null!==(_=null==i?void 0:i.item_SGH_id)&&void 0!==_?_:"",itemName:null!==(x=T.ruleValue)&&void 0!==x?x:"",salesForceId:null!==(I=k.ruleValue)&&void 0!==I?I:"",productId:null!==(C=e.id)&&void 0!==C?C:"",productName:null!==(P=e.productName)&&void 0!==P?P:"",careType:ca.EINSTEIN_TO_YOU,appointmentType:sa.IMMUNIZATION,catalogItemId:null!==(N=null==i?void 0:i.id)&&void 0!==N?N:""}],payment:{type:1,price:Number(null==t?void 0:t.price)}},z=await(async e=>{const t=await Ce.post("specialist/eav/slots",e).catch((function(e){var t;e.response?p.error(null===(t=e.response.data)||void 0===t?void 0:t.message):p.error("Houve um erro ao procurar agenda!")}));if(!t)return;const{data:i}=t;return i})(V);if(!z)return;f(z)}catch(e){console.log("err",e)}finally{o(!1)}const t=T.schedule;(null==u?void 0:u.channel)===oa.TELEORIENTATION&&(t.catalogItemId=null===(M=l.coverage)||void 0===M?void 0:M.id,t.productId=S.productId,t.itemId=oa.TELEORIENTATION,t.unit={},t.unitId=oa.TELEORIENTATION),T.addChannel((null==u?void 0:u.channel)||""),T.addCareType((null==u?void 0:u.care_type)||""),T.updateSchedule(),qi({event:"agendamento-einstein",categoria:(null===(R=null===(D=T.schedule)||void 0===D?void 0:D.productName)||void 0===R?void 0:R.includes("gripe"))?"Agendar-Vacina":"Agendar-Cuidado",acao:"step-4",rotulo:"tipo-de-atendimento",atendimento:null==u?void 0:u.care_type}),k(O.SERVICE_UNIT.id)}if("SPECIALIST"===t&&i){const e=Hr(b);try{const t=Number(i.external_platform.code_company),n=h.presential?-4:-5,{today:a,endDate:r}=Dr(4),o=await ha({professionalId:Number(i.external_platform.code_professional),companyId:t,medicalProcedureIds:n,startDate:w(a,"yyyy-MM-dd"),endDate:w(r,"yyyy-MM-dd")});if(o.error&&p.error("Não foi possível consultar agenda."),!o.error){0===o.data.length&&p.error("Esse especialista não possui agenda disponível.");const a=new Set,r=null===(L=null===(A=null==m?void 0:m.units.find((({name:e})=>e===i.name)))||void 0===A?void 0:A.services[0].office_service_health_plans)||void 0===L?void 0:L.filter((({health_plan:e})=>{const{health_insurance:t}=e,i=a.has(t.name);return a.add(t.name),!i}));0!==o.data.length&&(e.setUnit({attendanceType:g.presencial?"PRESENTIAL":"TELEMEDICINE",companyId:t,medicalProcedureId:n,office_id:i.id,unitName:i.name,professionalId:i.external_platform.code_professional,unitHealthPlans:r,crm:(null==m?void 0:m.professional_codes[0].value)||"",resourceName:(null==m?void 0:m.name)||"",specialistId:(null==m?void 0:m.id)||"",specialty:null==m?void 0:m.specialties[0],catalogUnitId:i.unit_id,unitAddress:i.unit_full_address}),y(e.setDateHours(o.data)),k(O.PAYMENT_VIEW.id))}}catch(e){console.error(e),p.error("Não foi possível consultar agenda.")}}o(!1)};return n.useEffect((()=>{(null==u?void 0:u.channel)===oa.TELEORIENTATION&&I()}),[u]),e(pi,{title:"Continuar",onClick:I,disabled:!(e=>{if("SPECIALIST"===t&&i)return!0;if("PRODUCT"===t||"PRODUCT_ENV"===t||"SERVICE_ENV"===t){if(e===se)return!!a;if(e===le||e===ue||e===ce)return!!a;if(e===de)return!!r}return!1})(null==u?void 0:u.care_type)})},jd=({productRules:t})=>{const[i,a]=n.useState("Escolha o tipo de atendimento");return n.useEffect((()=>{if(t){const e=Xn(t);e&&a(e)}}),[]),e(en,{title:i})},qd=({patientList:e,scheduleSpecialistSelected:t,setLoadingChangeProduct:i,selectedSpecialist:a,selectedItemToSchedule:r})=>{const[o,l]=n.useState({presential:[],telemedicine:[],eav:[]}),[d,s]=n.useState(),c=async({patient:e,office_id:t,specialist_id:i,payment:n})=>(await(async e=>{const t={error:!1,errorStatus:null,message:"",data:{}};try{const i=Xr(e.patient),n=await Ce.post("rule-validator/validate-ass",{...e,patient:i});return t.data=n.data,t}catch(e){return t.error=!0,console.error(e),t}})({patient:e,payment:n,specialist:{office_id:t,specialist_id:i}})).data.statusCode===Zr.OK||(p.error("Não foi possível selecionar a unidade."),!1);return n.useEffect((()=>{if("SPECIALIST"===r){const e={presential:[],telemedicine:[],eav:[]};null==a||a.units.map((t=>{t.attendance.telemedicine&&(e.telemedicine=[...e.telemedicine,t]),t.attendance.presential&&(e.presential=[...e.presential,t]),t.attendance.eav&&(e.presential=[...e.eav,t]),l(e)}))}}),[]),{coveragesSpecialist:o,onSelectUnitSpecialist:async n=>{i(!0);const{payment:r,idPatient:o}=t;if((null==a?void 0:a.id)&&r&&o){const t=e.find((e=>e.idPatient===o));if(t){await c({office_id:n.id,specialist_id:null==a?void 0:a.id,patient:t,payment:r})&&s(n)}}i(!1)},specialistUnitSelected:d,setSpecialistUnitSelected:s}},Wd=m.div`
  padding-bottom: 20px;
`,Yd=m.div`
  border: 1px solid #ffffff;
  padding: 32px 24px 32px;
  border-radius: 8px;
  -webkit-box-shadow: 0px 8px 20px 0px #0000000f;
  box-shadow: 0px 8px 20px 0px #0000000f;

  & + & {
    margin-top: 16px;
  }
`,Xd=m.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;

  .icon-wrapper {
    width: 48px;
    height: 48px;
    background-color: #ebf1f6;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 40px;
    }
  }

  img {
    display: inline-block;
    width: 48px;
    height: 48px;
  }

  .product-name {
    font-size: 16px;
    font-weight: 500;
    color: #555658;
  }

  .product-description {
    font-size: 14px;
    font-weight: 500;
    color: #898b8e;
  }
`,Kd=m.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  & + & {
    margin-top: 8px;
  }

  img {
    display: inline-block;
    width: 24px;
    height: 24px;
  }

  p {
    font-size: 14px;
    font-weight: 500;
    color: #555658;
  }

  span {
    font-size: 14px;
    line-height: 22px;
    color: #898b8e;
    font-weight: 400;
  }
`,Qd=m.div`
  font-weight: 500;
  color: #898b8e;
  font-size: 14px;
  line-height: 22px;
  margin-top: 8px;

  display: block;
  margin-left: 32px;
`,Zd=({resource:t,resourceSlot:n,productName:a})=>e(i,{children:e(mo,t?{imgSrc:t.image||`https://aps-digital.s3.amazonaws.com/profissionais/${t.crm}.jpg`,title:t.name,description:(null==t?void 0:t.role)?null==t?void 0:t.role:(null==t?void 0:t.roleList)?_l(null==t?void 0:t.roleList):""}:{imgSrc:`https://aps-digital.s3.amazonaws.com/profissionais/${null==n?void 0:n.resourceId}.jpg`,title:(null==n?void 0:n.resource)||"",description:a})}),Jd="https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/money.svg",es="https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/diu-insert-gray.svg",ts="https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/diu-remove-gray.svg",is="https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/stethoscopeIcon.svg",ns="https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/pre-natal.svg",as="https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/pre-natalGray.svg",rs=({unit:n,schedule:a,patient:r,product:o,selectedServiceId:l})=>{var d,s,c,u;let p,h;a.time&&(p=Rr(a.time.time)),a.payment&&(h=a.payment);const m=(null==h?void 0:h.type)===te||(null==h?void 0:h.type)===oe.PARTICULAR,g=(null==h?void 0:h.type)===ie,f=(null==h?void 0:h.type)===ne||(null==h?void 0:h.type)===oe.HEALTH_INSURANCE,v=a.careType===ce,b=a.careType===le||a.careType===ue,y=a.careType===de,_=a.careType===se,x=("Médico da Família"===o.name||"Enfermeiro da Família"===o.name)&&r.pregnant,S=e=>{const t={"Médico da Família":x?ns:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/estetoscopio.svg","Enfermeiro da Família":x?ns:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/medicine-bag.svg","Pré-natal":ns,"Inserção de DIU":es,"Remoção de DIU":ts}[e];return t||"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/vacinaEsquerda.svg"};return t(Yd,{children:[(({isSpecialist:e})=>{var t,i;return!(!e||(null===(t=o.coverages)||void 0===t?void 0:t.some((e=>"EXAM"!==e.category))))||l===process.env.REACT_APP_SERVICE_ID&&!(null===(i=o.coverages)||void 0===i?void 0:i.some((e=>"EXAM"!==e.category)))})({isSpecialist:!!a.useResouce&&!!a.resource})?e(Zd,{resource:a.useResouce?a.resource:void 0,resourceSlot:null===(d=a.selectedSlotOptions)||void 0===d?void 0:d[0],productName:Yo(a.productName||"")||""}):t(Xd,{children:[x||!o.icon?e("img",{src:S(o.name),alt:o.name}):e("div",{className:"icon-wrapper",children:e("img",{src:(k=o.icon,`https://agendamento-images-nprd.telemedicinaeinstein.com.br/icons/${k}`),alt:"product-icon"})}),t("div",{children:[e("p",{className:"product-name",children:Yo(o.name)}),a.scheduleType&&e("p",{className:"product-description",children:(E=a.scheduleType,{IMMUNIZATION:"Vacinas",PROCEDURE:x?"Consulta - Pré Natal":"Equipe do cuidado",EXAM:"Exames"}[E])})]})]}),e(Zl,{}),t(Kd,{children:[e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/user.svg",alt:"patient"}),e("p",{children:r.name})]}),a.useResouce&&a.resource&&t(Kd,{children:[e("img",{src:(e=>{const t={"Médico da Família":x?as:is,"Consulta médica":is,"Enfermeiro da Família":x?as:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/medicine-bag-gray.svg","Inserção de DIU":es,"Remoção de DIU":ts}[e];return t||es})(o.name),alt:o.name}),e("p",{children:(w=o.name,a.scheduleType!==ae.APPOINTMENT&&!ae.CONSULTATION||a.careType===ue?w:x?`Consulta ${w} - Pré Natal`:`Consulta  - ${w}`)})]}),t(Kd,{children:[e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/ScheduleDate.svg",alt:"date-and-hour"}),e("p",{children:p})]}),g&&t(Kd,{children:[e("img",{src:Jd,alt:"payment-eligibility"}),e("p",{children:null!==(c=null===(s=null==h?void 0:h.eligibility)||void 0===s?void 0:s.plan)&&void 0!==c?c:f})]}),f&&t(Kd,{children:[e("img",{src:Jd,alt:"payment-eligibility"}),e("p",{children:null===(u=a.payment)||void 0===u?void 0:u.insuranceName})]}),m&&t(Kd,{children:[e("img",{src:Jd,alt:"payment-particular"}),e("div",{children:e("p",{children:"Pagamento particular"})})]}),v&&t(Kd,{children:[e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/car-front.svg",alt:"drive-thru"}),e("p",{children:"Drive-thru"})]}),(b||v)&&!!n&&t(i,{children:[t(Kd,{children:[e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/location.svg",alt:"unit-details"}),e("p",{children:n.name})]}),t(Qd,{children:[n.address,n.address_number?`, ${n.address_number}`:"",e("br",{}),n.neighborhood?n.neighborhood:"",n.city?`, ${n.city}`:"",n.state?` - ${n.state}`:""]})]}),y&&e(i,{children:t(Kd,{children:[e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/location.svg",alt:"eav-details"}),e("p",{children:"Einstein até você"})]})}),_&&t(Kd,{children:[e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/Camera.svg",alt:"telemedicine"}),e("p",{children:"Consulta por telemedicina"})]})]});var w,E,k},os=m.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  h1 {
    font-weight: 600;
    font: 24px Montserrat;
    color: #000000;
  }

  .body-wrapper {
    overflow-y: auto;
    padding-top: 32px;
    padding-left: 32px;
    padding-right: 32px;
    padding-bottom: 1rem;
  }
`,ls=m.p`
  font-size: 16px;
  font-weight: 500;
  text-align: left;
  color: #898b8e;

  margin-top: 32px;
  margin-bottom: 24px;
`,ds=m.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: auto;
`;const ss=()=>{const e={};function t(e){var t;if(null==e?void 0:e.type){const i=(e=>{const t={};t.type=e;const i=()=>{t.type||re("Missing type property "),t.type===ie&&(t.planCode||re("Missing planCode property "),t.healthInsuranceId||re("Missing healthInsuranceId property "),t.nome||re("Missing nome property "))};return{setHelthInsuranceId:e=>{t.type===ie&&(t.healthInsuranceId=e)},setPlanCode:e=>{t.type===ie&&(t.planCode=e)},setName:e=>{t.type===ie&&(t.nome=e)},build:()=>(i(),t)}})(String(e.type));return e.eligibility&&(i.setHelthInsuranceId(String(null===(t=e.eligibility)||void 0===t?void 0:t.idInsurance)),i.setPlanCode(e.eligibility.codPlan),i.setName(e.insuranceName||e.eligibility.plan)),i.build()}}return{setPatient:function(t){const i=Yr(t.name);i.setBirthDate(t.birthDate),i.setDocument(t.document,t.documentType),i.setEmail(t.email),i.setPhone(t.phone),i.setGender(t.gender),i.setIsPregnant(t.pregnant),e.patient=i.build()},setSchedules:function({schedules:i,units:n}){e.schedules=i.map((e=>{const i=pe(e).validateSchedule(),n={};if(n.careType=i.careType,n.catalogItemId=i.catalogItemId,n.idConvenio=i.idConvenio,n.itemId=i.itemId,i.payment){const e=t(i.payment);e&&(n.payment=e)}return n.productId=i.productId,n.productName=i.productName,n.scheduleType=i.scheduleType,n.selectedSlotOptions=i.selectedSlotOptions,n.unit=i.unit,n}))},build:()=>e}},cs=e=>{const t={},i=Hr(e).validateSchedule();return{build:function(){return t.date=i.date,t.hour=i.hour,t.attendanceType=i.attendanceType,t.interval=i.interval,t.catalog=i.catalog,t.resource=i.resource,t.unit=i.unit,t.patient||re("Missing schedule.patient property"),t},setPatient:function(e){const i=Yr(e.name);i.setBirthDate(e.birthDate),i.setDocument(e.document,e.documentType),i.setEmail(e.email),i.setPhone(e.phone),i.setGender(e.gender),i.setIsPregnant(e.pregnant),t.patient=i.build()},setPayment:function(e){const i={};i.type=e.type,i.price=e.price,i.healthInsuranceId=e.healthInsuranceId,t.payment=i}}},us=({patientList:t,setLoading:i,completedSchedules:n,incompletedSchedules:a,handleSubmitErrorCallBack:r})=>{const{scheduleItems:o,units:l,setSelectedItem:d,setTokenSuccess:s,eavSlotsData:c,scheduleSpecialistSelected:u}=_(he,(e=>e)),{goTo:h}=_(A,(e=>e)),{findProduct:m}=_(ge,(e=>e)),{selectedItemToSchedule:g}=_(Le,(e=>e));function f(){const e=t.map((e=>((e,t,i)=>{const n=ss();return n.setPatient(e),n.setSchedules({schedules:t,units:i}),n.build()})(e,o,l)));return e}async function v(e){try{i(!0);const t=await(async e=>{const t=await Te.post("schedules",e,{headers:{channel:la.SCHEDULE_PLATFORM_WEB.toString()}}),{data:i}=t;return i})(e);t.token&&s&&s(t.token),h(O.CONCLUSION.id),i(!1)}catch(e){console.error(e),r&&r(),i(!1)}}async function b(e){try{i(!0);const t=await(async e=>{const t=await Me.post("schedule",e,{headers:{channel:la.SCHEDULE_PLATFORM_WEB.toString()}}),{data:i}=t;return i})(e);t.token&&s&&s(t.token),h(O.CONCLUSION.id),i(!1)}catch(e){console.error(e),p.error("Não foi possível realizar o agendamento."),i(!1)}}async function y(e){try{i(!0);const t=await(async e=>{const t=await Pe.post("schedules",e,{headers:{channel:la.SCHEDULE_PLATFORM_WEB.toString()}}),{data:i}=t;return i})(e);t.token&&s&&s(t.token),h(O.CONCLUSION.id),i(!1)}catch(e){console.error(e),p.error("Não foi possível realizar o agendamento."),i(!1)}}async function x(){var e,t;if(c){i(!0);const{availableSchedules:a,patient:r}=c,{schedule:o}=n[0],l=null===(e=null==o?void 0:o.selectedSlotOptions)||void 0===e?void 0:e[0];if(!m(o.productId))return p.error("Produto não encontrada!"),void i(!1);const d=a[null!==(t=null==l?void 0:l.date)&&void 0!==t?t:""].find((e=>{const t=new Date(e.intervalStart);if(`${t.getHours()}:${t.getMinutes()}`===(null==l?void 0:l.hour))return e}));if(!d)return p.error("Data não encontrada!"),void i(!1);const u=await(async e=>{const t={error:!1,errorStatus:null,message:"",data:{}};try{const i=await Ce.post("specialist/eav/schedule",e,{headers:{channel:la.SCHEDULE_PLATFORM_WEB.toString()}});return t.data=i.data,t}catch(e){return console.error(e),t.error=!0,t}})({patient:r,selectedSlotOptions:{start:d.intervalStart,end:d.intervalFinish}});u.error&&p.error("Houve um erro ao procurar agenda!"),u.error||(u.data.code&&s&&s(u.data.code),h(O.CONCLUSION.id))}i(!1)}return e(pi,{title:"Agendar",disabled:0!==a.length,onClick:()=>{var e,i;if(qi({event:"agendamento-einstein",categoria:(null===(i=null===(e=o[0])||void 0===e?void 0:e.productName)||void 0===i?void 0:i.includes("gripe"))?"Agendar-Vacina":"Agendar",acao:"step-6",rotulo:"confirmar-agendamento"}),"SPECIALIST"===g){const e=t.find((e=>e.idPatient===u.idPatient));if(e){const t=cs(u);if(t.setPatient(e),u.payment){const{type:e,healthInsuranceId:i,price:n}=u.payment;t.setPayment({type:String(e),healthInsuranceId:i,price:n})}y(t.build())}}if("PRODUCT"===g||"PRODUCT_ENV"===g||"SERVICE_ENV"===g)if((null==n?void 0:n[0].schedule.careType)===de)x();else{const[e]=f(),[t]=o;"TELEORIENTATION"===t.channel?b(e):v(e)}}})},ps=m.div`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #555658;
  text-align: center;

  h3 {
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
    text-align: center;
    margin-top: 24px;
  }

  .info1 {
    color: #898b8e;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    margin-top: 24px;
  }

  @media (min-width: 900px) {
    justify-content: space-between;
  }
`,hs=({visible:i,onClose:n})=>e(Ei,{childrenFooter:e(pi,{onClick:n,type:"button",title:"Escolher outro horário"}),visible:i,onClose:n,headTitle:"",children:t(ps,{children:[e("img",{className:"warn-image",src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warning.svg",alt:"warning"}),e("h3",{children:"Horário não disponível"}),e("p",{className:"info1",children:"Desculpe. Esse horário não está mais disponível. Por favor, selecione um novo horário."})]})}),ms=m.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  img {
    width: 154px;
    height: 154px;
    margin-bottom: 16px;
  }

  .title {
    font: 24px Montserrat;
    max-width: 294px;
    font-weight: 500;
    line-height: 29px;
    text-align: center;
    color: #555658;
    margin-bottom: 24px;
  }

  .subtitle {
    font: 19px Montserrat;
    max-width: 320px;
    font-weight: 400;
    line-height: 26px;
    text-align: center;
    color: #898b8e;
  }

  .code {
    margin-top: 24px;
    height: 41px;
    max-width: 310px;

    font: 32px Montserrat;
    font-weight: 600;
    line-height: 26px;
    text-align: center;
    color: #555658;
  }

  @media (max-width: 900px) {
    img {
      margin-bottom: 32px;
    }

    .title {
      margin-bottom: 32px;
    }
  }
`,gs=m.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`,fs=m.form`
  height: 100%;
  padding-top: 38px;
`,vs=m.div`
  margin-top: 32px;
`,bs=m.div`
  padding-bottom: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media (min-width: 900px) {
    padding-bottom: 56px;
    padding-top: ${({scheduleRemoved:e})=>e?"0":"64px"};
  }

  .conclusion-icon {
    margin-bottom: 24px;
  }

  .icon {
    width: 120px;
    margin-bottom: 24px;
  }
`,ys=m.h3`
  ${({theme:e})=>v`
    color: ${e.colors.colorGray500};
    font-weight: 500;
    font-size: 24px;
    text-align: center;
  `}
`,_s=({visible:a,onClose:r,scheduleId:l,setLoading:d,verificationCode:s,specialist:c})=>{const[u,h]=n.useState(!1),{setIsSchedulerOpen:m}=_(Ct,(e=>e));o((()=>{h(!1)}),[]);const g=async(e,t)=>{try{d(!0),c?await(async(e,t)=>{const i=await Ce.delete(`/specialist/schedules/${t}/${e}`),{data:n}=i;return n})(e,t):await(async(e,t)=>{const i=await Te.delete(`schedules/${t}/${e}`),{data:n}=i;return n})(e,t),h(!0),d(!1)}catch(e){d(!1),p.error("Não foi possível cancelar o agendamento"),console.error(e)}};return e(Ei,{visible:a,onClose:r,withoutCloseButton:!0,childrenFooter:t(i,{children:[!u&&e(pi,{title:"Sim",onClick:()=>{g(l,s)}}),e(pi,{title:u?"Fechar":"Não",tertiary:!u,onClick:()=>{u?(r(),m(!1)):r()}})]}),children:e(bs,{scheduleRemoved:!u,children:t(i,u?{children:[e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/conclusion.svg",alt:"",className:"icon"}),e(ys,{children:"Seu agendamento foi cancelado!"})]}:{children:[e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warning.svg",alt:"",className:"icon"}),e(ys,{children:"Tem certeza que deseja cancelar o agendamento?"})]})})})},xs=m.div`
  ${({theme:e})=>v`
    display: flex;
    flex-direction: row;
    padding: 16px 0;

    .icon {
      margin-right: 16px;
      width: 40px;
      display: flex;
      align-items: flex-start;

      .image {
        width: 40px;
        border-radius: 50%;
        height: 40px;
        object-fit: cover;
      }
    }

    .info {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .info .title {
      color: ${e.colors.colorGray400};
      font-size: 16px;
      line-height: 19px;
      font-weight: 500;
    }

    .info .subtitle {
      color: ${e.colors.colorGray500};
      font-size: 18px;
      font-weight: 500;
      line-height: 22px;
      margin-top: 2px;
    }

    .info .aditional {
      color: ${e.colors.colorGray400};
      font-size: 14px;
      font-weight: 500;
      line-height: 24px;
    }

    .info .link {
      color: ${e.colors.blueEinstein};
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      display: flex;
      align-items: center;
      gap: 12px;

      img {
        height: 26px;
      }
    }
  `}
`,Ss=m.div``,ws=m.div`
  ${({theme:e})=>v`
    ${xs}:not(:first-child) {
      border-top: 1px solid ${e.colors.colorGray100};
    }
  `}
`,Es=({icon:n,title:a,subtitle:r,adress:o,local:l,link:d})=>t(xs,{children:[e("div",{className:"icon",children:n}),t("div",{className:"info",children:[a&&!r?e(i,{children:e("p",{className:"subtitle",children:a})}):t(i,{children:[e("h5",{className:"title",children:a}),e("p",{className:"subtitle",children:r})]}),!!o&&e("p",{className:"aditional",children:o}),!!l&&e("p",{className:"aditional",children:l}),!!d&&t("a",{className:"link",href:d,target:"_blank",rel:"noreferrer",children:["Ir para consulta ",e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/EinsteinArrowRight.svg",alt:""})]})]})]}),ks="https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/patient.svg",Ts={EXAM:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/exam-icon.svg",IMMUNIZATION:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/vaccine-rouded.svg",DEFAULT:ks},Is={PRESENTIAL:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/pin-rouded.svg",EINSTEIN_TO_YOU:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/home-icon.svg",TELEMEDICINE:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/conference-cam.svg",DRIVE_THRU:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/car-rouded.svg"},Cs=({appointment:i})=>{var n,a,r;let o="";(null==i?void 0:i.date)&&i.hour&&(o=`${i.date}T${i.hour}`);return t(ws,{children:[(null==i?void 0:i.scheduleType)!==ae.CONSULTATION&&e(Es,{icon:e("img",{src:Ts[i.scheduleType]||Ts.DEFAULT}),title:(null==i?void 0:i.scheduleType)?Os[null==i?void 0:i.scheduleType]:"",subtitle:(null==i?void 0:i.product.name)||""}),(null==i?void 0:i.scheduleType)===ae.CONSULTATION&&(null==i?void 0:i.resource)&&e(Es,{icon:e("img",{className:"image",src:`https://aps-digital.s3.amazonaws.com/profissionais/${i.resource.crm}.jpg`,alt:"Specialist",onError:({currentTarget:e})=>{e.onerror=null,e.src=ks}}),title:(null==i?void 0:i.scheduleType)?(null==i?void 0:i.patient.isPregnant)?`Consulta ${i.product.name} - Pré Natal`:Os[null==i?void 0:i.scheduleType]:"",subtitle:i.resource.name||""}),e(Es,{icon:e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/calendar-rouded.svg"}),title:"Data",subtitle:o&&Rr(new Date(o))}),e(Es,{icon:e("img",{src:Is[null==i?void 0:i.careType]||Is.PRESENTIAL}),title:"Local",subtitle:(l=null==i?void 0:i.careType,d=null===(n=i.unit)||void 0===n?void 0:n.name,(l===Ms.TELEMEDICINE?Ds.TELEMEDICINE:l===Ms.PRESENTIAL?d:l===Ms.DRIVE_THRU?`${Ds.DRIVE_THRU} ${d}`:d)||""),adress:(null==i?void 0:i.careType)!==Ms.TELEMEDICINE?null===(a=null==i?void 0:i.unit)||void 0===a?void 0:a.addressLine1:void 0,local:(null==i?void 0:i.careType)!==Ms.TELEMEDICINE?null===(r=null==i?void 0:i.unit)||void 0===r?void 0:r.addressLine2:void 0,link:(null==i?void 0:i.careType)===Ms.TELEMEDICINE?i.virtualAppointmentUrl:void 0})]});var l,d},Ps={PRESENTIAL:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/pin-rouded.svg",EINSTEIN_TO_YOU:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/home-icon.svg",TELEMEDICINE:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/conference-cam.svg",DRIVE_THRU:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/car-rouded.svg"},Ns=({appointment:i})=>{let n="";(null==i?void 0:i.scheduleDate)&&i.scheduleTime&&(n=`${i.scheduleDate}T${i.scheduleTime}`);return t(ws,{children:[e(Es,{icon:e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/estetoscopio.svg",alt:"Specialist"}),title:"Consulta médica",subtitle:i.resourceName}),e(Es,{icon:e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/calendar-rouded.svg"}),title:"Data",subtitle:n&&Rr(new Date(n))}),e(Es,{icon:e("img",{src:Ps[i.attendance_type]||Ps.PRESENTIAL}),title:"Local",subtitle:(a=null==i?void 0:i.attendance_type,r=i.unit_name,(a===Ms.TELEMEDICINE?Ds.TELEMEDICINE:a===Ms.PRESENTIAL?r:a===Ms.DRIVE_THRU?`${Ds.DRIVE_THRU} ${r}`:r)||""),adress:(null==i?void 0:i.attendance_type)!==Ms.TELEMEDICINE?null==i?void 0:i.address:void 0})]});var a,r};var Ms;!function(e){e.PRESENTIAL="PRESENTIAL",e.EINSTEIN_TO_YOU="EINSTEIN_TO_YOU",e.TELEMEDICINE="TELEMEDICINE",e.DRIVE_THRU="DRIVE_THRU"}(Ms||(Ms={}));const Ds={PRESENTIAL:"Presencial",EINSTEIN_TO_YOU:"Einstein até você",TELEMEDICINE:"Consulta telemedicina",DRIVE_THRU:"Drive-thru"},Os={APPOINTMENT:"Consulta equipe de cuidado",CONSULTATION:"Consulta equipe de cuidado",EXAM:"Exame",IMMUNIZATION:"Vacina"};m.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 8px;
  width: 100%;

  @media (min-width: 900px) {
    height: 100%;
    justify-content: space-between;
  }
`;const Rs=m.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  margin-bottom: 32px;

  img {
    width: 56px;
    height: 56px;
  }
`,As=m.div``,Ls=m.h5`
  color: #555658;
  font-size: 18px;
  font-weight: 500;
  margin: 7px 0;
`;m.div`
  display: flex;
  align-items: center;
  gap: 10px;

  a {
    color: var(--blue-einstein);
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    text-decoration: none;
  }

  svg {
    width: 12px;
    fill: var(--blue-einstein);
  }
`;const Us=m.p`
  color: #555658;
  font-size: 18px;
  font-weight: 500;
`,$s=m.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  justify-content: space-between;
  margin-top: 24px;

  @media (min-width: 900px) {
    margin-top: 40px;
  }
`,Fs=m.div``,Vs=m.div`
  color: #898b8e;
  font-size: 14px;
  font-weight: 400;

  margin-top: 16px;
`,zs=m.div``,Hs=m.div`
  color: #898b8e;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 8px;
  text-align: justify;
  text-justify: inter-character;
`,Bs=m.div`
  margin-top: 16px;
`,Gs=m.div`
  margin-top: 24px;

  @media (min-width: 900px) {
    margin-top: 40px;
  }
`;m.div`
  margin-top: ${e=>e.showPrices?"55px":"64px"};

  @media (min-width: 900px) {
    margin-top: 0;
    padding: 24px 0;
  }
`;const js=()=>t("svg",{xmlns:"http://www.w3.org/2000/svg",xmlnsXlink:"http://www.w3.org/1999/xlink",width:"32",height:"32",viewBox:"0 0 32 32",children:[e("defs",{children:e("clipPath",{id:"clip-path",children:e("rect",{id:"Frame",width:"32",height:"32",transform:"translate(1631 413)",fill:"#e8e8e8"})})}),e("g",{id:"Icon",transform:"translate(-1631 -413)",clipPath:"url(#clip-path)",children:t("g",{id:"Icon-2","data-name":"Icon",transform:"translate(1631 413)",children:[t("g",{id:"Path",fill:"none",stroke:"#0376a3",strokeWidth:"2.6",children:[e("circle",{cx:"16",cy:"16",r:"16",stroke:"none"}),e("circle",{cx:"16",cy:"16",r:"14.7",fill:"none"})]}),e("path",{id:"Path-2","data-name":"Path",d:"M16,9.669v8",transform:"translate(0 0.492)",fill:"none",stroke:"#0376a3",strokeLinecap:"round",strokeWidth:"2.6"}),e("path",{id:"Path-3","data-name":"Path",d:"M16,22.331h0",transform:"translate(0 -0.492)",fill:"none",stroke:"#0376a3",strokeLinecap:"round",strokeWidth:"2.6"})]})})]}),qs=m.div`
  .icon-wrapper {
    background-color: #f2f6f9;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .img-with-wrapper {
    display: inline-block;
    width: 44px;
  }
`,Ws=({productIconName:t,serviceName:i})=>{let n=null,a=null;return t&&(a=`https://agendamento-images-nprd.telemedicinaeinstein.com.br/icons/${t}`),i&&(n=ei[i]||Jt.APPOINTMENT.icon),e(qs,{children:a?e("div",{className:"icon-wrapper",children:e("img",{className:"img-with-wrapper",src:a,alt:"an icon"})}):e("img",{src:n||"",alt:i})})},Ys=({handleAddProductList:n,onClose:a,product:r,titleMainButton:o,service:l,titleSecondaryButton:d})=>{const s=!l&&!(null==r?void 0:r.is_b2b);return e(po,{childrenFooter:t(i,{children:[e(pi,{title:o||"Adicionar",onClick:()=>{r&&(r.quantity=1,n({product:r,service:void 0})),l&&n({product:void 0,service:l})}}),e(Bs,{children:e(pi,{title:d||"Fechar",tertiary:!0,onClick:a})})]}),children:t(As,{children:[t(Rs,{children:[e(Ws,{productIconName:null==r?void 0:r.icon,serviceName:null==l?void 0:l.name}),e(Ls,{children:(null==r?void 0:r.name)||(null==l?void 0:l.name)})]}),t(Fs,{children:[t(zs,{children:[e(Hs,{children:(null==r?void 0:r.description)||(null==l?void 0:l.description)}),s&&t(i,{children:[e(Gs,{children:e(Xi,{info:"O agendamento por este canal é somente particular. Para informações de convênios entre em contato com a central de atendimento.",icon:e(js,{})})}),e($s,{children:t(Us,{children:[(null==r?void 0:r.price)&&(c=Number(null==r?void 0:r.price).toString(),new Intl.NumberFormat("pt-BR",{style:"currency",currency:"BRL"}).format(Number(c))),"*"]})})]})]}),s&&e(Vs,{children:"*Para atendimento em domicílio os valores podem sofrer alterações."})]})]})});var c};const Xs=m.div`
  background-color: #fff;
  padding: 72px 0 0 0;
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: 25;
`,Ks=({product:t,handleActionButton:i})=>e(pi,{title:"Continuar",disabled:!t,onClick:()=>{qi({event:"agendamento-einstein",categoria:"Agendar-Cuidado",acao:"step-3",rotulo:(null==t?void 0:t.name)||""}),i()}}),Qs=({products:t,setProductList:a,selected:r,handleSelect:o})=>{const{addGenericModals:l}=Vr({}),{selectedService:d}=_(M,(e=>e));n.useEffect((()=>{if(d){const e=function(e){return e.sort(((e,t)=>Number(e.priority)-Number(t.priority)))}(d.products);a(e)}}),[d]);return e(i,{children:t.map((t=>{return e(ml,{title:Yo(t.name),iconSrc:t.icon?(i=t.icon,`https://agendamento-images-nprd.telemedicinaeinstein.com.br/icons/${i}`):"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/estetoscopio.svg",iconWrapper:!0,onClick:()=>function(e){l({productRules:e.rules}),o({product:e})}(t),checked:!!r&&r.id===t.id},t.id);var i}))})},Zs=({productList:t,setModalGenericVisible:i,handleActionButtonModal:a,patientSelected:r,setGenericModalWhen:o,genericModalCondition:l,selectedProduct:d,selectedService:s,routeProductSelector:c,handleModalProps:u,setLoading:p,genericModal:h,...m})=>{const{openModal:g}=_(Bi,(e=>e)),{findProduct:f}=_(ge,(e=>e)),{goTo:v}=_(A,(e=>e)),{addUnitDatesAvailable:b,changeSchedule:y,selectedItem:x}=_(he,(e=>e)),{selectItemToSchedule:S,handleSelectProduct:w}=_(Le,(e=>e)),{handleSelectedCoverage:E,loading:k,unitDatesAvailable:T,selectedUnit:I,selectedCoverage:C}=$r({handleModalProps:u,changeSchedule:y,openModal:g,scheduleSelected:x}),{addGenericModals:P}=Vr({}),N=ra({changeSchedule:y,selectedSchedule:x}),M=aa({goTo:v,openModal:g});return n.useEffect((()=>{p(k)}),[k]),n.useEffect((()=>{b(T)}),[T]),n.useEffect((()=>{I&&(null==C?void 0:C.care_type)===se&&function(e){var t,i;N.addUnit({unit:e,localId:(null===(t=null==e?void 0:e.locations)||void 0===t?void 0:t.length)?null===(i=null==e?void 0:e.locations[0])||void 0===i?void 0:i.name:""}),N.updateSchedule(),S("PRODUCT");const n=f((null==d?void 0:d.id)||"");n&&w(n);v(O.SERVICE_UNIT.id)}(I)}),[I,C]),e(ia,{...m,handleActionButton:async function(e,n){if(e===j&&h.setGenericModalCondition(n),e!==B&&e!==G||i(!1),e===H){if(i(!1),d&&r){const e=f(d.id),t=M.handleTelemedicineProduct(e);(null==t?void 0:t.type)===na.only_telemedicine&&t.coverage&&E({coverage:t.coverage,patientSelected:r}),t||(l===Q?v(O.SERVICE_TYPE_PAGE.id):await c({alreadyShowModal:!0,productProp:d}))}d&&!r&&await c({alreadyShowModal:!0,productProp:d})}if(e===z&&(i(!1),s)){const e=(a=n,t.find((e=>e.id===a)));e&&r?(P({productRules:e.rules}),await c({productProp:e,alreadyShowModal:!0})):await c({productProp:e,alreadyShowModal:!0})}var a}})},Js=m.div`
  padding-bottom: 20px;
`,ec=m.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;

  #specialist-avatar {
    width: 80px;
    height: 80px;
    margin-bottom: 16px;
    border-radius: 80px;
  }

  #specialist-name {
    font: 18px Montserrat;
    font-weight: 500;
    line-height: 26px;
    text-align: center;
    color: #555658;
  }

  #specialist-code {
    font: 16px Montserrat;
    font-weight: 400;
    line-height: 22px;
    text-align: center;
    text-transform: uppercase;
    color: #898b8e;
  }
`,tc=m.div`
  margin-bottom: 32px;
`,ic=m.div`
  display: flex;
  align-items: flex-start;

  #detail-icon {
    width: 40px;
    height: 40px;
    margin-right: 16px;
  }

  div #detail-name {
    font: 14px Montserrat;
    font-weight: 500;
    line-height: 22px;
    color: #898b8e;
  }
`,nc=m.div`
  width: 100%;
  height: 1px;
  margin: 16px 0;
  background-color: #d5d5d6;
`,ac=m.button`
  height: 40px;
  width: 60%;
  background-color: white;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  border-color: #004f92;
  border-width: 1px;
  align-self: center;
  cursor: pointer;
  margin-top: 16px;

  p {
    font: 16px Montserrat;
    color: #004f92;
    font-weight: 500;
  }
`,rc=m.div``,oc=m.p`
  font: 14px Montserrat;
  font-weight: 500;
  line-height: 22px;
  color: #898b8e;
`,lc=m.a`
  font: 16px Montserrat;
  font-weight: 500;
  line-height: 22px;
  color: #004f92;
  text-decoration-color: #004f92;
  display: block;
`,dc=({unit:i})=>{var n;return t(rc,{children:[e(oc,{children:i.name&&Gr(i.name)}),null===(n=(e=>e.contacts.find((e=>"Contato para agendamento"===e.contact_type.name&&e.value.landlines.length)))(i))||void 0===n?void 0:n.value.landlines.map(((t,i)=>e(lc,{href:`tel:${xt(t)}`,children:St(t)},i)))]})},sc=m.div``,cc=m.p`
  margin-top: 4px;
  font: 16px Montserrat;
  font-weight: 500;
  line-height: 24px;
  color: #555658;
`,uc=m.p`
  font: 14px Montserrat;
  font-weight: 500;
  line-height: 22px;
  color: #898b8e;
`,pc=({unit:i})=>t(sc,{children:[e(cc,{children:i.name&&Gr(i.name)}),e(uc,{children:i.unit_full_address})]});function hc(e){let t="";return e.address&&(t=e.address),e.number&&(t=`${t} ${e.number}`),e.neighborhood&&(t=`${t}, ${e.neighborhood}`),e.city&&(t=`${t}, ${e.city}`),e.federated_state&&(t=`${t} - ${e.federated_state}`),t}const mc="https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/pin-rouded.svg",gc="https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/phone-blue.svg";const fc=m.div`
  img {
    position: absolute;
    z-index: 99;
    top: 0;
    width: 100%;
    height: 128px;
    object-fit: cover;
  }
`,vc=m.div`
  margin-top: 128px;
  padding: 32px;
`,bc=m.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`,yc=m.p`
  ${({theme:e})=>v`
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
    color: ${e.colors.colorGray500};
    padding-bottom: 16px;
  `}
`,_c=m.button`
  position: relative;
  z-index: 98;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  width: 40px;
  height: 40px;
  margin-left: 20px;
  border: none;
  cursor: pointer;

  img {
    width: 40px;
    height: 40px;
  }
`,xc=m.div`
  padding-top: 16px;
  padding-bottom: 12px;
  width: 100%;

  p#description {
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    color: ${Se.colors.colorGray400};
    display: block;

    span {
      color: ${Se.colors.colorGray500};
    }
  }

  div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    width: 100%;

    &#active {
      margin-bottom: 8px;
    }

    p {
      font-size: 16px;
      font-weight: 500;
      color: ${Se.colors.blueEinstein};
    }

    img {
      width: 24px;
      height: 24px;
      transform: rotate(0deg);
      transition: all 0.3s;
      cursor: pointer;
    }

    &#active img {
      transform: rotate(180deg);
      transition: all 0.3s;
    }
  }

  &:not(:last-child) {
    border-bottom: 1px solid #e8e8e8;
  }
`,Sc=m.ul`
  margin-top: 16px;

  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;

  li {
    list-style: none;
    padding: 8px 16px;
    background-color: #ebf1f6;
    border-radius: 16px;

    font-size: 16px;
    font-weight: 500;
    color: ${Se.colors.blueEinstein};
  }
`,wc=m.div`
  ${()=>v`
    padding-top: 16px;
    padding-bottom: 16px;

    display: flex;
    flex-direction: row;

    &:not(:last-child) {
      border-bottom: 1px solid #e8e8e8;
    }

    img {
      position: relative;
      width: 40px;
      height: 40px;
      margin-right: 16px;
    }
  `}
`,Ec=m.div`
  ${({theme:e})=>v`
    display: flex;
    flex-direction: column;
    width: 100%;

    p {
      display: inline-block;

      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      color: ${e.colors.colorGray500};

      + p {
        margin-top: 4px;
      }

      span {
        color: ${e.colors.colorGray400};
      }

      a {
        color: ${e.colors.blueEinstein};
        text-decoration: underline;
      }
    }

    .more-space {
      margin-top: 8px;
    }
  `}
`,kc={monday:"Segunda",tuesday:"Terça",thursday:"Quarta",wednesday:"Quinta",friday:"Sexta",saturday:"Sábado",sunday:"Domingo",holiday:"Feriado"},Tc=i=>{return kc[i.weekDay]&&i.period?t("p",{id:"description",children:[`${kc[i.weekDay]||i.weekDay}: `,e("span",{children:(n=i.period,"00:00-23:59"===n?"24h":n.replace("-"," às "))})]}):null;var n},Ic=({service_hours:t=[]})=>{const n=Object.entries(t).sort((([e],[t])=>Object.keys(kc).findIndex((t=>t===e))>Object.keys(kc).findIndex((e=>e===t))?1:-1));return e(i,{children:n.map((([t,i],n)=>e(Tc,{period:i,weekDay:t},n)))})},Cc="https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/arrow-down.svg",Pc=m.div`
  ${({theme:e})=>v`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 14px 0;
    cursor: pointer;

    &:not(:last-child) {
      border-bottom: 1px solid ${e.colors.colorGray300};
    }

    .icon {
      width: 40px;
      border-radius: 50%;
    }
  `}
`,Nc=m.div`
  ${({theme:e})=>v`
    padding: 0 16px;
    gap: 4px;
    width: 100%;

    .title {
      font-size: 16px;
      font-weight: ${e.fontWeight.medium};
      color: ${e.colors.colorGray500};
    }

    .subtitle {
      font-size: 14px;
      font-weight: ${e.fontWeight.medium};
      color: ${e.colors.colorGray400};
    }
  `}
`,Mc=({subtitle:i,icon:n,title:a,type:r,onClick:o})=>t(Pc,{onClick:o,children:["SPECIALIST"===r&&e("img",{className:"icon",src:n||"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/patient.svg",alt:"specialist"}),"SPECIALTY"===r&&e("img",{className:"icon",src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/estetoscopio.svg",alt:"specialty"}),t(Nc,{children:[e("p",{className:"title",children:Gr(a)}),e("p",{className:"subtitle",children:i?Gr(i):""})]}),e("img","SPECIALTY"===r?{className:"icon",src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/searchIconGray.svg",alt:"specialty"}:{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/arrow-right-gray.svg",alt:""})]}),Dc=({specialists:t,handleSelectResource:n,...a})=>e(i,{children:null==t?void 0:t.map((e=>d(Mc,{...a,key:e.id,title:e.name,subtitle:_l(e.specialties),icon:e.profile_picture,type:"SPECIALIST",onClick:()=>n(e)})))}),Oc=m.div`
  ${({theme:e})=>v`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 32px;

    h3 {
      margin-top: 16px;
      font-weight: ${e.fontWeight.medium};
      font-size: 16px;
      color: ${e.colors.colorGray400};
      text-align: center;
    }
  `}
`,Rc=({visible:n,info:a})=>e(i,{children:n&&t(Oc,{children:[e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/searchIcon.svg",alt:"search icon"}),e("h3",{children:a})]})}),Ac=({list:t,handleSelect:n,...a})=>e(i,{children:null==t?void 0:t.map((e=>d(Mc,{...a,key:e.id,title:e.name,type:"SPECIALTY",onClick:()=>n(e)})))}),Lc=m.div`
  height: 100%;

  .loading-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`,Uc=m.div`
  ${({standardSpacing:e})=>v`
    position: relative;
    padding: ${e?"0 32px":"20px 0 0"};
  `}
`,$c=({standardSpacing:a,loading:r,handleClear:o,handleClickResult:l,changeContext:d,placeholder:s,rounded:c,fetchSpecialists:u,specialistList:p=[],specialtyList:h=[],initialValue:m,clarIcon:g=!0,handleClearIcon:f})=>{const[v,b]=n.useState("");return n.useEffect((()=>{b(null!=m?m:"")}),[m]),t(i,{children:[e(il,{fullWidth:a,placeholder:s||"Pesquisar",rounded:c,value:v,handleChangeValue:b,iconLeft:a&&e("div",{style:{marginRight:"16px"},onClick:()=>{d&&d(),o&&o()},children:e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/arrow_left.svg"})}),autoFocus:a,onFocus:()=>{!a&&d&&d()},onChange:e=>{u&&u(e)},clearIcon:g,handleClearIcon:f}),e(Uc,{className:"results-wrapper",standardSpacing:a,children:e(Lc,{"data-testid":"service-list",children:r?e("div",{className:"loading-wrapper",children:e(tl,{loading:!0})}):a?t(i,{children:[e(Ac,{list:h.sort(((e,t)=>e.name.localeCompare(t.name))),handleSelect:e=>{l({type:"SPECIALTY",item:e,inputText:e.name}),b(e.name)}}),e(Dc,{specialists:p,handleSelectResource:e=>l({type:"SPECIALIST",item:e,inputText:v})}),e(Rc,{visible:!p.length&&!h.length,info:"Busque por médicos ou especialidades"})]}):e(i,{})})})]})},Fc=({specialistList:t,specialty:n,selectedSpecialist:a,handleSelectSpecialist:r})=>e(i,{children:t.map((t=>e(ml,{title:Gr(t.name),description:n,iconSrc:t.profile_picture?t.profile_picture:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/patient.svg",onClick:()=>r(t),checked:!!a&&a.id===t.id},t.id)))}),Vc=m.div`
  display: flex;
  flex-direction: column;
`,zc=m.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border: 1.4px solid #d5d5d6;
  border-radius: 8px;
  height: 54px;
  padding: 0 12px;
  margin: 6px 0;
  cursor: pointer;

  ${({isSelected:e})=>e&&v`
      border: 1.8px solid #004f92;
      background-color: rgba(235, 241, 247, 255);
    `}

  img {
    width: 14px;
    height: 14px;
  }
`,Hc=m.h2`
  ${({theme:e})=>v`
    width: 80%;
    font-size: 16px;
    font-weight: ${e.fontWeight.medium};
    color: #555658;
  `}
`,Bc=m.div`
  display: flex;
  width: 26px;
  height: 26px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid #d5d5d6;

  ${({isSelected:e})=>e&&v`
      background-color: #004f92;
    `}

  img {
    width: 14px;
    height: 14px;
  }

  div {
    background-color: #ffffff;
    width: 14px;
    height: 14px;
    border-radius: 50%;
  }
`,Gc=t=>t?e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/check.svg",alt:"check"}):e("div",{}),jc=({title:i,isSelected:n,isMultipleSelect:a,onSelectItem:r})=>t(zc,{isSelected:n,onClick:r,children:[e(Hc,{children:i}),e(Bc,{isSelected:n,children:n&&Gc(a)})]}),qc=m.div`
  display: flex;
  flex-direction: column;
  padding: 14px 0;
  height: 56px;

  ${({hasBorder:e})=>e&&v`
      border-bottom: 0.4px solid #d5d5d6;
    `}

  ${({isOpen:e})=>e&&v`
      height: auto;
    `}
`,Wc=m.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  div {
    img {
      width: 32px;
      height: 32px;
      transform: rotate(0deg);
      transition: all 0.3s;
    }

    &#active img {
      transform: rotate(180deg);
      transition: all 0.3s;
    }
  }
`,Yc=m.h2`
  ${({theme:e})=>v`
    font-size: 14px;
    font-weight: ${e.fontWeight.medium};
    color: #898b8e;
  `}
`,Xc=m.div`
  display: none;
  flex-direction: column;
  height: auto;
  margin-top: 14px;

  ${({isOpen:e})=>e&&v`
      display: flex;
    `}
`,Kc=({title:n,hasBorder:r,data:l,isMultipleSelect:d,onSelectItem:s,selectedFilters:c,alreadySelectedFilters:u,isVisible:p})=>{const[h,m]=a([]),[g,f]=a(!1),v=e=>{if(Array.isArray(e))c.length?m(e):m([]);else{let t;const i=h.findIndex((t=>t===e));if(i>-1){const e=h.filter(((e,t)=>i!==t));t=e}else t=d?[...h,e]:[e];m(t),s(t)}};return o((()=>{v(c)}),[c]),o((()=>{p&&(u.length?f(!0):f(!1))}),[p,u]),e(i,{children:l.length>0&&t(qc,{isOpen:g,hasBorder:r,children:[t(Wc,{onClick:()=>{f(!g)},children:[e(Yc,{children:n}),e("div",{id:g?"active":"not_active",onClick:()=>{},children:e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/arrow-down.svg",alt:"chevron"})})]}),e(Xc,{isOpen:g,children:l.map(((t,i)=>e(jc,{onSelectItem:()=>v(t.id),title:t.name,isMultipleSelect:d,isSelected:!!h.find((e=>e===t.id))},t.id+i)))})]})})},Qc={expertise:[],medicalField:[],units:[]},Zc=({visible:i,units:n,onClose:r,onApply:l,areaExpertises:d,medicalFields:s})=>{const{selectedFilters:c,setSelectedFilters:u,handleCleanSelectedFilters:p}=_(Tt,(e=>e)),[h,m]=a(c);return o((()=>{i&&m(c)}),[i]),e(Ei,{visible:i,headTitle:"Filtrar",onClose:()=>{r(),m(Qc)},withoutCloseButton:!0,childrenFooter:e(pi,{disabled:!(h.units.length||h.medicalField.length||h.expertise.length),type:"button",title:"Aplicar",onClick:()=>{m(Qc),u(h),l(h)}}),rightText:h.units.length||h.medicalField.length||h.expertise.length?"Limpar":"",onPressRightText:()=>{m(Qc),(c.units.length||c.medicalField.length||c.expertise.length)&&(p(),l(Qc,!0))},children:t(Vc,{children:[e(Kc,{isVisible:i,onSelectItem:e=>m({...h,units:e}),data:n,isMultipleSelect:!0,hasBorder:0!==d.length||0!==s.length,title:"Unidades de atendimento",selectedFilters:h.units,alreadySelectedFilters:c.units}),e(Kc,{isVisible:i,onSelectItem:e=>m({...h,medicalField:e}),data:s,hasBorder:0!==d.length,title:"Área de atuação médica",selectedFilters:h.medicalField,alreadySelectedFilters:c.medicalField}),e(Kc,{isVisible:i,onSelectItem:e=>m({...h,expertise:e}),data:d,title:"Expertise médica",selectedFilters:h.expertise,alreadySelectedFilters:c.expertise})]})})},Jc=m.div`
  display: flex;
  align-items: center;
`,eu=m.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  color: #004f92;
  cursor: pointer;
`,tu=m.div`
  margin-left: 12px;
  cursor: pointer;
  width: 24px;
  height: 24px;
`,iu=m.div`
  display: flex;
  background-color: #ebf7fd;
  border-radius: 16px;
  align-items: center;
  justify-content: space-between;
  height: 34px;
  width: 150px;
  padding: 10px 12px;
  cursor: pointer;
`,nu=m.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  height: 20px;
  width: 24px;
  background-color: var(--blue-einstein);
`,au=m.p`
  ${({theme:e})=>v`
    font-size: 12px;
    font-weight: ${e.fontWeight.bold};
    color: var(--background-color);
  `}
`,ru=({filtersCounter:n,onFilterPress:a,onResetFilter:r})=>{const o=()=>{let e=0;return n.units.length&&(e+=1),n.expertise.length&&(e+=1),n.medicalField.length&&(e+=1),e},l=o()<=9?`0${o()}`:o();return e(Jc,{children:o()>0?t(i,{children:[t(iu,{onClick:a,children:[e(eu,{children:"Filtrar busca"}),e(nu,{children:e(au,{children:l})})]}),e(tu,{onClick:r,children:e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/xIcon.svg",alt:"resetFilter"})})]}):e(eu,{onClick:a,children:"Filtrar"})})},ou=m.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 24px;
`,lu=m.div``,du=m.div`
  position: relative;
  align-items: center;
`;m.button`
  z-index: 9;
  position: absolute;
  top: 9px;
  right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: #004f92;
  border: none;
  border-radius: 100%;
  cursor: pointer;

  transition: all 0.15s ease-in-out;

  &:hover {
    opacity: 0.85;
  }
`;const su=m.div`
  ${({isSpacedBetween:e,isAlignedCenter:t,hasMargin:i})=>v`
    display: flex;
    justify-content: ${e?"space-between":"initial"};
    align-items: ${t?"center":"initial"};
    ${i&&v`
      margin-bottom: 25px;
    `}
  `}
`,cu=m.p`
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  color: #898b8e;
`,uu=m.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 40px;

  p {
    width: 70%;
    font-size: 16px;
    font-weight: 500;
    color: #898b8e;
    margin-top: 16px;
    text-align: center;
  }
`,pu={1:e((()=>{const[a,r]=n.useState([]),[o,l]=n.useState([]),[d,s]=n.useState([]),[c,u]=n.useState([]),[h,m]=n.useState(!1),[g,f]=n.useState(""),[v,b]=n.useState(!1),[y,x]=n.useState(!1),[S,w]=n.useState("RESOURCES"),[E,k]=n.useState({}),{goTo:T}=_(A,(e=>e)),{onCloseScheduler:I}=_(Ct,(e=>e)),{patientSelected:C}=_(_e,(e=>e)),{setSeletedService:P}=_(M,(e=>e)),{handleSelectProduct:N,handleSelectService:D,selectItemToSchedule:R,logged:L}=_(Le,(e=>e)),{setSelectedSpecialist:U,setSpecialties:$,setSpecialists:F,setSelectedSpecialty:V,specialties:z,findSpecialties:H}=_(Tt,(e=>e)),B=async e=>{f(""),x(!0);const t=await Ae(e);if(t.error&&(console.error(t.message),f("Erro ao buscar produto")),!t.error&&(0===t.data.length&&(f("Não encontramos nenhum produto."),u([])),t.data.length>0)){const i=t.data.filter((e=>{var t;return!(null===(t=process.env.REACT_APP_LOGGED_SERVICES)||void 0===t?void 0:t.includes(e.id))}));""===e?r(L?t.data:i):u(L?t.data:i)}x(!1)},G=async e=>{var t;if(x(!0),e.length>2){const i=await Ml({name:e});i.error&&(console.error(i.message),f("Erro ao buscar especialista")),i.error||(0===(null===(t=null==i?void 0:i.data)||void 0===t?void 0:t.length)&&(f("Não encontramos nenhum especialista."),l([])),i.data.length>0&&l(i.data))}x(!1)},j=({service:e,product:t})=>{e&&!t&&(D(e),R("SERVICE"),P&&P(e),e.id===process.env.REACT_APP_TELEORIENTATION_PRODUCT_ID?T(O.RESOURCE_DETAILS.id,{previousPage:!0}):T(O.MEDICAL_APPOINTMENT_TYPE.id,{patientSelected:C})),!e&&t&&(N(t),R("PRODUCT"),T(O.RESOURCE_DETAILS.id,{previousPage:!0}))},q=e=>{const t={"MÉDICOS EINSTEIN":()=>{w("SPECIALISTS")}}[e.toUpperCase()];return!!t&&(t(),!0)},W=async({type:e,item:t})=>{b(!0);const i={SPECIALTY:async()=>{const e=t;await(async e=>{b(!0),s([]),u([]);const t=await Ml({specialty:e.id,medical_indicator:1});t.error&&f("Erro ao consultar especialistas"),t.error||(F(t.data),V(e),T(O.SPECIALIST_LIST.id,{previousPage:!0}),m(!1)),b(!1)})(e)},SPECIALIST:async()=>{U(t),T(O.SPECIALIST_DETAILS.id,{previousPage:!0})},RESOURCE_SCHEDULE:async()=>{const e=t;await(async e=>{if("service"===e.type&&!q(e.name)){const t=await Re(e.id);t.error||j({service:t.data})}if("product"===e.type){const t=await Oe(e.id);t.error||j({product:t.data})}})(e)}};await i[e](),b(!1)};return n.useEffect((()=>{B(""),async function(){b(!0);const e=await Dl();e.error&&p.error("Não foi possível buscar as especialidades."),e.error||$(e.data),b(!1)}()}),[]),n.useEffect((()=>{l([]),u([])}),[S]),t(po,{standardSpacing:h,childrenFooter:!h&&e(pi,{title:"Continuar",disabled:!E.id,onClick:()=>{"MÉDICOS EINSTEIN"===E.name.toUpperCase()?(V(void 0),F([]),T(O.SPECIALIST_LIST.id,{previousPage:!0})):W({type:"RESOURCE_SCHEDULE",item:E})}}),children:[e(Pl,{children:e(Nl,{children:h?e(Cl,{fetchResources:e=>{s(H(e)),e.length>2&&(B(e),G(e))},fetchSpecialists:e=>{s(H(e)),e.length>2&&G(e)},handleClickResult:W,loading:y,resourcesSchedule:c,specialistList:o,specialtyList:d,standardSpacing:!0,changeContext:()=>{m(!h)},type:S,rounded:!0}):t(i,{children:[e(en,{title:"O que deseja agendar?",goBack:I}),e(Cl,{fetchResources:B,handleClickResult:W,loading:y,resourcesSchedule:a,selectedService:E,handleSelectService:async e=>{b(!0),k(e),b(!1)},standardSpacing:!1,changeContext:()=>{m(!h),w("RESOURCES")},type:"SERVICES",rounded:!0})]})})}),e(nn,{loading:v})]})}),{}),2:e((()=>{const{selectedService:i}=_(M,(e=>e)),{clearData:n}=_(Ct,(e=>e)),{goTo:a}=_(A,(e=>e)),{addGenericModals:r}=Vr({}),{formik:l,updateFormPatient:d,loading:s,setLoading:c,genericModal:u,patientSelected:p,selectedProduct:h,routeProductSelector:m,handleSchedulePatient:g,isModalSystemUnavailableVisible:f,setIsModalSystemUnavailableVisible:v,isModalNoEligibility:b,setIsModalNoEligibility:y,isModalProductNotCoveredVisible:x,setIsModalProductNotCoveredVisible:S,validateGenderCatalogGenericRules:w}=no();o((()=>{p&&d(p)}),[]),o((()=>{p&&d(p)}),[null==p?void 0:p.idPatient]);return t(zn,{onSubmit:e=>(e=>{e.preventDefault(),l.submitForm()})(e),children:[t(Hn,{children:[e(en,{title:"Informe os dados do paciente",goBack:()=>{n(),a(O.SERVICE_LIST.id)}}),e("div",{className:"info-wrapper",children:e(Xi,{icon:e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warningBlue.svg",alt:"alert icon"}),info:"Os dados do paciente são confidenciais e de uso exclusivo dos serviços Einstein."})}),e(jn,{formik:l,validateGenderCatalogGenericRules:w})]}),e(mi,{children:e(Gn,{children:e(pi,{title:"Continuar",type:"button",disabled:function(){const e=w();return!(l.values.document&&l.values.documentType&&l.values.name&&l.values.email&&l.values.birthDateDate&&l.values.phone&&!l.errors.document&&!l.errors.documentType&&!l.errors.name&&!l.errors.email&&!l.errors.birthDateDate&&!l.errors.phone&&e)}(),onClick:()=>l.submitForm()})})}),e(nn,{loading:s}),e(Fr,{goTo:a,genericModal:u,selectedProduct:h,patientSelected:p,selectedService:i,routeProductSelector:m,handleSchedulePatient:g,addAdditionalInformations:r,setLoading:c}),e(rn,{visible:f,onClose:()=>{v(!1)}}),e(ln,{visible:b,onClose:()=>{y(!1)}}),e(Li,{visible:x,onClose:()=>S(!1)})]})}),{}),3:e((()=>{const{goTo:i}=_(A,(e=>e)),{scheduleItems:n,setSelectedItem:r}=_(he,(e=>e)),{productList:l}=_(ge,(e=>e)),{patientList:d}=_(_e,(e=>e)),[s,c]=a([]),[u,p]=a(!1);return o((()=>{const e=[];let t=!0;d.forEach((i=>{n.forEach((n=>{var a,r;if(n.idPatient===i.idPatient){const o={};o.patient=i,o.payment=String(null===(a=null==n?void 0:n.payment)||void 0===a?void 0:a.type)||"",o.schedule=n,o.complete=!!n.time&&!!(null===(r=null==n?void 0:n.payment)||void 0===r?void 0:r.type)&&!!n.careType,t=o.complete&&t;const d=l.find((e=>e.id===n.productId));d&&(o.product=d),e.push(o)}}))})),c(e),p(t)}),[n]),e(ao,{children:t(oo,{children:[e(en,{title:"Agendamento"}),e(ro,{children:"Escolha um item para agendar"}),e("ul",{className:"list",children:e(lo,{children:s.map(((t,n)=>e(so,{children:e(ti,{disabled:!1,product:t.product,border:!1,whitoutRemoveBtn:!0,handleClick:()=>{r(t.schedule),i(O.PAYMENT_VIEW.id)}})},n)))})})]})})}),{}),4:e((()=>{const{goTo:i}=_(A,(e=>e)),{openModal:r}=_(Bi,(e=>e)),{changeProduct:o}=_(ge,(e=>e)),{findProductOriginal:l}=_(ge,(e=>e)),{patientSelected:d,addPatientList:s}=_(_e,(e=>e)),{selectedProduct:c,selectedItemToSchedule:u}=_(Le,(e=>e)),{setEligibilityPlans:p,eligibilityPlans:h}=_(ve,(e=>e)),{selectedItem:m,changeSchedule:g,scheduleSpecialistSelected:f,setScheduleSpecialistSelected:v,changeScheduleSpecialist:b}=_(he,(e=>e)),y=null==m?void 0:m.payment,[x,S]=n.useState(y),[w,E]=a(!1),{createSchedule:k,genericModal:T,isModalSystemUnavailableVisible:I,setIsModalSystemUnavailableVisible:C,isModalHealthInsuranceUnavailableVisible:P,setIsModalHealthInsuranceUnavailableVisible:N,isModalProductNotCoveredVisible:M,setIsModalProductNotCoveredVisible:D,isModalNoEligibility:R,setIsModalNoEligibility:L}=eo({addPatientList:s,changeProduct:o,eligibilityPlans:h,setEligibilityPlans:p,goTo:i,changeSchedule:g,selectedSchedule:m,openModal:r,scheduleSpecialistSelected:f,setScheduleSpecialistSelected:v,changeScheduleSpecialist:b}),$=async({product:e,patient:t,payment:i})=>{E(!0);const n=await k({patient:t,product:e,itemToSchedule:"PRODUCT",payment:i});(null==n?void 0:n.type)===Q&&(T.setGenericModalCondition(Q),T.setModalGenericVisible(!0)),E(!1)};return t(Ol,{children:[e(jl,{payment:x,setPayment:S,handlePayment:e=>{var t;S("string"==typeof(t=e)?{...x,type:t}:t)},setIsModalHealthInsuranceUnavailableVisible:N}),e(mi,{children:e(pi,{disabled:(()=>{var e,t,i,n;if(null==x?void 0:x.type){if((x.type===ne||x.type===oe.HEALTH_INSURANCE)&&x.insuranceName)return!1;if(x.type===te||x.type===oe.PARTICULAR)return!1;if(x.type===ie)return!((null===(e=null==x?void 0:x.eligibility)||void 0===e?void 0:e.codPlan)&&(null===(t=null==x?void 0:x.eligibility)||void 0===t?void 0:t.idInsurance)&&(null===(i=null==x?void 0:x.eligibility)||void 0===i?void 0:i.idCustomer)&&(null===(n=null==x?void 0:x.eligibility)||void 0===n?void 0:n.plan))}return!0})(),title:"Continuar",onClick:async()=>{if("SPECIALIST"===u)b({...f,payment:x}),i(O.SERVICE_UNIT.id);else{if((null==m?void 0:m.name)&&x){const e=m,t=l((null==e?void 0:e.productId)||"");t&&d&&await $({patient:d,product:t,payment:x})}(null==x?void 0:x.type)&&c&&d&&await $({patient:d,product:c,payment:x})}}})}),e(ia,{when:U,condition:T.genericModalCondition,visible:T.modalGenericVisible,isVisible:T.setModalGenericVisible,handleActionButton:async function(e,t){e===B&&T.setModalGenericVisible(!1),e===j&&T.setGenericModalCondition(t),e===H&&(T.setModalGenericVisible(!1),c&&d&&(T.genericModalCondition===Q?i(O.SERVICE_TYPE_PAGE.id):x&&await $({product:c,patient:d,payment:x})))}}),e(rn,{visible:I,onClose:()=>C(!1)}),e(nn,{loading:w}),e(Li,{visible:M,onClose:()=>D(!1)}),e(ln,{visible:R,onClose:()=>{L(!1)}}),e(Yl,{visible:P,onClickClose:()=>N(!1)})]})}),{}),5:e((()=>{var r;const{setEligibilityPlans:o,eligibilityPlans:l}=_(ve,(e=>e)),{findProduct:d,changeProduct:s}=_(ge,(e=>e)),{selectedItemToSchedule:c}=_(Le,(e=>e)),{selectedSpecialist:u}=_(Tt,(e=>e)),{selectedService:p}=_(M,(e=>e)),{openModal:h}=_(Bi,(e=>e)),{goTo:m}=_(A,(e=>e)),{patientList:g,findPatiendById:f,patientSelected:v,addPatientList:b}=_(_e,(e=>e)),{addUnits:y,addUnitDatesAvailable:x,setScheduleSpecialistSelected:S,setEavSlotsData:w,getNotScheduledProducts:E,scheduleSpecialistSelected:k,changeScheduleSpecialist:T,changeSchedule:I,selectedItem:C}=_(he,(e=>e)),P=d((null==C?void 0:C.productId)||""),[N,D]=n.useState(!1),[O,R]=n.useState(!1),[L,U]=n.useState(!1),[$,F]=a({presencial:!1,telemedicine:!1,eav:!1}),{coveragesSpecialist:V,specialistUnitSelected:z,onSelectUnitSpecialist:H,setSpecialistUnitSelected:B}=qd({patientList:g,scheduleSpecialistSelected:k,selectedItemToSchedule:c,setLoadingChangeProduct:D,selectedSpecialist:u}),{handleRemoveResource:G,loading:j,selectCoverage:q,selectedUnit:W,coverageUnit:Y,selectedCoverage:X,closedToScheduleUnits:K,openToScheduleUnits:Q,schedule:Z,setUnitToSchedule:J,genericModal:ee,isModalSystemUnavailableVisible:te,resetCoverageSelection:ie,setIsModalSystemUnavailableVisible:ne,setSpecificUnitsResources:ae}=(({addPatientList:e,changeProduct:t,eligibilityPlans:i,setEligibilityPlans:a,changeSchedule:r,goTo:o,selectedSchedule:l,openModal:d,changeScheduleSpecialist:s,scheduleSpecialistSelected:c,setScheduleSpecialistSelected:u,loadingChangeProduct:p,addUnits:h,addUnitDatesAvailable:m,patientSelected:g})=>{const{genericModal:f,isModalSystemUnavailableVisible:v,setIsModalSystemUnavailableVisible:b}=eo({addPatientList:e,changeProduct:t,eligibilityPlans:i,setEligibilityPlans:a,goTo:o,changeSchedule:r,selectedSchedule:l,openModal:d,scheduleSpecialistSelected:c,setScheduleSpecialistSelected:u,changeScheduleSpecialist:s}),y=ra({changeSchedule:r,selectedSchedule:l}),{coverageUnit:_,unitDatesAvailable:x,openToScheduleUnits:S,selectedCoverage:w,closedToScheduleUnits:E,handleSelectedCoverage:k,setSpecificUnitsResources:T,loading:I,resetCoverageSelection:C,selectedUnit:P,setUnitToSchedule:N}=$r({handleModalProps:f.handleModalProps,changeSchedule:r,openModal:d,scheduleSelected:l}),M=p||I;return n.useEffect((()=>{h(S)}),[S]),n.useEffect((()=>{m(x)}),[x]),n.useEffect((()=>{y.schedule.resource&&y.addResource(!0)}),[]),{loading:M,selectCoverage:e=>{k({coverage:e,patientSelected:g})},handleRemoveResource:async()=>{y.schedule&&(C(),y.schedule&&(y.addResource(!1),y.updateSchedule())),f.handleModalProps({visible:!1})},selectedUnit:P,coverageUnit:_,selectedCoverage:w,openToScheduleUnits:S,closedToScheduleUnits:E,setUnitToSchedule:N,schedule:y.schedule,genericModal:f,resetCoverageSelection:C,setSpecificUnitsResources:T,isModalSystemUnavailableVisible:v,setIsModalSystemUnavailableVisible:b}})({addPatientList:b,changeProduct:s,eligibilityPlans:l,setEligibilityPlans:o,changeSchedule:I,goTo:m,selectedSchedule:C,openModal:h,changeScheduleSpecialist:T,scheduleSpecialistSelected:k,setScheduleSpecialistSelected:S,loadingChangeProduct:N,addUnits:y,addUnitDatesAvailable:x,patientSelected:v});return t(po,{childrenFooter:C?e(Gd,{selectedItemToSchedule:c,specialistUnitSelected:z,selectedUnit:W,eavLocation:L,setLoadingChangeProduct:D,coverageUnit:Y,patientList:g,findProduct:d,findPatiendById:f,selectedCoverage:X,coveragesSpecialist:V,selectedSpecialist:u,selectedCoverageSpecialist:$,setEavSlotsData:w,getNotScheduledProducts:E,scheduleSpecialistSelected:k,changeScheduleSpecialist:T,changeSchedule:I,selectedItem:C}):null,children:[t(Wd,{children:[t(i,{children:[e(jd,{productRules:null==P?void 0:P.rules}),c&&e(xd,{selectedCoverage:X,coverages:null==P?void 0:P.coverages,handleSelectCoverage:q,productName:null==P?void 0:P.name,selectedItemToSchedule:c,coveragesSpecialists:V,selectedCoverageSpecialist:$,setSelectedCoverageSpecialist:e=>{B(void 0),F(e)}})]}),"SPECIALIST"===c&&t(i,{children:[$.presencial&&e(od,{units:V.presential,selectedUnit:z,onSelectUnit:H}),$.telemedicine&&e(od,{units:V.telemedicine,selectedUnit:z,onSelectUnit:H}),$.eav&&e(od,{units:V.eav,selectedUnit:z,onSelectUnit:H})]}),((null==X?void 0:X.care_type)===le||(null==X?void 0:X.care_type)===ce||(null==X?void 0:X.care_type)===ue)&&e(Bd,{openToScheduleUnits:Q,closedToScheduleUnits:K,typePayment:String(null===(r=null==C?void 0:C.payment)||void 0===r?void 0:r.type),selectedLocation:W,onLocationSelected:J,careType:X.care_type,hasResource:!!(null==Z?void 0:Z.resource)}),(null==X?void 0:X.care_type)===de&&e(gd,{location:L,setValidForm:e=>{e||U(null)},setLocation:e=>{U(e),e&&R({...O,address:e})}})]}),e(nn,{loading:j}),e(fd,{genericModal:ee,setLoadingChangeProduct:D,handleRemoveResource:G,selectedService:p,resetCoverageSelection:ie,patientSelected:v,setSpecificUnitsResources:ae}),e(rn,{visible:te,onClose:()=>{ne(!1)}})]})}),{}),6:e((()=>{const{selectedItem:n,changeScheduleDateSlot:r,scheduleItems:o,scheduleSpecialistSelected:l,changeScheduleSpecialist:d}=_(he,(e=>e)),{selectedItemToSchedule:s}=_(Le,(e=>e)),[c,u]=a(null),[p,h]=a(),[m,g]=a(!1),[f,v]=a(!1),[b,y]=a(!1),{goTo:x,goBack:S}=_(A,(e=>e)),E=()=>{"TELEORIENTATION"===(null==n?void 0:n.channel)?x(O.SERVICE_LIST.id):S()};return t(po,{childrenFooter:e(pi,{title:"Continuar",disabled:!c||!p||b,onClick:()=>{var e;if("SPECIALIST"===s&&c&&p){const e=Hr(l);d(e.setDateHour({date:w(c,"yyyy-MM-dd"),hour:w(p.time,"HH:mm")})),x(O.APPOINTMENT_CONFIRMATION.id)}"PRODUCT"!==s&&"PRODUCT_ENV"!==s&&"SERVICE_ENV"!==s||n&&p&&c&&(r({scheduleId:n.id,displayTimes:p}),qi({event:"agendamento-einstein",categoria:(null===(e=n.productName)||void 0===e?void 0:e.includes("gripe"))?"Agendar-Vacina":"Agendar",acao:"step-5",rotulo:"data-e-horario"}),x(O.APPOINTMENT_CONFIRMATION.id))}}),children:[e(en,{title:"Data e horário",goBack:E}),(null==n?void 0:n.useResouce)&&(null==n?void 0:n.resource)?e(No,{children:e(mo,{imgSrc:`https://aps-digital.s3.amazonaws.com/profissionais/${n.resource.crm}.jpg`,title:n.resource.name,description:n.resource.role})}):e(i,{children:f&&e(No,{children:e(mo,{imgSrc:`https://aps-digital.s3.amazonaws.com/profissionais/${null==p?void 0:p.slots[0].resourceId}.jpg`,title:(null==p?void 0:p.slots[0].resource)||Yo((null==n?void 0:n.productName)||"")||"",description:(null==p?void 0:p.slots[0].resource)?Yo((null==n?void 0:n.productName)||"")||"":"À definir"})})}),e(Wo,{schedules:o,schedule:n,setHasScheduleSameDateTime:y,setLoadingSlots:g,setSelectedDate:u,selectedDate:c,selectedTime:p,setSelectedTime:h,selectedItemToSchedule:s,scheduleSpecialist:l,handleGoBack:E,setIsProductWithProfessional:v}),e(nn,{loading:m})]})}),{}),7:e((()=>{const{goTo:i,goBack:n}=_(A,(e=>e)),{scheduleItems:r,units:l,setSelectedItem:d,scheduleSpecialistSelected:s}=_(he,(e=>e)),{selectedItemToSchedule:c}=_(Le,(e=>e)),{productList:u}=_(ge,(e=>e)),p=_(_e,(e=>e.patientList)),{selectedService:h}=_(M,(e=>e)),[m,g]=a(!1),[f,v]=a([]),[b,y]=a([]),[x,S]=a(!1);o((()=>{if("SPECIALIST"===c){const e=p.find((e=>e.idPatient===s.idPatient));if(e){const t=function(e){var t,i;const n={},a={};a.name=e.scheduleSpecialist.unit.name,a.address=e.scheduleSpecialist.unit.address||"",n.unit=a,n.patient=e.patient;const r={name:"Consulta médica"};n.product=r;const o={};o.date=e.scheduleSpecialist.date,o.startHour=e.scheduleSpecialist.hour,o.payment={...e.scheduleSpecialist.payment,...(null===(t=e.scheduleSpecialist.payment)||void 0===t?void 0:t.price)?{price:null===(i=e.scheduleSpecialist.payment)||void 0===i?void 0:i.price}:{}},n.schedule=o;const l={name:e.scheduleSpecialist.resource.name,roleList:e.scheduleSpecialist.specialityList,role:"",crm:"",image:e.scheduleSpecialist.image};return o.resource=l,o.useResouce=!0,o.time={id:"",time:new Date(`${e.scheduleSpecialist.date}T${e.scheduleSpecialist.hour}:00`),slots:[]},o.careType=e.scheduleSpecialist.attendanceType,n}({scheduleSpecialist:s,patient:e});v([t])}}"PRODUCT"!==c&&"PRODUCT_ENV"!==c&&"SERVICE_ENV"!==c||(v(function(){const e=[];return p.forEach((t=>{r.forEach((i=>{var n;if(i.idPatient===t.idPatient&&i.time&&(null===(n=null==i?void 0:i.payment)||void 0===n?void 0:n.type)&&i.careType){const n=l.find((e=>e.id_sgh===i.unitId)),a=u.find((e=>e.id===i.productId));if(a){const r=function(e){const{schedule:t,patient:i,unit:n,product:a}=e,r={};return r.patient=i,r.schedule=t,n&&(r.unit=n),r.product=a,r}({patient:t,product:a,schedule:i,unit:n});e.push(r)}}}))})),e}()),y(function(){const e=[];return p.forEach((t=>{r.forEach((i=>{var n,a;if(i.idPatient===t.idPatient){const r=!!i.time&&!!(null===(n=null==i?void 0:i.payment)||void 0===n?void 0:n.type)&&!!i.careType;if(!r){const n={};n.patient=t,n.payment=String(null===(a=null==i?void 0:i.payment)||void 0===a?void 0:a.type)||"",n.schedule=i,n.complete=r;const o=u.find((e=>e.id===i.productId));o&&(n.product=o),e.push(n)}}}))})),e}()))}),[]);return t(os,{children:[t("div",{className:"body-wrapper",children:[e(en,{title:"Confirme o agendamento"}),!!b.length&&e(ls,{children:"Itens pendentes"}),b.map(((t,n)=>e(ti,{whitoutRemoveBtn:!0,product:t.product,handleClick:()=>{d(t.schedule),i(O.PAYMENT_VIEW.id)}},n))),f.map(((t,i)=>e(rs,{unit:t.unit,patient:t.patient,product:t.product,schedule:t.schedule,selectedServiceId:(null==h?void 0:h.id)||""},i)))]}),e(ds,{children:e(mi,{children:e(us,{patientList:p,setLoading:g,completedSchedules:f,incompletedSchedules:b,handleSubmitErrorCallBack:()=>{S(!0)}})})}),e(nn,{loading:m}),e(hs,{visible:x,onClose:()=>{var e,t;S(!1),i(O.SERVICE_UNIT.id,{scheduleForRemove:!0,scheduleDateToRemove:null===(e=r[0].time)||void 0===e?void 0:e.slots[0].date,scheduleHourToRemove:null===(t=r[0].time)||void 0===t?void 0:t.slots[0].hour})}})]})}),{}),8:e((()=>{const{goTo:i,primaryRouteNavigate:a}=_(A,(e=>e)),{clearData:r,setIsSchedulerOpen:o}=_(Ct,(e=>e)),{tokenSuccess:l,scheduleItems:d}=_(he,(e=>e)),{selectedItemToSchedule:s}=_(Le,(e=>e));return n.useEffect((()=>{var e,t;qi({event:"agendamento-einstein",categoria:(null===(t=null===(e=d[0])||void 0===e?void 0:e.productName)||void 0===t?void 0:t.includes("gripe"))?"Agendar-Vacina":"Agendar",acao:"step-7",rotulo:"sucesso"})}),[]),t(ms,{children:[t(gs,{children:[e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/conclusion.svg",alt:"sucesso"}),e("h1",{className:"title",children:"Agendamento realizado com sucesso!"}),e("p",{className:"subtitle",children:"Para consultar as informações do seu agendamento use o código:"}),e("p",{className:"code",children:l||"000 000"})]}),t(mi,{children:[e(pi,{title:"Ir para home",onClick:()=>{o(!1),r()}}),e(pi,{title:"Novo agendamento",onClick:()=>{r(),"PRODUCT_ENV"===s&&i(O.RESOURCE_DETAILS.id),"SERVICE_ENV"===s&&i(O.RESOURCE_DETAILS.id),"PRODUCT"===s&&i(O.SERVICE_LIST.id),"SPECIALIST"===s&&i(O.SERVICE_LIST.id)},tertiary:!0})]})]})}),{}),9:e((()=>{const{goTo:i}=_(A,(e=>e)),{setIsSchedulerOpen:a,clearData:r}=_(Ct,(e=>e)),[o,l]=n.useState(!1),[d,s]=n.useState(!1),[c,u]=n.useState(!1),h=I({initialValues:{documentType:"CPF",document:"",appointmentCod:""},validateOnChange:!1,validateOnBlur:!1,onSubmit:async e=>{let t=!1;if("CPF"===h.values.documentType?pt(e.document)||(h.setFieldError("document","Documento inválido"),t=!0):"Passport"===h.values.documentType&&(ht(e.document)||(h.setFieldError("document","Documento inválido"),t=!0)),e.appointmentCod.length<7&&(h.setFieldError("appointmentCod","Código inválido"),t=!0),!t){const t=xt(e.document);u(!0),qi({event:"agendamento-einstein",categoria:"consultar-agendamento",acao:"step-2",rotulo:"infos-agendamento"});try{const n=await(async(e,t)=>{const i={};try{const n=await Te.get("schedules",{params:{document:e,verificationCode:t}});n.data&&(i.data=n.data)}catch(e){console.error(e),i.error=!0}return i})(t,e.appointmentCod),a=await(async(e,t,i)=>{const n={};try{const a=await Ce.get("/specialist/schedules/web",{params:{document:e,documentType:i,verificationCode:t}});a.data&&(n.data=a.data)}catch(e){console.error(e),n.error=!0}return n})(t,e.appointmentCod,e.documentType);if(!n.data&&!a.data)throw new Error("agendamento não encontrado");i(O.DETAILS_APPOINTMENT.id,{...n.data,...a.data,specialist:!!a.data,patient:{document:h.values.document}})}catch(e){console.error(e),p.error("agendamento não encontrado.")}u(!1)}}});return t(po,{childrenFooter:e(pi,{title:"Consultar",type:"button",disabled:"CPF"===h.values.documentType?h.values.document.length<14||h.values.appointmentCod.length<7:h.values.document.length<3||h.values.appointmentCod.length<7,onClick:h.submitForm}),children:[t(fs,{children:[e(en,{title:"Consultar agendamento",goBack:()=>{r(),a(!1)}}),e(Ln,{setFieldValue:h.setFieldValue,setFieldError:h.setFieldError,document:h.values.document,documentType:h.values.documentType,error:h.errors.document,setIsValid:l,isValid:o,onConfirmIdentity:()=>{},showConfirmIdentity:d}),e(An,{children:e(Rn,{name:"appointmentCod",id:"appointmentCod",placeholder:"Código do agendamento",label:"Código do agendamento",type:"text",onChange:e=>{const t=(e=>{let t=mt(e).toUpperCase();return t.length>=6&&(t=t.substr(0,6)),t=t.replace(/([A-Z0-9]{3})([A-Z0-9]{1,3})/g,"$1-$2"),t})(e.target.value);h.setFieldValue("appointmentCod",t),t.length<6?h.setFieldError("appointmentCod","Código inválido"):h.setFieldError("appointmentCod","")},filled:7===h.values.appointmentCod.length,invalid:h.values.appointmentCod.length>0&&h.values.appointmentCod.length<7,value:h.values.appointmentCod,error:h.errors.appointmentCod})}),e(vs,{children:e(Xi,{icon:e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warningBlue.svg",alt:"info"}),info:"O código está no e-mail de confirmação do agendamento"})})]}),e(nn,{loading:c})]})}),{}),10:e((()=>{const{state:i}=_(A,(e=>e)),[a,r]=n.useState(!1),[o,l]=n.useState(),[d,s]=n.useState(),[c,u]=n.useState(!1),{setIsSchedulerOpen:p}=_(Ct,(e=>e));return n.useEffect((()=>{i&&(i.specialist?s(i):l(i))}),[]),t(po,{childrenFooter:e(pi,{title:"Cancelar agendamento",type:"button",onClick:()=>{r(!0)}}),children:[t(Ss,{children:[e(en,{title:"Detalhes agendamento"}),o&&e(ws,{children:e(Cs,{appointment:o})}),d&&e(ws,{children:e(Ns,{appointment:d})})]}),e(_s,{visible:a,onClose:()=>p(!1),scheduleId:(null==o?void 0:o.id)||(null==d?void 0:d.id)||"",verificationCode:(null==o?void 0:o.verificationCode)||(null==d?void 0:d.token)||"",setLoading:u,specialist:!!(null==d?void 0:d.id)}),e(nn,{loading:c})]})}),{}),11:e((({onClose:a})=>{const{openModal:r}=_(Bi,(e=>e)),{changeProduct:o}=_(ge,(e=>e)),{setSeletedService:l}=_(M,(e=>e)),{goTo:d,state:s,goBack:c}=_(A,(e=>e)),{selectedItem:u,changeSchedule:p,scheduleSpecialistSelected:h,setScheduleSpecialistSelected:m,changeScheduleSpecialist:g}=_(he,(e=>e)),{setIsSchedulerOpen:f,clearData:v}=_(Ct,(e=>e)),{patientSelected:b,addPatientList:y}=_(_e,(e=>e)),{eligibilityPlans:x,setEligibilityPlans:S}=_(ve,(e=>e)),{selectedProduct:w,selectItemToSchedule:E,handleSelectProduct:k,selectedService:T,selectedItemToSchedule:I}=_(Le,(e=>e)),[C,P]=n.useState(),[N,D]=n.useState(),[R,L]=n.useState(!1),{createSchedule:$,genericModal:F,isModalSystemUnavailableVisible:V,setIsModalSystemUnavailableVisible:z}=eo({addPatientList:y,changeProduct:o,eligibilityPlans:x,setEligibilityPlans:S,goTo:d,changeSchedule:p,selectedSchedule:u,openModal:r,scheduleSpecialistSelected:h,setScheduleSpecialistSelected:m,changeScheduleSpecialist:g}),H=async()=>{L(!0);const e=process.env.REACT_APP_PRODUCT_ID;if(e){const t=await Oe(e),{error:i,data:n}=t;i&&G(),i||P(n)}L(!1)},B=async()=>{L(!0);const e=process.env.REACT_APP_SERVICE_ID;if(e){const t=await Re(e),{error:i,data:n}=t;i&&G(),i||D(n)}L(!1)},G=()=>{v(),f(!1),a&&a()};return n.useEffect((()=>{"PRODUCT_ENV"===I&&H(),"SERVICE_ENV"===I&&B(),"PRODUCT"===I&&w&&P(w),"SERVICE"===I&&T&&D(T)}),[]),t(i,{children:[C||N?e(i,{children:e(Xs,{children:e(Ys,{product:C,service:N,handleAddProductList:async({product:e,service:t})=>{if(L(!0),e&&(qi({event:"agendamento-einstein",categoria:"Agendar-Vacina",acao:"step-2",rotulo:"visualizou-detalhes"}),k(e),E(I),b||d(O.PATIENT_FORM.id),b)){const t=await $({product:e,patient:b,itemToSchedule:I});t&&(null==t?void 0:t.type)===Q&&(F.setGenericModalCondition(Q),F.setModalGenericVisible(!0))}if(t){if(qi({event:"agendamento-einstein",categoria:"Agendar-Cuidado",acao:"step-2",rotulo:"visualizou-detalhes"}),t.id===process.env.REACT_APP_TELEORIENTATION_PRODUCT_ID){const[e]=t.products;k(e),E("PRODUCT"),1===t.products.length&&b&&(x.length?await $({product:e,patient:b,itemToSchedule:"PRODUCT"}):r("PRODUCT_NOT_COVERED")),1!==t.products.length||b||d(O.PATIENT_FORM.id)}else a&&a(),l&&l(t),d(O.MEDICAL_APPOINTMENT_TYPE.id,{previousPage:!!s.previousPage,patientSelected:b});f(!0)}L(!1)},onClose:()=>{s.previousPage||G(),s.previousPage&&c()},titleMainButton:"Agendar",titleSecondaryButton:s.previousPage?"Voltar":"Fechar"})})}):null,e(nn,{loading:R}),e(rn,{visible:V,onClose:()=>{z(!1)}}),e(ia,{when:U,condition:F.genericModalCondition,visible:F.modalGenericVisible,isVisible:F.setModalGenericVisible,handleActionButton:F.handleActionButtonModal})]})}),{}),13:e((()=>{const[i,n]=a([]),[r,o]=a(!1),[l,d]=a(),{goTo:s}=_(A,(e=>e)),{openModal:c}=_(Bi,(e=>e)),{changeProduct:u}=_(ge,(e=>e)),{selectedService:p}=_(M,(e=>e)),{selectedItem:h,changeSchedule:m,scheduleSpecialistSelected:g,setScheduleSpecialistSelected:f,changeScheduleSpecialist:v}=_(he,(e=>e)),{setEligibilityPlans:b,eligibilityPlans:y}=_(ve,(e=>e)),{patientSelected:x,addPatientList:S}=_(_e,(e=>e)),{handleSelectProduct:w,selectItemToSchedule:E,selectedItemToSchedule:k}=_(Le,(e=>e));function T({product:e}){d(e),w(e)}const{createSchedule:I,genericModal:C,isModalSystemUnavailableVisible:P,setIsModalSystemUnavailableVisible:N,isModalProductNotCoveredVisible:D,setIsModalProductNotCoveredVisible:R,isModalNoEligibility:L,setIsModalNoEligibility:$}=eo({addPatientList:S,changeProduct:u,eligibilityPlans:y,setEligibilityPlans:b,goTo:s,changeSchedule:m,selectedSchedule:h,openModal:c,scheduleSpecialistSelected:g,setScheduleSpecialistSelected:f,changeScheduleSpecialist:v}),{handleSelectedCoverage:V}=$r({handleModalProps:C.handleModalProps,changeSchedule:m,openModal:c,scheduleSelected:h});function z(e,t){const i=e.rules?Qn(e.rules):void 0;if(i){return Kn({genericModals:i,condition:Z,when:t})}}const H=async({productProp:e,alreadyShowModal:t})=>{if(o(!0),null===k&&E("PRODUCT"),"SERVICE"===k&&E("PRODUCT"),null==l?void 0:l.is_b2b){const i=e||l;if(i&&x){if(z(l,U)&&!t)C.openModal(U,Z);else{const e=await I({product:i,patient:x,itemToSchedule:"PRODUCT"});(null==e?void 0:e.type)===Q&&C.openModal(U,e.type),(null==e?void 0:e.type)===na.only_telemedicine&&e.coverage&&V({coverage:e.coverage,patientSelected:x})}}!x&&i&&(T({product:i}),s(O.PATIENT_FORM.id,{isAps:!0}))}l&&!(null==l?void 0:l.is_b2b)&&(T({product:l}),s(O.RESOURCE_DETAILS.id)),o(!1)};return t(po,{childrenFooter:e(Ks,{product:l,handleActionButton:()=>{if(l){if(l.rules?Qn(l.rules):void 0){z(l,F)?C.openModal(F,Z):H({alreadyShowModal:!1})}else H({alreadyShowModal:!1})}}}),children:[t(Js,{children:[e(en,{title:"Escolha o produto"}),e(Qs,{products:i,setProductList:n,selected:l,handleSelect:T})]}),e(Zs,{when:C.genericModalWhen,condition:C.genericModalCondition,visible:C.modalGenericVisible,isVisible:C.setModalGenericVisible,productList:i,patientSelected:x,selectedProduct:l,selectedService:p,setModalGenericVisible:C.setModalGenericVisible,handleActionButtonModal:C.handleActionButtonModal,genericModalCondition:C.genericModalCondition,routeProductSelector:H,setGenericModalWhen:C.setGenericModalWhen,handleModalProps:C.handleModalProps,setLoading:o,genericModal:C}),e(rn,{visible:P,onClose:()=>{N(!1)}}),e(Li,{visible:D,onClose:()=>R(!1)}),e(ln,{visible:L,onClose:()=>{$(!1)}}),e(nn,{loading:r})]})}),{}),14:e((function(){var a,r;const{openModal:o}=_(Bi,(e=>e)),{changeProduct:l}=_(ge,(e=>e)),{goBack:d,goTo:s}=_(A,(e=>e)),{patientSelected:c}=_(_e,(e=>e)),{selectItemToSchedule:u,logged:p}=_(Le,(e=>e)),{setEligibilityPlans:h,eligibilityPlans:m}=_(ve,(e=>e)),{selectedSpecialist:g,setSelectedSpecialty:f}=_(Tt,(e=>e)),{addPatientList:v}=_(_e,(e=>e)),{setScheduleSpecialistSelected:b,selectedItem:y,changeSchedule:x,changeScheduleSpecialist:S,scheduleSpecialistSelected:w}=_(he,(e=>e)),{handleAddPatient:E}=eo({addPatientList:v,changeProduct:l,eligibilityPlans:m,setEligibilityPlans:h,goTo:s,changeSchedule:x,selectedSchedule:y,openModal:o,scheduleSpecialistSelected:w,setScheduleSpecialistSelected:b,changeScheduleSpecialist:S}),[k,T]=n.useState([]),[I,C]=n.useState([]),P=e=>e.contacts.find((e=>"Contato para agendamento"===e.contact_type.name&&e.value.landlines.length)),N=()=>{var e;return null===(e=null==g?void 0:g.units)||void 0===e?void 0:e.find((e=>P(e)))},M=null==g?void 0:g.units.some((e=>{var t,i;return!!(null===(t=e.schedule_types)||void 0===t?void 0:t.some((e=>"Autoagendamento"===e.name)))&&!!(null===(i=null==e?void 0:e.external_platform)||void 0===i?void 0:i.code_company)}));return n.useEffect((()=>{if(g){const e=g.units.filter((e=>{if((null==e?void 0:e.unit_id)&&P(e))return e})),t=g.units.filter((e=>{if((null==e?void 0:e.external_office_id)&&P(e))return e})).map((e=>{const t=g.external_offices.find((t=>t.id===(null==e?void 0:e.external_office_id)));return t?{...e,unit_full_address:hc(t),name:t.name||"Consultório Particular"}:e}));T(e),C(t)}}),[g]),t(po,{childrenFooter:t(i,{children:[M&&e(pi,{title:"Agendar online",onClick:async()=>{if(g&&(u("SPECIALIST"),p&&c&&await E({patient:c,itemToSchedule:"SPECIALIST",specialist:g}),!p)){const e=Hr();b(e.setSpecialist({specialityList:g.specialties,image:g.profile_picture,interval:30})),s(O.PATIENT_FORM.id)}}}),e(pi,{title:"Voltar",tertiary:!0,onClick:()=>{d()}})]}),children:[t(ec,{children:[e("img",{id:"specialist-avatar",src:(null==g?void 0:g.profile_picture)?null==g?void 0:g.profile_picture:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/patient.svg",alt:"Specialist Avatar"}),e("h1",{id:"specialist-name",children:null==g?void 0:g.name}),null===(a=null==g?void 0:g.professional_codes)||void 0===a?void 0:a.map((e=>t("p",{id:"specialist-code",children:[e.type," ",e.value]},e.value))),(null==g?void 0:g.curriculum)&&e(ac,{onClick:()=>{window.open(g.curriculum)},children:e("p",{children:"Ver currículo"})})]}),t(tc,{children:[(null==g?void 0:g.specialties.length)?e(i,{children:t(ic,{children:[e("img",{id:"detail-icon",src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/stethoscope.svg",alt:"Detail Icon"}),t("div",{children:[e("p",{id:"detail-name",children:"Especialidades"}),e("p",{id:"detail-description",children:xl(null==g?void 0:g.specialties)})]})]})}):null,(null==k?void 0:k.length)&&N()?t(i,{children:[e(nc,{}),t(ic,{children:[e("img",{id:"detail-icon",src:gc,alt:"Detail Icon"}),t("div",{children:[e("p",{id:"detail-name",children:"Contato"}),k.map(((t,i)=>e(dc,{unit:t},i)))]})]})]}):I.length?t(i,{children:[e(nc,{}),t(ic,{children:[e("img",{id:"detail-icon",src:gc,alt:"Detail Icon"}),t("div",{children:[e("p",{id:"detail-name",children:"Contato"}),I.map(((t,i)=>e(dc,{unit:t},i)))]})]})]}):null,(null==k?void 0:k.length)&&N()?t(i,{children:[e(nc,{}),t(ic,{children:[e("img",{id:"detail-icon",src:mc,alt:"Detail Icon"}),t("div",{children:[e("p",{id:"detail-name",children:"Unidades de atendimento"}),k.map(((t,i)=>e(pc,{unit:t},i)))]})]})]}):I.length?t(i,{children:[e(nc,{}),t(ic,{children:[e("img",{id:"detail-icon",src:mc,alt:"Detail Icon"}),t("div",{children:[e("p",{id:"detail-name",children:"Unidades de atendimento"}),I.map(((t,i)=>e(pc,{unit:t},i)))]})]})]}):null,(null===(r=null==g?void 0:g.languages)||void 0===r?void 0:r.length)&&t(i,{children:[e(nc,{}),t(ic,{children:[e("img",{id:"detail-icon",src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/languages-rounded.svg",alt:"Detail Icon"}),t("div",{children:[e("p",{id:"detail-name",children:"Idiomas"}),e("p",{id:"detail-description",children:Gr((()=>{var e;return null===(e=null==g?void 0:g.languages)||void 0===e?void 0:e.join(", ")})()||"")})]})]})]})]})]})}),{}),15:e((()=>{const{selectedUnit:n,setIsSchedulerOpen:r}=_(Ct,(e=>e)),[o,l]=a(""),d=null==n?void 0:n.contacts.filter((e=>"E-mail"!==e.type)),s=null==n?void 0:n.contacts.filter((e=>"E-mail"===e.type)),c=n?(e=>{const t=[],i=["domingo","segunda","terça","quarta","quinta","sexta","sábado"],n=[];n.push(!1),n.push(e.weekdays.monday),n.push(e.weekdays.tuesday),n.push(e.weekdays.wednesday),n.push(e.weekdays.thursday),n.push(e.weekdays.friday),n.push(!1);const a=[],r=n.reduce(((e,t,i,n)=>{if(0===i){const e=n[n.length-1];return t&&!e?[i]:[]}{const a=n[i-1];return t&&!a?[...e,i]:[...e]}}),a),o=n.reduce(((e,t,i,n)=>{if(0===i){const e=6,i=n[e];return!t&&i?[e]:[]}{const a=i-1,r=n[a];return!t&&r?[...e,a]:[...e]}}),a);if(1===r.length&&1===o.length){const n=r[0],a=o[0];let l;l=n===a?`${i[n].charAt(0).toUpperCase()+i[n].slice(1)}`:`${i[n].charAt(0).toUpperCase()+i[n].slice(1)} a ${i[a]}`;const d=`${e.start} às ${e.end}`;t.push(`${l}: ${d}`)}else if(r.length>1&&o.length>1){const a=n.map(((e,t)=>e?t:-1)).filter((e=>-1!==e)).map((e=>i[e])).reverse().reduce(((e,t,i)=>0===i?t:1===i?`${t} e ${e}`:`${t}, ${e}`),""),r=a.charAt(0).toUpperCase()+a.slice(1),o=`${e.start} às ${e.end}`;t.push(`${r}: ${o}`)}if(e.different.start&&e.different.end){const i=`${e.different.start} às ${e.different.end}`;e.weekends.saturday&&e.weekends.sunday?t.push(`Sábado e domingo: ${i}`):e.weekends.saturday?t.push(`Sábado: ${i}`):e.weekends.sunday&&t.push(`Domingo: ${i}`)}if(e.holiday.is_holiday){const i=`${e.holiday.hours.start} às ${e.holiday.hours.end}`;t.push(`Feriados: ${i}`)}return t})(n.workHours):[];return e(po,{standardSpacing:!0,children:t(fc,{children:[e("img",{src:(null==n?void 0:n.img_url)||"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/unidade-jardins/1x.jpeg",alt:null==n?void 0:n.name}),t(vc,{children:[t(bc,{children:[e(yc,{children:Gr(n?n.name:"")}),e(_c,{onClick:()=>r(!1),children:e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/times-gray.svg",alt:"close"})})]}),t(wc,{children:[e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/pin-rouded.svg",alt:"location"}),t(Ec,{children:[e("p",{children:"Endereço"}),t("p",{children:[t("span",{children:[null==n?void 0:n.address.name,", ",null==n?void 0:n.address.number]}),e("br",{}),t("span",{children:[null==n?void 0:n.address.neighborhood,", ",null==n?void 0:n.address.city," - ",null==n?void 0:n.address.state]})]})]})]}),(null==n?void 0:n.locations.length)&&n.workHours&&(null===(u=null==n?void 0:n.locations)||void 0===u?void 0:u.find((e=>e.description)))?t(wc,{children:[e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/clock-blue.svg",alt:"clock"}),t(Ec,{children:[e("p",{children:"Horário de atendimento"}),!n.locations.some((e=>e.service_hours))&&t("p",{children:[e("span",{children:c.length>0&&c[0]}),c.length>1&&c.slice(1,c.length).map(((i,n)=>t("span",{children:[e("br",{}),i]},n)))]}),null==n?void 0:n.locations.map((n=>{if(n.service_hours)return o===n.id?e(xc,{children:n.service_hours&&t(i,{children:[t("div",{id:"active",onClick:()=>l(""),children:[e("p",{children:n.description}),e("img",{src:Cc,alt:"chevron"})]}),e(Ic,{service_hours:n.service_hours})]})}):e(xc,{children:t("div",{onClick:()=>l(n.id),children:[e("p",{children:n.description}),e("img",{src:Cc,alt:"chevron"})]})})}))]})]}):null,d&&d.length?t(wc,{children:[e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/phone-blue.svg",alt:"phone"}),t(Ec,{children:[e("p",{children:"Telefones"}),d.map((i=>t("p",{children:[e("span",{children:i.type}),e("br",{}),t("a",{href:`tel:+55${i.value}`,children:["+55 ",St(i.value)]})]})))]})]}):null,s&&s.length?t(wc,{children:[e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/email-rounded.svg",alt:"email"}),t(Ec,{children:[e("p",{children:"Emails"}),s.map((i=>t("p",{children:[e("span",{children:i.type}),e("br",{}),e("a",{href:`mailto:${i.value}`,children:i.value})]})))]})]}):null,(null==n?void 0:n.facilities.length)?t(wc,{children:[e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/face-rounded.svg",alt:"facilities"}),t(Ec,{children:[e("p",{children:"Facilidades"}),e(Sc,{children:null==n?void 0:n.facilities.map((t=>e("li",{children:Gr(t.name)})))})]})]}):null]})]})});var u}),{}),16:e((()=>{const[a,r]=n.useState(null),[o,l]=n.useState([]),[d,s]=n.useState(!1),[c,u]=n.useState(""),[h,m]=n.useState(!1),[g,f]=n.useState(!1),[v,b]=n.useState(!1),[y,x]=n.useState([]),[S,w]=n.useState([]),{goTo:E}=_(A,(e=>e)),{specialists:k,setSpecialists:T,setSelectedSpecialist:I,selectedSpecialist:C,setSelectedSpecialty:P,selectedSpecialty:N,setSpecialties:M,listUnitsFilter:D,setListUnitsFilter:R,findSpecialties:L,selectedFilters:U,handleCleanSelectedFilters:$,valueFilter:F,setValueFilter:V,specialties:z}=_(Tt,(e=>e)),H=async()=>{m(!0);const e=await(async()=>{const e={error:!1,errorStatus:null,message:"",data:{}};try{const t=await Ne.get("specialists/public/units",{params:{medical_indicator:1,hasSchedulingContact:1}});return e.data=t.data,e}catch(t){return e.error=!0,console.error(t),e}})();e.error&&u("Erro ao consultar unidades para filtro"),e.error||R(e.data.map((e=>{const t=e.unit_name.toLowerCase();return{id:e.unit_id,name:t.replace(/(^\w{1})|(\s+\w{1})/g,(e=>e.toUpperCase()))}}))),m(!1)},B=async(e,t)=>{m(!0),l([e]);const{units:i,expertise:n,medicalField:a}=t,r={specialty:e.id,medical_indicator:1,...i.length>0?{units:i.join(",")}:{},...n.length>0?{area_expertise:n[0]}:{},...a.length>0?{medical_field:a[0]}:{}},o=await Ml(r);o.error&&u("Erro ao consultar especialistas"),o.error||(T(o.data),s(!1)),m(!1)},G=async({type:e,item:t,inputText:i,filters:n})=>{m(!0),s(!1);const a={SPECIALTY:async()=>{const e=t;let a=n;(null==N?void 0:N.id)!==e.id&&(a={expertise:[],medicalField:[],units:[]},$()),await B(e,null!=a?a:U),P(e),V(i),j(t.id)},SPECIALIST:async()=>{s(!0),I(t),E(O.SPECIALIST_DETAILS.id,{previousPage:!0}),V(i)}};await a[e](),m(!1)},j=async e=>{const t=await(async e=>{const t={error:!1,errorStatus:null,message:"",data:{}};try{const i=await De.get(`validate-specialties/${e}`);return t.data=i.data,t}catch(e){return t.error=!0,console.error(e),t}})(e);if(t.error)p.error("Não foi possível buscar área de atuação.");else{const e=[],i=[];t.data.area_expertise.forEach((t=>{var i,n,a,r;const o=e.find((({id:e})=>{var i;return e===(null===(i=t.area_expertise)||void 0===i?void 0:i.id)}));o||e.push({id:null!==(n=null===(i=null==t?void 0:t.area_expertise)||void 0===i?void 0:i.id)&&void 0!==n?n:"",name:null!==(r=null===(a=null==t?void 0:t.area_expertise)||void 0===a?void 0:a.name)&&void 0!==r?r:""})})),t.data.medical_field.forEach((e=>{var t,n,a,r;const o=i.find((({id:t})=>{var i;return t===(null===(i=e.medical_field)||void 0===i?void 0:i.id)}));o||i.push({id:null!==(n=null===(t=null==e?void 0:e.medical_field)||void 0===t?void 0:t.id)&&void 0!==n?n:"",name:null!==(r=null===(a=null==e?void 0:e.medical_field)||void 0===a?void 0:a.name)&&void 0!==r?r:""})})),x(e),w(i)}};n.useEffect((()=>{D.length||H(),z.length||(async()=>{m(!0);const e=await Dl();if(e.error&&p.error("Não foi possível buscar as especialidades."),!e.error){const t=e.data.sort(((e,t)=>e.name.localeCompare(t.name)));M(t),l(t)}m(!1)})(),F.length?(l(L(F)),s(!0)):l(z),N||$(),r(null),I(void 0)}),[]);return t(po,{childrenFooter:k&&k.length>0&&e(i,{children:e(pi,{title:"Continuar",disabled:!a,onClick:()=>G({type:"SPECIALIST",item:a,inputText:F})})}),standardSpacing:d,children:[e(ou,{children:e(lu,{children:d?e($c,{fetchSpecialists:e=>{l(L(e)),e.length<=2&&T([]),e.length>2&&(async e=>{var t;m(!0),P(void 0);const i={};e.length>2&&(i.name=e);const n=await Ml(i);n.error&&(console.error(n.message),u("Erro ao buscar especialista")),n.error||((null===(t=null==n?void 0:n.data)||void 0===t?void 0:t.length)>0?T(n.data):(u("Não encontramos nenhum especialista."),T([]))),m(!1)})(e)},handleClickResult:G,handleSelectSpecialist:I,handleClear:()=>{l(z),V(""),T([]),r(null),P(void 0),I(void 0)},loading:g,selectedSpecialist:C,initialValue:F,specialistList:k||[],specialtyList:o,changeContext:()=>{s(!d)},standardSpacing:!0,rounded:!0,handleClearIcon:()=>{l(z),T([])}}):t(i,{children:[e(en,{title:(null==k?void 0:k.length)?"Voltar":"Busque por médicos e especialidades",goBack:()=>{k&&k.length>0?s(!0):E(O.SERVICE_LIST.id)}}),e(du,{children:e($c,{handleClickResult:G,handleSelectSpecialist:I,handleClear:()=>(T([]),void I(void 0)),loading:g,selectedSpecialist:C,placeholder:null==N?void 0:N.name,standardSpacing:!1,changeContext:()=>{s(!d)},rounded:!0,initialValue:F,clarIcon:!1})}),N&&t(su,{isSpacedBetween:!0,isAlignedCenter:!0,hasMargin:!0,children:[e(cu,{children:"Resultados"}),e(ru,{onResetFilter:()=>{$(),G({type:"SPECIALTY",item:N,inputText:F,filters:{expertise:[],medicalField:[],units:[]}})},onFilterPress:()=>b(!0),filtersCounter:U})]}),e(Fc,{specialistList:k||[],specialty:null==N?void 0:N.name,selectedSpecialist:a,handleSelectSpecialist:e=>{r(e),I(e)}}),(!k||0===(null==k?void 0:k.length))&&N&&(U.expertise.length>0||U.medicalField.length>0||U.units.length>0)&&!h&&t(uu,{children:[e("img",{src:"https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warning.svg"}),e("p",{children:"Não encontramos resultados para os filtros aplicados"})]})]})})}),e(Zc,{visible:v,units:D,areaExpertises:y,medicalFields:S,onClose:()=>b(!1),onApply:(e,t=!1)=>{b(t),r(null),T([]),N&&B(N,e)}}),e(nn,{loading:h})]})}),{})},hu=m.div`
  ${({withoutPaddingHeader:e})=>v`
    width: 100%;
    max-height: 100vh;
    padding-top: ${e?"0":"72px"};

    @media (min-width: 900px) {
      width: 100%;
      margin: 0 auto;
      padding-top: ${e?"0":"72px"};
    }
  `}
`,mu=m.main`
  ${({withoutPaddingHeader:e})=>v`
    height: ${e?"var(--height-full)":"var(--height-body-without-header)"};
  `}
`,gu=({visible:a,routerTo:r,patient:o,onClose:l,unit:d,authToken:s,patientToken:c,eligibility:u})=>{const p=_(A,(e=>e)),{setEligibilityPlans:h}=_(ve,(e=>e)),{scheduleItems:m}=_(he,(e=>e)),{isSchedulerOpen:g,setIsSchedulerOpen:f,isModalCloseOpen:v,setModalCloseOpen:b,setSelectedUnit:y,clearData:x}=_(Ct,(e=>e)),{selectItemToSchedule:S,setLogged:w}=_(Le,(e=>e)),{addPatientList:E,clearPatientList:k,setPatientSelected:T}=_(_e,(e=>e)),{goTo:I}=_(A,(e=>e)),C={PRODUCT:()=>{S("PRODUCT_ENV"),I(O.RESOURCE_DETAILS.id)},SERVICE:()=>{S("SERVICE_ENV"),I(O.RESOURCE_DETAILS.id)},UNIT:()=>{y(d),I(O.UNIT_AUXILIARY_INFO.id)},SPECIALIST:()=>{y(d),I(O.SPECIALIST_LIST.id)},CONSULTAPPOINTMENT:()=>{I(O.CONSULTAPPOINTMENT.id)},DEFAULT:()=>{I(O.SERVICE_LIST.id)}};n.useEffect((()=>{a&&(C[r||"DEFAULT"](),f(a)),s&&c&&(ji(Me,"x-access-token",`Bearer ${s}`),ji(Me,"x-access-patient-token",`Bearer ${c}`),ji(De,"x-access-token",`Bearer ${s}`),ji(De,"x-access-patient-token",`Bearer ${c}`))}),[a]),n.useEffect((()=>{o?(E(o),T(o)):k(),o&&s&&w(!0)}),[o]),n.useEffect((()=>{u&&h([u])}),[u]),n.useEffect((()=>{!1===g&&P()}),[g]);const P=()=>{var e,t,i;qi({event:"agendamento-einstein",categoria:(null===(t=null===(e=m[0])||void 0===e?void 0:e.productName)||void 0===t?void 0:t.includes("gripe"))?"Agendar-Vacina":"Agendar-Cuidado",acao:"abandonar-agendamento",rotulo:(null===(i=R(p.route||0))||void 0===i?void 0:i.title)||""}),x(),b&&b(!1),f(!1),l&&l()},N=p.route!==O.CONCLUSION.id&&p.route!==O.CONSULTAPPOINTMENT.id&&p.route!==O.UNIT_AUXILIARY_INFO.id,M=()=>{N?b&&b(!0):P()};let D=e(i,{});const L=R(p.route||0);return L&&(D=e(i,{children:pu[L.id]})),e(Ri,{onClose:M,visible:g,isFull:!0,isMainNavigation:p.route===O.CONCLUSION.id,conclusion:p.route===O.CONCLUSION.id,children:e(hu,{withoutPaddingHeader:!N,children:t(Gi,{children:[N&&e(ri,{onClose:M}),t(mu,{withoutPaddingHeader:!N,children:[D,e(Ci,{visible:!!v,onConfirmClose:P,onCancelClose:()=>b&&b(!1)})]})]})})})},fu=t=>e(Nt,{children:e(gu,{...t})});var vu=Object.freeze({__proto__:null,Button:pi,LoadingOverlay:nn,Sidebar:Ri});export{fu as SchedulerItem,vu as Ui};
//# sourceMappingURL=index.js.map
